// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7XKBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FUNNEL_VERSION", ()=>FUNNEL_VERSION);
parcelHelpers.export(exports, "onboardingVariant", ()=>onboardingVariant);
var _posthogJs = require("posthog-js");
var _posthogJsDefault = parcelHelpers.interopDefault(_posthogJs);
// --- Funnel versioning -------------------------------------------------------
// `funnel_version` is stamped on EVERY event (including the automatic landing-page
// $pageview), so any funnel can start at the landing page and be broken down by it.
//
// It is built from two pieces:
//   * FUNNEL_BASE -- bump this whenever you ship a STRUCTURAL funnel change
//     (added/removed/reordered steps, redesigned page, new interstitial, new pricing...).
//   * a sticky funnel arm chosen once on the visitor's FIRST page load (the coin-flip
//     that used to live in eeo.js). Each arm reads as its own funnel_version, e.g.
//     "2026-06-control" / "2026-06-facts" / "2026-06-facts_early", so you compare them
//     like any other version.
//
// The variant is persisted per-browser (localStorage) so a visitor stays in one funnel
// for their whole journey and across sessions. eeo.js imports `onboardingVariant` to
// decide which onboarding page to show.
const FUNNEL_BASE = '2026-06';
const VARIANT_KEY = 'fapply_onboarding_variant';
// Three-way split (~1/3 each):
//   * control     -- no progress-facts interstitial.
//   * facts       -- progress_facts.html shown late (at eeo, before the job_assistant carousel).
//   * facts_early -- progress_facts.html shown immediately after "Get Started" on index.html,
//                    before registration.
const VARIANTS = [
    'control',
    'facts',
    'facts_early'
];
function resolveOnboardingVariant() {
    let variant = null;
    try {
        variant = localStorage.getItem(VARIANT_KEY);
    } catch (e) {}
    if (!VARIANTS.includes(variant)) {
        const r = Math.random();
        // variant = r < 1 / 3 ? 'control' : r < 2 / 3 ? 'facts' : 'facts_early';
        variant = r < 0.5 ? 'facts' : 'facts_early';
        try {
            localStorage.setItem(VARIANT_KEY, variant);
        } catch (e) {}
        return {
            variant,
            isNew: true
        };
    }
    return {
        variant,
        isNew: false
    };
}
const { variant: onboardingVariant, isNew: variantIsNew } = resolveOnboardingVariant();
const FUNNEL_VERSION = `${FUNNEL_BASE}-${onboardingVariant}`;
(0, _posthogJsDefault.default).init('phc_zIGV5Gq0B1q7gD9rUJvt1xi90Y4XmXxzhC5GnTVb352', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    loaded: (ph)=>{
        // Registered inside `loaded` so both land on the automatic initial $pageview.
        ph.register({
            funnel_version: FUNNEL_VERSION,
            onboarding_variant: onboardingVariant
        });
        if (variantIsNew) ph.capture('onboarding_variant_assigned', {
            variant: onboardingVariant,
            funnel_version: FUNNEL_VERSION,
            source: 'index_split'
        });
    }
});
exports.default = (0, _posthogJsDefault.default);

},{"posthog-js":"y4xLV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"y4xLV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Compression", ()=>Ss);
parcelHelpers.export(exports, "DEFAULT_PRODUCT_TOUR_APPEARANCE", ()=>ia);
parcelHelpers.export(exports, "DisplaySurveyType", ()=>io);
parcelHelpers.export(exports, "PostHog", ()=>Zo);
parcelHelpers.export(exports, "SurveyEventName", ()=>Zn);
parcelHelpers.export(exports, "SurveyEventProperties", ()=>to);
parcelHelpers.export(exports, "SurveyEventType", ()=>Wn);
parcelHelpers.export(exports, "SurveyPosition", ()=>Vn);
parcelHelpers.export(exports, "SurveyQuestionBranchingType", ()=>Xn);
parcelHelpers.export(exports, "SurveyQuestionType", ()=>Yn);
parcelHelpers.export(exports, "SurveySchedule", ()=>Qn);
parcelHelpers.export(exports, "SurveyTabPosition", ()=>Jn);
parcelHelpers.export(exports, "SurveyType", ()=>Kn);
parcelHelpers.export(exports, "SurveyWidgetType", ()=>Gn);
parcelHelpers.export(exports, "default", ()=>ea);
parcelHelpers.export(exports, "posthog", ()=>ea);
parcelHelpers.export(exports, "severityLevels", ()=>$s);
var t = "undefined" != typeof window ? window : void 0, i = "undefined" != typeof globalThis ? globalThis : t;
"undefined" == typeof self && (i.self = i), "undefined" == typeof File && (i.File = function() {});
var e = Array.prototype, r = e.forEach, s = e.indexOf, n = null == i ? void 0 : i.navigator, o = null == i ? void 0 : i.document, a = null == i ? void 0 : i.location, l = null == i ? void 0 : i.fetch, u = null != i && i.XMLHttpRequest && "withCredentials" in new i.XMLHttpRequest ? i.XMLHttpRequest : void 0, h = null == i ? void 0 : i.AbortController, d = null == n ? void 0 : n.userAgent, v = null != t ? t : {}, c = {
    DEBUG: !1,
    LIB_VERSION: "1.347.2"
};
function f(t, i, e, r, s, n, o) {
    try {
        var a = t[n](o), l = a.value;
    } catch (t) {
        return void e(t);
    }
    a.done ? i(l) : Promise.resolve(l).then(r, s);
}
function p(t) {
    return function() {
        var i = this, e = arguments;
        return new Promise(function(r, s) {
            var n = t.apply(i, e);
            function o(t) {
                f(n, r, s, o, a, "next", t);
            }
            function a(t) {
                f(n, r, s, o, a, "throw", t);
            }
            o(void 0);
        });
    };
}
function g() {
    return g = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var e = arguments[i];
            for(var r in e)({}).hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, g.apply(null, arguments);
}
function _(t, i) {
    if (null == t) return {};
    var e = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== i.indexOf(r)) continue;
        e[r] = t[r];
    }
    return e;
}
var m = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
], b = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], y = function(t, i) {
    if (void 0 === i && (i = []), !t) return !1;
    var e = t.toLowerCase();
    return b.concat(i).some((t)=>{
        var i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
};
function w(t, i) {
    return -1 !== t.indexOf(i);
}
var x = function(t) {
    return t.trim();
}, E = function(t) {
    return t.replace(/^\$/, "");
};
var S = Array.isArray, k = Object.prototype, P = k.hasOwnProperty, T = k.toString, I = S || function(t) {
    return "[object Array]" === T.call(t);
}, C = (t)=>"function" == typeof t, R = (t)=>t === Object(t) && !I(t), F = (t)=>{
    if (R(t)) {
        for(var i in t)if (P.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, O = (t)=>void 0 === t, M = (t)=>"[object String]" == T.call(t), A = (t)=>M(t) && 0 === t.trim().length, j = (t)=>null === t, D = (t)=>O(t) || j(t), L = (t)=>"[object Number]" == T.call(t) && t == t, N = (t)=>L(t) && t > 0, U = (t)=>"[object Boolean]" === T.call(t), z = (t)=>t instanceof FormData, H = (t)=>w(m, t);
function B(t) {
    return null === t || "object" != typeof t;
}
function q(t, i) {
    return Object.prototype.toString.call(t) === "[object " + i + "]";
}
function W(t) {
    return !O(Event) && function(t, i) {
        try {
            return t instanceof i;
        } catch (t) {
            return !1;
        }
    }(t, Event);
}
var G = [
    !0,
    "true",
    1,
    "1",
    "yes"
], V = (t)=>w(G, t), J = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function K(t, i, e, r, s) {
    return i > e && (r.warn("min cannot be greater than max."), i = e), L(t) ? t > e ? (r.warn(" cannot be  greater than max: " + e + ". Using max value instead."), e) : t < i ? (r.warn(" cannot be less than min: " + i + ". Using min value instead."), i) : t : (r.warn(" must be a number. using max or fallback. max: " + e + ", fallback: " + s), K(s || e, i, e, r));
}
class Y {
    constructor(t){
        this.t = {}, this.i = t.i, this.o = K(t.bucketSize, 0, 100, t.h), this.m = K(t.refillRate, 0, this.o, t.h), this.$ = K(t.refillInterval, 0, 864e5, t.h);
    }
    S(t, i) {
        var e = i - t.lastAccess, r = Math.floor(e / this.$);
        if (r > 0) {
            var s = r * this.m;
            t.tokens = Math.min(t.tokens + s, this.o), t.lastAccess = t.lastAccess + r * this.$;
        }
    }
    consumeRateLimit(t) {
        var i, e = Date.now(), r = String(t), s = this.t[r];
        return s ? this.S(s, e) : (s = {
            tokens: this.o,
            lastAccess: e
        }, this.t[r] = s), 0 === s.tokens || (s.tokens--, 0 === s.tokens && (null == (i = this.i) || i.call(this, t)), 0 === s.tokens);
    }
    stop() {
        this.t = {};
    }
}
var X = "Mobile", Q = "iOS", Z = "Android", tt = "Tablet", it = Z + " " + tt, et = "iPad", rt = "Apple", st = rt + " Watch", nt = "Safari", ot = "BlackBerry", at = "Samsung", lt = at + "Browser", ut = at + " Internet", ht = "Chrome", dt = ht + " OS", vt = ht + " " + Q, ct = "Internet Explorer", ft = ct + " " + X, pt = "Opera", gt = pt + " Mini", _t = "Edge", mt = "Microsoft " + _t, bt = "Firefox", yt = bt + " " + Q, wt = "Nintendo", xt = "PlayStation", Et = "Xbox", $t = Z + " " + X, St = X + " " + nt, kt = "Windows", Pt = kt + " Phone", Tt = "Nokia", It = "Ouya", Ct = "Generic", Rt = Ct + " " + X.toLowerCase(), Ft = Ct + " " + tt.toLowerCase(), Ot = "Konqueror", Mt = "(\\d+(\\.\\d+)?)", At = new RegExp("Version/" + Mt), jt = new RegExp(Et, "i"), Dt = new RegExp(xt + " \\w+", "i"), Lt = new RegExp(wt + " \\w+", "i"), Nt = new RegExp(ot + "|PlayBook|BB10", "i"), Ut = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var zt, Ht, Bt, qt = (t, i)=>i && w(i, rt) || function(t) {
        return w(t, nt) && !w(t, ht) && !w(t, Z);
    }(t), Wt = function(t, i) {
    return i = i || "", w(t, " OPR/") && w(t, "Mini") ? gt : w(t, " OPR/") ? pt : Nt.test(t) ? ot : w(t, "IE" + X) || w(t, "WPDesktop") ? ft : w(t, lt) ? ut : w(t, _t) || w(t, "Edg/") ? mt : w(t, "FBIOS") ? "Facebook " + X : w(t, "UCWEB") || w(t, "UCBrowser") ? "UC Browser" : w(t, "CriOS") ? vt : w(t, "CrMo") || w(t, ht) ? ht : w(t, Z) && w(t, nt) ? $t : w(t, "FxiOS") ? yt : w(t.toLowerCase(), Ot.toLowerCase()) ? Ot : qt(t, i) ? w(t, X) ? St : nt : w(t, bt) ? bt : w(t, "MSIE") || w(t, "Trident/") ? ct : w(t, "Gecko") ? bt : "";
}, Gt = {
    [ft]: [
        new RegExp("rv:" + Mt)
    ],
    [mt]: [
        new RegExp(_t + "?\\/" + Mt)
    ],
    [ht]: [
        new RegExp("(" + ht + "|CrMo)\\/" + Mt)
    ],
    [vt]: [
        new RegExp("CriOS\\/" + Mt)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + Mt)
    ],
    [nt]: [
        At
    ],
    [St]: [
        At
    ],
    [pt]: [
        new RegExp("(Opera|OPR)\\/" + Mt)
    ],
    [bt]: [
        new RegExp(bt + "\\/" + Mt)
    ],
    [yt]: [
        new RegExp("FxiOS\\/" + Mt)
    ],
    [Ot]: [
        new RegExp("Konqueror[:/]?" + Mt, "i")
    ],
    [ot]: [
        new RegExp(ot + " " + Mt),
        At
    ],
    [$t]: [
        new RegExp("android\\s" + Mt, "i")
    ],
    [ut]: [
        new RegExp(lt + "\\/" + Mt)
    ],
    [ct]: [
        new RegExp("(rv:|MSIE )" + Mt)
    ],
    Mozilla: [
        new RegExp("rv:" + Mt)
    ]
}, Vt = function(t, i) {
    var e = Wt(t, i), r = Gt[e];
    if (O(r)) return null;
    for(var s = 0; s < r.length; s++){
        var n = r[s], o = t.match(n);
        if (o) return parseFloat(o[o.length - 2]);
    }
    return null;
}, Jt = [
    [
        new RegExp(Et + "; " + Et + " (.*?)[);]", "i"),
        (t)=>[
                Et,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp(wt, "i"),
        [
            wt,
            ""
        ]
    ],
    [
        new RegExp(xt, "i"),
        [
            xt,
            ""
        ]
    ],
    [
        Nt,
        [
            ot,
            ""
        ]
    ],
    [
        new RegExp(kt, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                Pt,
                ""
            ];
            if (new RegExp(X).test(i) && !/IEMobile\b/.test(i)) return [
                kt + " " + X,
                ""
            ];
            var e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                var r = e[1], s = Ut[r] || "";
                return /arm/i.test(i) && (s = "RT"), [
                    kt,
                    s
                ];
            }
            return [
                kt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>{
            if (t && t[3]) {
                var i = [
                    t[3],
                    t[4],
                    t[5] || "0"
                ];
                return [
                    Q,
                    i.join(".")
                ];
            }
            return [
                Q,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var i = "";
            return t && t.length >= 3 && (i = O(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(" + Z + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + Z + ")", "i"),
        (t)=>{
            if (t && t[2]) {
                var i = [
                    t[2],
                    t[3],
                    t[4] || "0"
                ];
                return [
                    Z,
                    i.join(".")
                ];
            }
            return [
                Z,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var i = [
                "Mac OS X",
                ""
            ];
            if (t && t[1]) {
                var e = [
                    t[1],
                    t[2],
                    t[3] || "0"
                ];
                i[1] = e.join(".");
            }
            return i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            dt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], Kt = function(t) {
    return Lt.test(t) ? wt : Dt.test(t) ? xt : jt.test(t) ? Et : new RegExp(It, "i").test(t) ? It : new RegExp("(" + Pt + "|WPDesktop)", "i").test(t) ? Pt : /iPad/.test(t) ? et : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? st : Nt.test(t) ? ot : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp(Tt, "i").test(t) ? Tt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp(X).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? Z : it : new RegExp("(pda|" + X + ")", "i").test(t) ? Rt : new RegExp(tt, "i").test(t) && !new RegExp(tt + " pc", "i").test(t) ? Ft : "";
}, Yt = (t)=>t instanceof Error;
function Xt(t) {
    var i = globalThis._posthogChunkIds;
    if (i) {
        var e = Object.keys(i);
        return Bt && e.length === Ht || (Ht = e.length, Bt = e.reduce((e, r)=>{
            zt || (zt = {});
            var s = zt[r];
            if (s) e[s[0]] = s[1];
            else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                var a = n[o], l = null == a ? void 0 : a.filename, u = i[r];
                if (l && u) {
                    e[l] = u, zt[r] = [
                        l,
                        u
                    ];
                    break;
                }
            }
            return e;
        }, {})), Bt;
    }
}
class Qt {
    constructor(t, i, e){
        void 0 === e && (e = []), this.coercers = t, this.stackParser = i, this.modifiers = e;
    }
    buildFromUnknown(t, i) {
        void 0 === i && (i = {});
        var e = i && i.mechanism || {
            handled: !0,
            type: "generic"
        }, r = this.buildCoercingContext(e, i, 0).apply(t), s = this.buildParsingContext(i), n = this.parseStacktrace(r, s);
        return {
            $exception_list: this.convertToExceptionList(n, e),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var i = this;
        return p(function*() {
            for (var e of t)e.stacktrace && e.stacktrace.frames && I(e.stacktrace.frames) && (e.stacktrace.frames = yield i.applyModifiers(e.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var i;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null == (i = t.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, i) {
        var e, r;
        return null != t.cause && (e = this.parseStacktrace(t.cause, i)), "" != t.stack && null != t.stack && (r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? i.skipFirstLines : 0), i.chunkIdMap)), g({}, t, {
            cause: e,
            stack: r
        });
    }
    applyChunkIds(t, i) {
        return t.map((t)=>(t.filename && i && (t.chunk_id = i[t.filename]), t));
    }
    applyCoercers(t, i) {
        for (var e of this.coercers)if (e.match(t)) return e.coerce(t, i);
        return this.coerceFallback(i);
    }
    applyModifiers(t) {
        var i = this;
        return p(function*() {
            var e = t;
            for (var r of i.modifiers)e = yield r(e);
            return e;
        })();
    }
    convertToExceptionList(t, i) {
        var e, r, s, n = {
            type: t.type,
            value: t.value,
            mechanism: {
                type: null !== (e = i.type) && void 0 !== e ? e : "generic",
                handled: null === (r = i.handled) || void 0 === r || r,
                synthetic: null !== (s = t.synthetic) && void 0 !== s && s
            }
        };
        t.stack && (n.stacktrace = {
            type: "raw",
            frames: t.stack
        });
        var o = [
            n
        ];
        return null != t.cause && o.push(...this.convertToExceptionList(t.cause, g({}, i, {
            handled: !0
        }))), o;
    }
    buildParsingContext(t) {
        var i;
        return {
            chunkIdMap: Xt(this.stackParser),
            skipFirstLines: null !== (i = t.skipFirstLines) && void 0 !== i ? i : 1
        };
    }
    buildCoercingContext(t, i, e) {
        void 0 === e && (e = 0);
        var r = (e, r)=>{
            if (r <= 4) {
                var s = this.buildCoercingContext(t, i, r);
                return this.applyCoercers(e, s);
            }
        };
        return g({}, i, {
            syntheticException: 0 == e ? i.syntheticException : void 0,
            mechanism: t,
            apply: (t)=>r(t, e),
            next: (t)=>r(t, e + 1)
        });
    }
}
var Zt = "?";
function ti(t, i, e, r, s) {
    var n = {
        platform: t,
        filename: i,
        function: "<anonymous>" === e ? Zt : e,
        in_app: !0
    };
    return O(r) || (n.lineno = r), O(s) || (n.colno = s), n;
}
var ii = (t, i)=>{
    var e = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return e || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : Zt,
        e ? "safari-extension:" + i : "safari-web-extension:" + i
    ] : [
        t,
        i
    ];
}, ei = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, ri = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, si = /\((\S*)(?::(\d+))(?::(\d+))\)/, ni = (t, i)=>{
    var e = ei.exec(t);
    if (e) {
        var [, r, s, n] = e;
        return ti(i, r, Zt, +s, +n);
    }
    var o = ri.exec(t);
    if (o) {
        if (o[2] && 0 === o[2].indexOf("eval")) {
            var a = si.exec(o[2]);
            a && (o[2] = a[1], o[3] = a[2], o[4] = a[3]);
        }
        var [l, u] = ii(o[1] || Zt, o[2]);
        return ti(i, u, l, o[3] ? +o[3] : void 0, o[4] ? +o[4] : void 0);
    }
}, oi = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, ai = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, li = (t, i)=>{
    var e = oi.exec(t);
    if (e) {
        if (e[3] && e[3].indexOf(" > eval") > -1) {
            var r = ai.exec(e[3]);
            r && (e[1] = e[1] || "eval", e[3] = r[1], e[4] = r[2], e[5] = "");
        }
        var s = e[3], n = e[1] || Zt;
        return [n, s] = ii(n, s), ti(i, s, n, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
    }
}, ui = /\(error: (.*)\)/, hi = 50;
function di() {
    return function(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        return function(i, r) {
            void 0 === r && (r = 0);
            for(var s = [], n = i.split("\n"), o = r; o < n.length; o++){
                var a = n[o];
                if (!(a.length > 1024)) {
                    var l = ui.test(a) ? a.replace(ui, "$1") : a;
                    if (!l.match(/\S*Error: /)) {
                        for (var u of e){
                            var h = u(l, t);
                            if (h) {
                                s.push(h);
                                break;
                            }
                        }
                        if (s.length >= hi) break;
                    }
                }
            }
            return function(t) {
                if (!t.length) return [];
                var i = Array.from(t);
                return i.reverse(), i.slice(0, hi).map((t)=>{
                    var e;
                    return g({}, t, {
                        filename: t.filename || (e = i, e[e.length - 1] || {}).filename,
                        function: t.function || Zt
                    });
                });
            }(s);
        };
    }("web:javascript", ni, li);
}
class vi {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, i) {
        var e = M(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: e ? t.stack : void 0,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        var i = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? i + ": " + t.message : i;
    }
    isDOMException(t) {
        return q(t, "DOMException");
    }
    isDOMError(t) {
        return q(t, "DOMError");
    }
}
class ci {
    match(t) {
        return ((t)=>t instanceof Error)(t);
    }
    coerce(t, i) {
        return {
            type: this.getType(t),
            value: this.getMessage(t, i),
            stack: this.getStack(t),
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, i) {
        var e = t.message;
        return e.error && "string" == typeof e.error.message ? String(e.error.message) : String(e);
    }
    getStack(t) {
        return t.stacktrace || t.stack || void 0;
    }
}
class fi {
    constructor(){}
    match(t) {
        return q(t, "ErrorEvent") && null != t.error;
    }
    coerce(t, i) {
        var e, r = i.apply(t.error);
        return r || {
            type: "ErrorEvent",
            value: t.message,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
var pi = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class gi {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, i) {
        var e, [r, s] = this.getInfos(t);
        return {
            type: null != r ? r : "Error",
            value: null != s ? s : t,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        var i = "Error", e = t, r = t.match(pi);
        return r && (i = r[1], e = r[2]), [
            i,
            e
        ];
    }
}
var _i = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function mi(t, i) {
    void 0 === i && (i = 40);
    var e = Object.keys(t);
    if (e.sort(), !e.length) return "[object has no keys]";
    for(var r = e.length; r > 0; r--){
        var s = e.slice(0, r).join(", ");
        if (!(s.length > i)) return r === e.length || s.length <= i ? s : s.slice(0, i) + "...";
    }
    return "";
}
class bi {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, i) {
        var e, r = this.getErrorPropertyFromObject(t);
        return r ? i.apply(r) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        return W(t) ? t.constructor.name : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            var i = "'" + t.name + "' captured as exception";
            return "message" in t && "string" == typeof t.message && (i += " with message: '" + t.message + "'"), i;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        var e = this.getObjectClassName(t);
        return (e && "Object" !== e ? "'" + e + "'" : "Object") + " captured as exception with keys: " + mi(t);
    }
    isSeverityLevel(t) {
        return M(t) && !A(t) && _i.indexOf(t) >= 0;
    }
    getErrorPropertyFromObject(t) {
        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i)) {
            var e = t[i];
            if (Yt(e)) return e;
        }
    }
    getObjectClassName(t) {
        try {
            var i = Object.getPrototypeOf(t);
            return i ? i.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}
class yi {
    match(t) {
        return W(t);
    }
    coerce(t, i) {
        var e, r = t.constructor.name;
        return {
            type: r,
            value: r + " captured as exception with keys: " + mi(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class wi {
    match(t) {
        return B(t);
    }
    coerce(t, i) {
        var e;
        return {
            type: "Error",
            value: "Primitive value captured as exception: " + String(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class xi {
    match(t) {
        return q(t, "PromiseRejectionEvent");
    }
    coerce(t, i) {
        var e, r = this.getUnhandledRejectionReason(t);
        return B(r) ? {
            type: "UnhandledRejection",
            value: "Non-Error promise rejection captured with value: " + String(r),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        } : i.apply(r);
    }
    getUnhandledRejectionReason(t) {
        if (B(t)) return t;
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
}
var Ei = function(i, e) {
    var { debugEnabled: r } = void 0 === e ? {} : e, s = {
        k: function(e) {
            if (t && (c.DEBUG || v.POSTHOG_DEBUG || r) && !O(t.console) && t.console) {
                for(var s = ("__rrweb_original__" in t.console[e]) ? t.console[e].__rrweb_original__ : t.console[e], n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)o[a - 1] = arguments[a];
                s(i, ...o);
            }
        },
        info: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("log", ...i);
        },
        warn: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("warn", ...i);
        },
        error: function() {
            for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
            s.k("error", ...i);
        },
        critical: function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            console.error(i, ...e);
        },
        uninitializedWarning: (t)=>{
            s.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t, e)=>Ei(i + " " + t, e)
    };
    return s;
}, $i = Ei("[PostHog.js]"), Si = $i.createLogger, ki = Si("[ExternalScriptsLoader]"), Pi = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return ki.warn(i + " was requested but loading of external scripts is disabled."), e("Loading of external scripts is disabled");
    var r = null == o ? void 0 : o.querySelectorAll("script");
    if (r) {
        for(var s, n = function() {
            if (r[a].src === i) {
                var t = r[a];
                return t.__posthog_loading_callback_fired ? {
                    v: e()
                } : (t.addEventListener("load", (i)=>{
                    t.__posthog_loading_callback_fired = !0, e(void 0, i);
                }), t.onerror = (t)=>e(t), {
                    v: void 0
                });
            }
        }, a = 0; a < r.length; a++)if (s = n()) return s.v;
    }
    var l = ()=>{
        if (!o) return e("document not found");
        var r = o.createElement("script");
        if (r.type = "text/javascript", r.crossOrigin = "anonymous", r.src = i, r.onload = (t)=>{
            r.__posthog_loading_callback_fired = !0, e(void 0, t);
        }, r.onerror = (t)=>e(t), t.config.prepare_external_dependency_script && (r = t.config.prepare_external_dependency_script(r)), !r) return e("prepare_external_dependency_script returned null");
        if ("head" === t.config.external_scripts_inject_target) o.head.appendChild(r);
        else {
            var s, n = o.querySelectorAll("body > script");
            if (n.length > 0) null == (s = n[0].parentNode) || s.insertBefore(r, n[0]);
            else o.body.appendChild(r);
        }
    };
    null != o && o.body ? l() : null == o || o.addEventListener("DOMContentLoaded", l);
};
v.__PosthogExtensions__ = v.__PosthogExtensions__ || {}, v.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    var r = "/static/" + i + ".js?v=" + t.version;
    if ("remote-config" === i && (r = "/array/" + t.config.token + "/config.js"), "toolbar" === i) {
        var s = 3e5;
        r = r + "&t=" + Math.floor(Date.now() / s) * s;
    }
    var n = t.requestRouter.endpointFor("assets", r);
    Pi(t, n, e);
}, v.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    var r = t.requestRouter.endpointFor("api", i);
    Pi(t, r, e);
};
var Ti = {};
function Ii(t, i, e) {
    if (I(t)) {
        if (r && t.forEach === r) t.forEach(i, e);
        else if ("length" in t && t.length === +t.length) {
            for(var s = 0, n = t.length; s < n; s++)if (s in t && i.call(e, t[s], s) === Ti) return;
        }
    }
}
function Ci(t, i, e) {
    if (!D(t)) {
        if (I(t)) return Ii(t, i, e);
        if (z(t)) {
            for (var r of t.entries())if (i.call(e, r[1], r[0]) === Ti) return;
        } else for(var s in t)if (P.call(t, s) && i.call(e, t[s], s) === Ti) return;
    }
}
var Ri = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return Ii(e, function(i) {
        for(var e in i)void 0 !== i[e] && (t[e] = i[e]);
    }), t;
}, Fi = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return Ii(e, function(i) {
        Ii(i, function(i) {
            t.push(i);
        });
    }), t;
};
function Oi(t) {
    for(var i = Object.keys(t), e = i.length, r = new Array(e); e--;)r[e] = [
        i[e],
        t[i[e]]
    ];
    return r;
}
var Mi = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, Ai = function(t) {
    return function() {
        try {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            return t.apply(this, e);
        } catch (t) {
            $i.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $i.critical(t);
        }
    };
}, ji = function(t) {
    var i = {};
    return Ci(t, function(t, e) {
        (M(t) && t.length > 0 || L(t)) && (i[e] = t);
    }), i;
};
function Di(t, i) {
    var e, r, s;
    return e = t, r = (t)=>M(t) && !j(i) ? t.slice(0, i) : t, s = new Set, function t(i, e) {
        var n;
        return i !== Object(i) ? r ? r(i, e) : i : s.has(i) ? void 0 : (s.add(i), I(i) ? (n = [], Ii(i, (i)=>{
            n.push(t(i));
        })) : (n = {}, Ci(i, (i, e)=>{
            s.has(i) || (n[e] = t(i, e));
        })), n);
    }(e);
}
var Li = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function Ni(t) {
    var i = null == t ? void 0 : t.hostname;
    if (!M(i)) return !1;
    var e = i.split(".").slice(-2).join(".");
    for (var r of Li)if (e === r) return !1;
    return !0;
}
function Ui(t, i) {
    for(var e = 0; e < t.length; e++)if (i(t[e])) return t[e];
}
function zi(t, i, e, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(i, e, {
        capture: s,
        passive: n
    });
}
var Hi = "$people_distinct_id", Bi = "__alias", qi = "__timers", Wi = "$autocapture_disabled_server_side", Gi = "$heatmaps_enabled_server_side", Vi = "$exception_capture_enabled_server_side", Ji = "$error_tracking_suppression_rules", Ki = "$error_tracking_capture_extension_exceptions", Yi = "$web_vitals_enabled_server_side", Xi = "$dead_clicks_enabled_server_side", Qi = "$product_tours_enabled_server_side", Zi = "$web_vitals_allowed_metrics", te = "$session_recording_remote_config", ie = "$sesid", ee = "$session_is_sampled", re = "$enabled_feature_flags", se = "$early_access_features", ne = "$feature_flag_details", oe = "$stored_person_properties", ae = "$stored_group_properties", le = "$surveys", ue = "$flag_call_reported", he = "$feature_flag_errors", de = "$user_state", ve = "$client_session_props", ce = "$capture_rate_limit", fe = "$initial_campaign_params", pe = "$initial_referrer_info", ge = "$initial_person_info", _e = "$epp", me = "__POSTHOG_TOOLBAR__", be = "$posthog_cookieless", ye = [
    Hi,
    Bi,
    "__cmpns",
    qi,
    "$session_recording_enabled_server_side",
    Gi,
    ie,
    re,
    Ji,
    de,
    se,
    ne,
    ae,
    oe,
    le,
    ue,
    he,
    ve,
    ce,
    fe,
    pe,
    _e,
    ge,
    "$conversations_widget_session_id",
    "$conversations_ticket_id",
    "$conversations_widget_state",
    "$conversations_user_traits"
];
function we(t) {
    return t instanceof Element && (t.id === me || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function xe(t) {
    return !!t && 1 === t.nodeType;
}
function Ee(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $e(t) {
    return !!t && 3 === t.nodeType;
}
function Se(t) {
    return !!t && 11 === t.nodeType;
}
function ke(t) {
    return t ? x(t).split(/\s+/) : [];
}
function Pe(i) {
    var e = null == t ? void 0 : t.location.href;
    return !!(e && i && i.some((t)=>e.match(t)));
}
function Te(t) {
    var i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return ke(i);
}
function Ie(t) {
    return D(t) ? null : x(t).split(/(\s+)/).filter((t)=>Ye(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function Ce(t) {
    var i = "";
    return He(t) && !Be(t) && t.childNodes && t.childNodes.length && Ci(t.childNodes, function(t) {
        var e;
        $e(t) && t.textContent && (i += null !== (e = Ie(t.textContent)) && void 0 !== e ? e : "");
    }), x(i);
}
function Re(t) {
    var i;
    return O(t.target) ? t.srcElement || null : null != (i = t.target) && i.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var Fe = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function Oe(t, i) {
    if (O(i)) return !0;
    var e, r = function(t) {
        if (i.some((i)=>t.matches(i))) return {
            v: !0
        };
    };
    for (var s of t)if (e = r(s)) return e.v;
    return !1;
}
function Me(t) {
    var i = t.parentNode;
    return !(!i || !xe(i)) && i;
}
var Ae = [
    "next",
    "previous",
    "prev",
    ">",
    "<"
], je = 10;
var De = [
    ".ph-no-rageclick",
    ".ph-no-capture"
];
function Le(i, e) {
    if (!t || Ne(i)) return !1;
    var r, s, n;
    U(e) ? (r = !!e && De, s = void 0) : (r = null !== (n = null == e ? void 0 : e.css_selector_ignorelist) && void 0 !== n ? n : De, s = null == e ? void 0 : e.content_ignorelist);
    if (!1 === r) return !1;
    var { targetElementList: o } = Ue(i, !1);
    return !function(t, i) {
        if (!1 === t || O(t)) return !1;
        var e;
        if (!0 === t) e = Ae;
        else {
            if (!I(t)) return !1;
            if (t.length > je) return $i.error("[PostHog] content_ignorelist array cannot exceed " + je + " items. Use css_selector_ignorelist for more complex matching."), !1;
            e = t.map((t)=>t.toLowerCase());
        }
        return i.some((t)=>{
            var { safeText: i, ariaLabel: r } = t;
            return e.some((t)=>i.includes(t) || r.includes(t));
        });
    }(s, o.map((t)=>{
        var i;
        return {
            safeText: Ce(t).toLowerCase(),
            ariaLabel: (null == (i = t.getAttribute("aria-label")) ? void 0 : i.toLowerCase().trim()) || ""
        };
    })) && !Oe(o, r);
}
var Ne = (t)=>!t || Ee(t, "html") || !xe(t), Ue = (i, e)=>{
    if (!t || Ne(i)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    for(var r = !1, s = [
        i
    ], n = i; n.parentNode && !Ee(n, "body");)if (Se(n.parentNode)) s.push(n.parentNode.host), n = n.parentNode.host;
    else {
        var o = Me(n);
        if (!o) break;
        if (e || Fe.indexOf(o.tagName.toLowerCase()) > -1) r = !0;
        else {
            var a = t.getComputedStyle(o);
            a && "pointer" === a.getPropertyValue("cursor") && (r = !0);
        }
        s.push(o), n = o;
    }
    return {
        parentIsUsefulElement: r,
        targetElementList: s
    };
};
function ze(i, e, r, s, n) {
    var o, a, l, u;
    if (void 0 === r && (r = void 0), !t || Ne(i)) return !1;
    if (null != (o = r) && o.url_allowlist && !Pe(r.url_allowlist)) return !1;
    if (null != (a = r) && a.url_ignorelist && Pe(r.url_ignorelist)) return !1;
    if (null != (l = r) && l.dom_event_allowlist) {
        var h = r.dom_event_allowlist;
        if (h && !h.some((t)=>e.type === t)) return !1;
    }
    var { parentIsUsefulElement: d, targetElementList: v } = Ue(i, s);
    if (!function(t, i) {
        var e = null == i ? void 0 : i.element_allowlist;
        if (O(e)) return !0;
        var r, s = function(t) {
            if (e.some((i)=>t.tagName.toLowerCase() === i)) return {
                v: !0
            };
        };
        for (var n of t)if (r = s(n)) return r.v;
        return !1;
    }(v, r)) return !1;
    if (!Oe(v, null == (u = r) ? void 0 : u.css_selector_allowlist)) return !1;
    var c = t.getComputedStyle(i);
    if (c && "pointer" === c.getPropertyValue("cursor") && "click" === e.type) return !0;
    var f = i.tagName.toLowerCase();
    switch(f){
        case "html":
            return !1;
        case "form":
            return (n || [
                "submit"
            ]).indexOf(e.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (n || [
                "change",
                "click"
            ]).indexOf(e.type) >= 0;
        default:
            return d ? (n || [
                "click"
            ]).indexOf(e.type) >= 0 : (n || [
                "click"
            ]).indexOf(e.type) >= 0 && (Fe.indexOf(f) > -1 || "true" === i.getAttribute("contenteditable"));
    }
}
function He(t) {
    for(var i = t; i.parentNode && !Ee(i, "body"); i = i.parentNode){
        var e = Te(i);
        if (w(e, "ph-sensitive") || w(e, "ph-no-capture")) return !1;
    }
    if (w(Te(t), "ph-include")) return !0;
    var r = t.type || "";
    if (M(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    if (M(s)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function Be(t) {
    return !!(Ee(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || Ee(t, "select") || Ee(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var qe = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", We = new RegExp("^(?:" + qe + ")$"), Ge = new RegExp(qe), Ve = "\\d{3}-?\\d{2}-?\\d{4}", Je = new RegExp("^(" + Ve + ")$"), Ke = new RegExp("(" + Ve + ")");
function Ye(t, i) {
    if (void 0 === i && (i = !0), D(t)) return !1;
    if (M(t)) {
        if (t = x(t), (i ? We : Ge).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((i ? Je : Ke).test(t)) return !1;
    }
    return !0;
}
function Xe(t) {
    var i = Ce(t);
    return Ye(i = (i + " " + Qe(t)).trim()) ? i : "";
}
function Qe(t) {
    var i = "";
    return t && t.childNodes && t.childNodes.length && Ci(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null == (e = t.tagName) ? void 0 : e.toLowerCase())) try {
            var r = Ce(t);
            i = (i + " " + r).trim(), t.childNodes && t.childNodes.length && (i = (i + " " + Qe(t)).trim());
        } catch (t) {
            $i.error("[AutoCapture]", t);
        }
    }), i;
}
function Ze(t) {
    return function(t) {
        var i = t.map((t)=>{
            var i, e, r = "";
            if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
            var n = g({}, t.text ? {
                text: t.text
            } : {}, {
                "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
            }, t.href ? {
                href: t.href
            } : {}, t.attr_id ? {
                attr_id: t.attr_id
            } : {}, t.attributes), o = {};
            return Oi(n).sort((t, i)=>{
                var [e] = t, [r] = i;
                return e.localeCompare(r);
            }).forEach((t)=>{
                var [i, e] = t;
                return o[tr(i.toString())] = tr(e.toString());
            }), r += ":", r += Oi(o).map((t)=>{
                var [i, e] = t;
                return i + '="' + e + '"';
            }).join("");
        });
        return i.join(";");
    }(function(t) {
        return t.map((t)=>{
            var i, e, r = {
                text: null == (i = t.$el_text) ? void 0 : i.slice(0, 400),
                tag_name: t.tag_name,
                href: null == (e = t.attr__href) ? void 0 : e.slice(0, 2048),
                attr_class: ir(t),
                attr_id: t.attr__id,
                nth_child: t.nth_child,
                nth_of_type: t.nth_of_type,
                attributes: {}
            };
            return Oi(t).filter((t)=>{
                var [i] = t;
                return 0 === i.indexOf("attr__");
            }).forEach((t)=>{
                var [i, e] = t;
                return r.attributes[i] = e;
            }), r;
        });
    }(t));
}
function tr(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function ir(t) {
    var i = t.attr__class;
    return i ? I(i) ? i : ke(i) : void 0;
}
class er {
    constructor(t){
        this.disabled = !1 === t;
        var i = R(t) ? t : {};
        this.thresholdPx = i.threshold_px || 30, this.timeoutMs = i.timeout_ms || 1e3, this.clickCount = i.click_count || 3, this.clicks = [];
    }
    isRageClick(t, i, e) {
        if (this.disabled) return !1;
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(i - r.y) < this.thresholdPx && e - r.timestamp < this.timeoutMs) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), this.clicks.length === this.clickCount) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
}
var rr = (t)=>{
    var i = null == o ? void 0 : o.createElement("a");
    return O(i) ? null : (i.href = t, i);
}, sr = function(t, i) {
    var e, r;
    void 0 === i && (i = "&");
    var s = [];
    return Ci(t, function(t, i) {
        O(t) || O(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(i), s[s.length] = r + "=" + e);
    }), s.join(i);
}, nr = function(t, i) {
    for(var e, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++){
        var n = r[s].split("=");
        if (n[0] === i) {
            e = n;
            break;
        }
    }
    if (!I(e) || e.length < 2) return "";
    var o = e[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $i.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, or = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    for(var r = t.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], u = (a || "").split("&"), h = [], d = 0; d < u.length; d++){
        var v = u[d].split("=");
        I(v) && (i.includes(v[0]) ? h.push(v[0] + "=" + e) : h.push(u[d]));
    }
    var c = l;
    return null != a && (c += "?" + h.join("&")), null != n && (c += "#" + n), c;
}, ar = function(t, i) {
    var e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, lr = "$copy_autocapture", ur = Si("[AutoCapture]");
function hr(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function dr(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var i = t;
    do i = i.previousSibling;
    while (i && !xe(i));
    return i;
}
function vr(t, i, e, r) {
    var s = t.tagName.toLowerCase(), n = {
        tag_name: s
    };
    Fe.indexOf(s) > -1 && !e && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? n.$el_text = hr(1024, Xe(t)) : n.$el_text = hr(1024, Ce(t)));
    var o = Te(t);
    o.length > 0 && (n.classes = o.filter(function(t) {
        return "" !== t;
    })), Ci(t.attributes, function(e) {
        var s;
        if ((!Be(t) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(e.name)) && (null == r || !r.includes(e.name)) && !i && Ye(e.value) && (s = e.name, !M(s) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
            var o = e.value;
            "class" === e.name && (o = ke(o).join(" ")), n["attr__" + e.name] = hr(1024, o);
        }
    });
    for(var a = 1, l = 1, u = t; u = dr(u);)a++, u.tagName === t.tagName && l++;
    return n.nth_child = a, n.nth_of_type = l, n;
}
function cr(i, e) {
    for(var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = e, h = [
        i
    ], d = i; d.parentNode && !Ee(d, "body");)Se(d.parentNode) ? (h.push(d.parentNode.host), d = d.parentNode.host) : (h.push(d.parentNode), d = d.parentNode);
    var v, c = [], f = {}, p = !1, g = !1;
    if (Ci(h, (t)=>{
        var i = He(t);
        "a" === t.tagName.toLowerCase() && (p = t.getAttribute("href"), p = i && p && Ye(p) && p), w(Te(t), "ph-no-capture") && (g = !0), c.push(vr(t, o, a, l));
        var e = function(t) {
            if (!He(t)) return {};
            var i = {};
            return Ci(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var e = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    e && r && Ye(r) && (i[e] = r);
                }
            }), i;
        }(t);
        Ri(f, e);
    }), g) return {
        props: {},
        explicitNoCapture: g
    };
    if (a || ("a" === i.tagName.toLowerCase() || "button" === i.tagName.toLowerCase() ? c[0].$el_text = Xe(i) : c[0].$el_text = Ce(i)), p) {
        var _, m;
        c[0].attr__href = p;
        var b = null == (_ = rr(p)) ? void 0 : _.host, y = null == t || null == (m = t.location) ? void 0 : m.host;
        b && y && b !== y && (v = p);
    }
    return {
        props: Ri({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: c
        }, {
            $elements_chain: Ze(c)
        }, null != (r = c[0]) && r.$el_text ? {
            $el_text: null == (s = c[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, f)
    };
}
class fr {
    constructor(t){
        this.P = !1, this.T = null, this.I = !1, this.instance = t, this.rageclicks = new er(t.config.rageclick), this.C = null;
    }
    get R() {
        var t, i, e = R(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return e.url_allowlist = null == (t = e.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), e.url_ignorelist = null == (i = e.url_ignorelist) ? void 0 : i.map((t)=>new RegExp(t)), e;
    }
    F() {
        if (this.isBrowserSupported()) {
            if (t && o) {
                var i = (i)=>{
                    i = i || (null == t ? void 0 : t.event);
                    try {
                        this.O(i);
                    } catch (t) {
                        ur.error("Failed to capture event", t);
                    }
                };
                if (zi(o, "submit", i, {
                    capture: !0
                }), zi(o, "change", i, {
                    capture: !0
                }), zi(o, "click", i, {
                    capture: !0
                }), this.R.capture_copied_text) {
                    var e = (i)=>{
                        i = i || (null == t ? void 0 : t.event), this.O(i, lr);
                    };
                    zi(o, "copy", e, {
                        capture: !0
                    }), zi(o, "cut", e, {
                        capture: !0
                    });
                }
            }
        } else ur.info("Disabling Automatic Event Collection because this browser is not supported");
    }
    startIfEnabled() {
        this.isEnabled && !this.P && (this.F(), this.P = !0);
    }
    onRemoteConfig(t) {
        t.elementsChainAsString && (this.I = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [Wi]: !!t.autocapture_opt_out
        }), this.T = !!t.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(t) {
        this.C = t;
    }
    getElementSelectors(t) {
        var i, e = [];
        return null == (i = this.C) || i.forEach((i)=>{
            var r = null == o ? void 0 : o.querySelectorAll(i);
            null == r || r.forEach((r)=>{
                t === r && e.push(i);
            });
        }), e;
    }
    get isEnabled() {
        var t, i, e = null == (t = this.instance.persistence) ? void 0 : t.props[Wi], r = this.T;
        if (j(r) && !U(e) && !this.instance.M()) return !1;
        var s = null !== (i = this.T) && void 0 !== i ? i : !!e;
        return !!this.instance.config.autocapture && !s;
    }
    O(i, e) {
        if (void 0 === e && (e = "$autocapture"), this.isEnabled) {
            var r, s = Re(i);
            if ($e(s) && (s = s.parentNode || null), "$autocapture" === e && "click" === i.type && i instanceof MouseEvent) this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(i.clientX, i.clientY, i.timeStamp || (new Date).getTime()) && Le(s, this.instance.config.rageclick) && this.O(i, "$rageclick");
            var n = e === lr;
            if (s && ze(s, i, this.R, n, n ? [
                "copy",
                "cut"
            ] : void 0)) {
                var { props: o, explicitNoCapture: a } = cr(s, {
                    e: i,
                    maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                    maskAllText: this.instance.config.mask_all_text,
                    elementAttributeIgnoreList: this.R.element_attribute_ignorelist,
                    elementsChainAsString: this.I
                });
                if (a) return !1;
                var l = this.getElementSelectors(s);
                if (l && l.length > 0 && (o.$element_selectors = l), e === lr) {
                    var u, h = Ie(null == t || null == (u = t.getSelection()) ? void 0 : u.toString()), d = i.type || "clipboard";
                    if (!h) return !1;
                    o.$selected_content = h, o.$copy_type = d;
                }
                return this.instance.capture(e, o), !0;
            }
        }
    }
    isBrowserSupported() {
        return C(null == o ? void 0 : o.querySelectorAll);
    }
}
Math.trunc || (Math.trunc = function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return L(t) && isFinite(t) && Math.floor(t) === t;
});
var pr = "0123456789abcdef";
class gr {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, i, e, r) {
        if (!Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(r) || t < 0 || i < 0 || e < 0 || r < 0 || t > 0xffffffffffff || i > 4095 || e > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | i >>> 8, s[7] = i, s[8] = 128 | e >>> 24, s[9] = e >>> 16, s[10] = e >>> 8, s[11] = e, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new gr(s);
    }
    toString() {
        for(var t = "", i = 0; i < this.bytes.length; i++)t = t + pr.charAt(this.bytes[i] >>> 4) + pr.charAt(15 & this.bytes[i]), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new gr(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var i = 0; i < 16; i++){
            var e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}
class _r {
    constructor(){
        this.A = 0, this.j = 0, this.D = new yr;
    }
    generate() {
        var t = this.generateOrAbort();
        if (O(t)) {
            this.A = 0;
            var i = this.generateOrAbort();
            if (O(i)) throw new Error("Could not generate UUID after timestamp reset");
            return i;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.A) this.A = t, this.L();
        else {
            if (!(t + 1e4 > this.A)) return;
            this.j++, this.j > 4398046511103 && (this.A++, this.L());
        }
        return gr.fromFieldsV7(this.A, Math.trunc(this.j / Math.pow(2, 30)), this.j & Math.pow(2, 30) - 1, this.D.nextUint32());
    }
    L() {
        this.j = 1024 * this.D.nextUint32() + (1023 & this.D.nextUint32());
    }
}
var mr, br = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var i = 0; i < t.length; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
t && !O(t.crypto) && crypto.getRandomValues && (br = (t)=>crypto.getRandomValues(t));
class yr {
    constructor(){
        this.N = new Uint32Array(8), this.U = 1 / 0;
    }
    nextUint32() {
        return this.U >= this.N.length && (br(this.N), this.U = 0), this.N[this.U++];
    }
}
var wr = ()=>xr().toString(), xr = ()=>(mr || (mr = new _r)).generate(), Er = "";
var $r = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function Sr(t, i) {
    if (i) {
        var e = function(t, i) {
            if (void 0 === i && (i = o), Er) return Er;
            if (!i) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(t)) return "";
            for(var e = t.split("."), r = Math.min(e.length, 8), s = "dmn_chk_" + wr(); !Er && r--;){
                var n = e.slice(r).join("."), a = s + "=1;domain=." + n + ";path=/";
                i.cookie = a + ";max-age=3", i.cookie.includes(s) && (i.cookie = a + ";max-age=0", Er = n);
            }
            return Er;
        }(t);
        if (!e) {
            var r = ((t)=>{
                var i = t.match($r);
                return i ? i[0] : "";
            })(t);
            r !== e && $i.info("Warning: cookie subdomain discovery mismatch", r, e), e = r;
        }
        return e ? "; domain=." + e : "";
    }
    return "";
}
var kr = {
    H: ()=>!!o,
    B: function(t) {
        $i.error("cookieStore error: " + t);
    },
    q: function(t) {
        if (o) {
            try {
                for(var i = t + "=", e = o.cookie.split(";").filter((t)=>t.length), r = 0; r < e.length; r++){
                    for(var s = e[r]; " " == s.charAt(0);)s = s.substring(1, s.length);
                    if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
                }
            } catch (t) {}
            return null;
        }
    },
    W: function(t) {
        var i;
        try {
            i = JSON.parse(kr.q(t)) || {};
        } catch (t) {}
        return i;
    },
    G: function(t, i, e, r, s) {
        if (o) try {
            var n = "", a = "", l = Sr(o.location.hostname, r);
            if (e) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * e * 3600000), n = "; expires=" + u.toUTCString();
            }
            s && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(i)) + n + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $i.warn("cookieStore warning: large cookie, len=" + h.length), o.cookie = h, h;
        } catch (t) {
            return;
        }
    },
    V: function(t, i) {
        if (null != o && o.cookie) try {
            kr.G(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
}, Pr = null, Tr = {
    H: function() {
        if (!j(Pr)) return Pr;
        var i = !0;
        if (O(t)) i = !1;
        else try {
            var e = "__mplssupport__";
            Tr.G(e, "xyz"), '"xyz"' !== Tr.q(e) && (i = !1), Tr.V(e);
        } catch (t) {
            i = !1;
        }
        return i || $i.error("localStorage unsupported; falling back to cookie store"), Pr = i, i;
    },
    B: function(t) {
        $i.error("localStorage error: " + t);
    },
    q: function(i) {
        try {
            return null == t ? void 0 : t.localStorage.getItem(i);
        } catch (t) {
            Tr.B(t);
        }
        return null;
    },
    W: function(t) {
        try {
            return JSON.parse(Tr.q(t)) || {};
        } catch (t) {}
        return null;
    },
    G: function(i, e) {
        try {
            null == t || t.localStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            Tr.B(t);
        }
    },
    V: function(i) {
        try {
            null == t || t.localStorage.removeItem(i);
        } catch (t) {
            Tr.B(t);
        }
    }
}, Ir = [
    "$device_id",
    "distinct_id",
    ie,
    ee,
    _e,
    ge
], Cr = {}, Rr = {
    H: function() {
        return !0;
    },
    B: function(t) {
        $i.error("memoryStorage error: " + t);
    },
    q: function(t) {
        return Cr[t] || null;
    },
    W: function(t) {
        return Cr[t] || null;
    },
    G: function(t, i) {
        Cr[t] = i;
    },
    V: function(t) {
        delete Cr[t];
    }
}, Fr = null, Or = {
    H: function() {
        if (!j(Fr)) return Fr;
        if (Fr = !0, O(t)) Fr = !1;
        else try {
            var i = "__support__";
            Or.G(i, "xyz"), '"xyz"' !== Or.q(i) && (Fr = !1), Or.V(i);
        } catch (t) {
            Fr = !1;
        }
        return Fr;
    },
    B: function(t) {
        $i.error("sessionStorage error: ", t);
    },
    q: function(i) {
        try {
            return null == t ? void 0 : t.sessionStorage.getItem(i);
        } catch (t) {
            Or.B(t);
        }
        return null;
    },
    W: function(t) {
        try {
            return JSON.parse(Or.q(t)) || null;
        } catch (t) {}
        return null;
    },
    G: function(i, e) {
        try {
            null == t || t.sessionStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            Or.B(t);
        }
    },
    V: function(i) {
        try {
            null == t || t.sessionStorage.removeItem(i);
        } catch (t) {
            Or.B(t);
        }
    }
}, Mr = function(t) {
    return t[t.PENDING = -1] = "PENDING", t[t.DENIED = 0] = "DENIED", t[t.GRANTED = 1] = "GRANTED", t;
}({});
class Ar {
    constructor(t){
        this._instance = t;
    }
    get R() {
        return this._instance.config;
    }
    get consent() {
        return this.J() ? Mr.DENIED : this.K;
    }
    isOptedOut() {
        return "always" === this.R.cookieless_mode || this.consent === Mr.DENIED || this.consent === Mr.PENDING && (this.R.opt_out_capturing_by_default || "on_reject" === this.R.cookieless_mode);
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return this.consent === Mr.DENIED;
    }
    optInOut(t) {
        this.Y.G(this.X, t ? 1 : 0, this.R.cookie_expiration, this.R.cross_subdomain_cookie, this.R.secure_cookie);
    }
    reset() {
        this.Y.V(this.X, this.R.cross_subdomain_cookie);
    }
    get X() {
        var { token: t, opt_out_capturing_cookie_prefix: i, consent_persistence_name: e } = this._instance.config;
        return e || (i ? i + t : "__ph_opt_in_out_" + t);
    }
    get K() {
        var t = this.Y.q(this.X);
        return V(t) ? Mr.GRANTED : w(J, t) ? Mr.DENIED : Mr.PENDING;
    }
    get Y() {
        if (!this.Z) {
            var t = this.R.opt_out_capturing_persistence_type;
            this.Z = "localStorage" === t ? Tr : kr;
            var i = "localStorage" === t ? kr : Tr;
            i.q(this.X) && (this.Z.q(this.X) || this.optInOut(V(i.q(this.X))), i.V(this.X, this.R.cross_subdomain_cookie));
        }
        return this.Z;
    }
    J() {
        return !!this.R.respect_dnt && !!Ui([
            null == n ? void 0 : n.doNotTrack,
            null == n ? void 0 : n.msDoNotTrack,
            v.doNotTrack
        ], (t)=>V(t));
    }
}
var jr = Si("[Dead Clicks]"), Dr = ()=>!0, Lr = (t)=>{
    var i, e = !(null == (i = t.instance.persistence) || !i.get_property(Xi)), r = t.instance.config.capture_dead_clicks;
    return U(r) ? r : !!R(r) || e;
};
class Nr {
    get lazyLoadedDeadClicksAutocapture() {
        return this.tt;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabledOrStop();
    }
    onRemoteConfig(t) {
        this.instance.persistence && this.instance.persistence.register({
            [Xi]: null == t ? void 0 : t.captureDeadClicks
        }), this.startIfEnabledOrStop();
    }
    startIfEnabledOrStop() {
        this.isEnabled(this) ? this.it(()=>{
            this.et();
        }) : this.stop();
    }
    it(t) {
        var i, e;
        null != (i = v.__PosthogExtensions__) && i.initDeadClicksAutocapture && t(), null == (e = v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i)=>{
            i ? jr.error("failed to load script", i) : t();
        });
    }
    et() {
        var t;
        if (o) {
            if (!this.tt && null != (t = v.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var i = R(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                i.__onCapture = this.onCapture, this.tt = v.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, i), this.tt.start(o), jr.info("starting...");
            }
        } else jr.error("`document` not found. Cannot start.");
    }
    stop() {
        this.tt && (this.tt.stop(), this.tt = void 0, jr.info("stopping..."));
    }
}
var Ur = Si("[ExceptionAutocapture]");
class zr {
    constructor(i){
        var e, r, s;
        this.rt = ()=>{
            var i;
            if (t && this.isEnabled && null != (i = v.__PosthogExtensions__) && i.errorWrappingFunctions) {
                var e = v.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = v.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = v.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.st && this.R.capture_unhandled_errors && (this.st = e(this.captureException.bind(this))), !this.nt && this.R.capture_unhandled_rejections && (this.nt = r(this.captureException.bind(this))), !this.ot && this.R.capture_console_errors && (this.ot = s(this.captureException.bind(this)));
                } catch (t) {
                    Ur.error("failed to start", t), this.ut();
                }
            }
        }, this._instance = i, this.ht = !(null == (e = this._instance.persistence) || !e.props[Vi]), this.dt = new Y({
            refillRate: null !== (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) && void 0 !== r ? r : 1,
            bucketSize: null !== (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10,
            refillInterval: 1e4,
            h: Ur
        }), this.R = this.vt(), this.startIfEnabledOrStop();
    }
    vt() {
        var t = this._instance.config.capture_exceptions, i = {
            capture_unhandled_errors: !1,
            capture_unhandled_rejections: !1,
            capture_console_errors: !1
        };
        return R(t) ? i = g({}, i, t) : (O(t) ? this.ht : t) && (i = g({}, i, {
            capture_unhandled_errors: !0,
            capture_unhandled_rejections: !0
        })), i;
    }
    get isEnabled() {
        return this.R.capture_console_errors || this.R.capture_unhandled_errors || this.R.capture_unhandled_rejections;
    }
    startIfEnabledOrStop() {
        this.isEnabled ? (Ur.info("enabled"), this.ut(), this.it(this.rt)) : this.ut();
    }
    it(t) {
        var i, e;
        null != (i = v.__PosthogExtensions__) && i.errorWrappingFunctions && t(), null == (e = v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "exception-autocapture", (i)=>{
            if (i) return Ur.error("failed to load script", i);
            t();
        });
    }
    ut() {
        var t, i, e;
        null == (t = this.st) || t.call(this), this.st = void 0, null == (i = this.nt) || i.call(this), this.nt = void 0, null == (e = this.ot) || e.call(this), this.ot = void 0;
    }
    onRemoteConfig(t) {
        var i = t.autocaptureExceptions;
        this.ht = !!i || !1, this._instance.persistence && this._instance.persistence.register({
            [Vi]: this.ht
        }), this.R = this.vt(), this.startIfEnabledOrStop();
    }
    onConfigChange() {
        this.R = this.vt();
    }
    captureException(t) {
        var i, e, r = null !== (i = null == t || null == (e = t.$exception_list) || null == (e = e[0]) ? void 0 : e.type) && void 0 !== i ? i : "Exception";
        this.dt.consumeRateLimit(r) ? Ur.info("Skipping exception capture because of client rate limiting.", {
            exception: r
        }) : this._instance.exceptions.sendExceptionEvent(t);
    }
}
function Hr(t, i, e) {
    try {
        if (!(i in t)) return ()=>{};
        var r = t[i], s = e(r);
        return C(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            }
        })), t[i] = s, ()=>{
            t[i] = r;
        };
    } catch (t) {
        return ()=>{};
    }
}
class Br {
    constructor(i){
        var e;
        this._instance = i, this.ct = (null == t || null == (e = t.location) ? void 0 : e.pathname) || "";
    }
    get isEnabled() {
        return "history_change" === this._instance.config.capture_pageview;
    }
    startIfEnabled() {
        this.isEnabled && ($i.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
    }
    stop() {
        this.ft && this.ft(), this.ft = void 0, $i.info("History API monitoring stopped");
    }
    monitorHistoryChanges() {
        var i, e;
        if (t && t.history) {
            var r = this;
            null != (i = t.history.pushState) && i.__posthog_wrapped__ || Hr(t.history, "pushState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r._t("pushState");
                }), null != (e = t.history.replaceState) && e.__posthog_wrapped__ || Hr(t.history, "replaceState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r._t("replaceState");
                }), this.bt();
        }
    }
    _t(i) {
        try {
            var e, r = null == t || null == (e = t.location) ? void 0 : e.pathname;
            if (!r) return;
            r !== this.ct && this.isEnabled && this._instance.capture("$pageview", {
                navigation_type: i
            }), this.ct = r;
        } catch (t) {
            $i.error("Error capturing " + i + " pageview", t);
        }
    }
    bt() {
        if (!this.ft) {
            var i = ()=>{
                this._t("popstate");
            };
            zi(t, "popstate", i), this.ft = ()=>{
                t && t.removeEventListener("popstate", i);
            };
        }
    }
}
var qr = Si("[SegmentIntegration]");
function Wr(t, i) {
    var e = t.config.segment;
    if (!e) return i();
    !function(t, i) {
        var e = t.config.segment;
        if (!e) return i();
        var r = (e)=>{
            var r = ()=>e.anonymousId() || wr();
            t.config.get_device_id = r, e.id() && (t.register({
                distinct_id: e.id(),
                $device_id: r()
            }), t.persistence.set_property(de, "identified")), i();
        }, s = e.user();
        "then" in s && C(s.then) ? s.then(r) : r(s);
    }(t, ()=>{
        e.register(((t)=>{
            Promise && Promise.resolve || qr.warn("This browser does not have Promise support, and can not use the segment integration");
            var i = (i, e)=>{
                if (!e) return i;
                i.event.userId || i.event.anonymousId === t.get_distinct_id() || (qr.info("No userId set, resetting PostHog"), t.reset()), i.event.userId && i.event.userId !== t.get_distinct_id() && (qr.info("UserId set, identifying with PostHog"), t.identify(i.event.userId));
                var r = t.calculateEventProperties(e, i.event.properties);
                return i.event.properties = Object.assign({}, r, i.event.properties), i;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (t)=>i(t, t.event.event),
                page: (t)=>i(t, "$pageview"),
                identify: (t)=>i(t, "$identify"),
                screen: (t)=>i(t, "$screen")
            };
        })(t)).then(()=>{
            i();
        });
    });
}
var Gr = "posthog-js";
function Vr(t, i) {
    var { organization: e, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ], sendExceptionsToPostHog: o = !0 } = void 0 === i ? {} : i;
    return (i)=>{
        var a, l, u, h, d;
        if (!("*" === n || n.includes(i.level)) || !t.__loaded) return i;
        i.tags || (i.tags = {});
        var v = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        i.tags["PostHog Person URL"] = v, t.sessionRecordingStarted() && (i.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var c = (null == (a = i.exception) ? void 0 : a.values) || [], f = c.map((t)=>g({}, t, {
                stacktrace: t.stacktrace ? g({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>g({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), p = {
            $exception_message: (null == (l = c[0]) ? void 0 : l.value) || i.message,
            $exception_type: null == (u = c[0]) ? void 0 : u.type,
            $exception_level: i.level,
            $exception_list: f,
            $sentry_event_id: i.event_id,
            $sentry_exception: i.exception,
            $sentry_exception_message: (null == (h = c[0]) ? void 0 : h.value) || i.message,
            $sentry_exception_type: null == (d = c[0]) ? void 0 : d.type,
            $sentry_tags: i.tags
        };
        return e && r && (p.$sentry_url = (s || "https://sentry.io/organizations/") + e + "/issues/?project=" + r + "&query=" + i.event_id), o && t.exceptions.sendExceptionEvent(p), i;
    };
}
class Jr {
    constructor(t, i, e, r, s, n){
        this.name = Gr, this.setupOnce = function(o) {
            o(Vr(t, {
                organization: i,
                projectId: e,
                prefix: r,
                severityAllowList: s,
                sendExceptionsToPostHog: null == n || n
            }));
        };
    }
}
var Kr = null != t && t.location ? ar(t.location.hash, "__posthog") || ar(location.hash, "state") : null, Yr = "_postHogToolbarParams", Xr = Si("[Toolbar]"), Qr = function(t) {
    return t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.LOADED = 2] = "LOADED", t;
}(Qr || {});
class Zr {
    constructor(t){
        this.instance = t;
    }
    yt(t) {
        v.ph_toolbar_state = t;
    }
    wt() {
        var t;
        return null !== (t = v.ph_toolbar_state) && void 0 !== t ? t : Qr.UNINITIALIZED;
    }
    maybeLoadToolbar(i, e, r) {
        if (void 0 === i && (i = void 0), void 0 === e && (e = void 0), void 0 === r && (r = void 0), this.instance.config.name && "ph_toolbar_internal" === this.instance.config.name) return !1;
        if (!t || !o) return !1;
        i = null != i ? i : t.location, r = null != r ? r : t.history;
        try {
            if (!e) {
                try {
                    t.localStorage.setItem("test", "test"), t.localStorage.removeItem("test");
                } catch (t) {
                    return !1;
                }
                e = null == t ? void 0 : t.localStorage;
            }
            var s, n = Kr || ar(i.hash, "__posthog") || ar(i.hash, "state"), a = n ? Mi(()=>JSON.parse(atob(decodeURIComponent(n)))) || Mi(()=>JSON.parse(decodeURIComponent(n))) : null;
            return a && "ph_authorize" === a.action ? ((s = a).source = "url", s && Object.keys(s).length > 0 && (a.desiredHash ? i.hash = a.desiredHash : r ? r.replaceState(r.state, "", i.pathname + i.search) : i.hash = "")) : ((s = JSON.parse(e.getItem(Yr) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
        } catch (t) {
            return !1;
        }
    }
    xt(t) {
        var i = v.ph_load_toolbar || v.ph_load_editor;
        !D(i) && C(i) ? i(t, this.instance) : Xr.warn("No toolbar load function found");
    }
    loadToolbar(i) {
        var e = !(null == o || !o.getElementById(me));
        if (!t || e) return !1;
        var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = g({
            token: this.instance.config.token
        }, i, {
            apiURL: this.instance.requestRouter.endpointFor("ui")
        }, r ? {
            instrument: !1
        } : {});
        if (t.localStorage.setItem(Yr, JSON.stringify(g({}, s, {
            source: void 0
        }))), this.wt() === Qr.LOADED) this.xt(s);
        else if (this.wt() === Qr.UNINITIALIZED) {
            var n;
            this.yt(Qr.LOADING), null == (n = v.__PosthogExtensions__) || null == n.loadExternalDependency || n.loadExternalDependency(this.instance, "toolbar", (t)=>{
                if (t) return Xr.error("[Toolbar] Failed to load", t), void this.yt(Qr.UNINITIALIZED);
                this.yt(Qr.LOADED), this.xt(s);
            }), zi(t, "turbolinks:load", ()=>{
                this.yt(Qr.UNINITIALIZED), this.loadToolbar(s);
            });
        }
        return !0;
    }
    Et(t) {
        return this.loadToolbar(t);
    }
    maybeLoadEditor(t, i, e) {
        return void 0 === t && (t = void 0), void 0 === i && (i = void 0), void 0 === e && (e = void 0), this.maybeLoadToolbar(t, i, e);
    }
}
var ts = Si("[TracingHeaders]");
class is {
    constructor(t){
        this.$t = void 0, this.St = void 0, this.rt = ()=>{
            var t, i;
            O(this.$t) && (null == (t = v.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) || t._patchXHR(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
            O(this.St) && (null == (i = v.__PosthogExtensions__) || null == (i = i.tracingHeadersPatchFns) || i._patchFetch(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
        }, this._instance = t;
    }
    it(t) {
        var i, e;
        null != (i = v.__PosthogExtensions__) && i.tracingHeadersPatchFns && t(), null == (e = v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "tracing-headers", (i)=>{
            if (i) return ts.error("failed to load script", i);
            t();
        });
    }
    startIfEnabledOrStop() {
        var t, i;
        this._instance.config.__add_tracing_headers ? this.it(this.rt) : (null == (t = this.$t) || t.call(this), null == (i = this.St) || i.call(this), this.$t = void 0, this.St = void 0);
    }
}
var es = "https?://(.*)", rs = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], ss = Fi([
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid"
], rs), ns = "<masked>", os = [
    "li_fat_id"
];
function as(t, i, e) {
    if (!o) return {};
    var r, s = i ? Fi([], rs, e || []) : [], n = ls(or(o.URL, s, ns), t), a = (r = {}, Ci(os, function(t) {
        var i = kr.q(t);
        r[t] = i || null;
    }), r);
    return Ri(a, n);
}
function ls(t, i) {
    var e = ss.concat(i || []), r = {};
    return Ci(e, function(i) {
        var e = nr(t, i);
        r[i] = e || null;
    }), r;
}
function us(t) {
    var i = function(t) {
        return t ? 0 === t.search(es + "google.([^/?]*)") ? "google" : 0 === t.search(es + "bing.com") ? "bing" : 0 === t.search(es + "yahoo.com") ? "yahoo" : 0 === t.search(es + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", r = {};
    if (!j(i)) {
        r.$search_engine = i;
        var s = o ? nr(o.referrer, e) : "";
        s.length && (r.ph_keyword = s);
    }
    return r;
}
function hs() {
    return navigator.language || navigator.userLanguage;
}
function ds() {
    return (null == o ? void 0 : o.referrer) || "$direct";
}
function vs(t, i) {
    var e = t ? Fi([], rs, i || []) : [], r = null == a ? void 0 : a.href.substring(0, 1e3);
    return {
        r: ds().substring(0, 1e3),
        u: r ? or(r, e, ns) : void 0
    };
}
function cs(t) {
    var i, { r: e, u: r } = t, s = {
        $referrer: e,
        $referring_domain: null == e ? void 0 : "$direct" == e ? "$direct" : null == (i = rr(e)) ? void 0 : i.host
    };
    if (r) {
        s.$current_url = r;
        var n = rr(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = ls(r);
        Ri(s, o);
    }
    if (e) {
        var a = us(e);
        Ri(s, a);
    }
    return s;
}
function fs() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function ps() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
function gs(i, e) {
    if (!d) return {};
    var r, s, n, o = i ? Fi([], rs, e || []) : [], [l, u] = function(t) {
        for(var i = 0; i < Jt.length; i++){
            var [e, r] = Jt[i], s = e.exec(t), n = s && (C(r) ? r(s, t) : r);
            if (n) return n;
        }
        return [
            "",
            ""
        ];
    }(d);
    return Ri(ji({
        $os: l,
        $os_version: u,
        $browser: Wt(d, navigator.vendor),
        $device: Kt(d),
        $device_type: (s = d, n = Kt(s), n === et || n === it || "Kobo" === n || "Kindle Fire" === n || n === Ft ? tt : n === wt || n === Et || n === xt || n === It ? "Console" : n === st ? "Wearable" : n ? X : "Desktop"),
        $timezone: fs(),
        $timezone_offset: ps()
    }), {
        $current_url: or(null == a ? void 0 : a.href, o, ns),
        $host: null == a ? void 0 : a.host,
        $pathname: null == a ? void 0 : a.pathname,
        $raw_user_agent: d.length > 1e3 ? d.substring(0, 997) + "..." : d,
        $browser_version: Vt(d, navigator.vendor),
        $browser_language: hs(),
        $browser_language_prefix: (r = hs(), "string" == typeof r ? r.split("-")[0] : void 0),
        $screen_height: null == t ? void 0 : t.screen.height,
        $screen_width: null == t ? void 0 : t.screen.width,
        $viewport_height: null == t ? void 0 : t.innerHeight,
        $viewport_width: null == t ? void 0 : t.innerWidth,
        $lib: "web",
        $lib_version: c.LIB_VERSION,
        $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        $time: Date.now() / 1e3
    });
}
var _s = Si("[Web Vitals]"), ms = 9e5;
class bs {
    constructor(t){
        var i;
        this.kt = !1, this.P = !1, this.N = {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }, this.Pt = ()=>{
            clearTimeout(this.Tt), 0 !== this.N.metrics.length && (this._instance.capture("$web_vitals", this.N.metrics.reduce((t, i)=>g({}, t, {
                    ["$web_vitals_" + i.name + "_event"]: g({}, i),
                    ["$web_vitals_" + i.name + "_value"]: i.value
                }), {})), this.N = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }, this.It = (t)=>{
            var i, e = null == (i = this._instance.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0);
            if (O(e)) _s.error("Could not read session ID. Dropping metrics!");
            else {
                this.N = this.N || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var r = this.Ct();
                if (!O(r)) {
                    if (D(null == t ? void 0 : t.name) || D(null == t ? void 0 : t.value)) _s.error("Invalid metric received", t);
                    else if (this.Rt && t.value >= this.Rt) _s.error("Ignoring metric with value >= " + this.Rt, t);
                    else this.N.url !== r && (this.Pt(), this.Tt = setTimeout(this.Pt, this.flushToCaptureTimeoutMs)), O(this.N.url) && (this.N.url = r), this.N.firstMetricTimestamp = O(this.N.firstMetricTimestamp) ? Date.now() : this.N.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0), this.N.metrics.push(g({}, t, {
                        $current_url: r,
                        $session_id: e.sessionId,
                        $window_id: e.windowId,
                        timestamp: Date.now()
                    })), this.N.metrics.length === this.allowedMetrics.length && this.Pt();
                }
            }
        }, this.rt = ()=>{
            if (!this.P) {
                var t, i, e, r, s = v.__PosthogExtensions__;
                O(s) || O(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: i, onFCP: e, onINP: r } = s.postHogWebVitalsCallbacks), t && i && e && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.It.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.It.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && e(this.It.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.It.bind(this)), this.P = !0) : _s.error("web vitals callbacks not loaded - not starting");
            }
        }, this._instance = t, this.kt = !(null == (i = this._instance.persistence) || !i.props[Yi]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var t, i, e = R(this._instance.config.capture_performance) ? null == (t = this._instance.config.capture_performance) ? void 0 : t.web_vitals_allowed_metrics : void 0;
        return D(e) ? (null == (i = this._instance.persistence) ? void 0 : i.props[Zi]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : e;
    }
    get flushToCaptureTimeoutMs() {
        return (R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get useAttribution() {
        var t = R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_attribution : void 0;
        return null != t && t;
    }
    get Rt() {
        var t = R(this._instance.config.capture_performance) && L(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : ms;
        return 0 < t && t <= 6e4 ? ms : t;
    }
    get isEnabled() {
        var t = null == a ? void 0 : a.protocol;
        if ("http:" !== t && "https:" !== t) return _s.info("Web Vitals are disabled on non-http/https protocols"), !1;
        var i = R(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : U(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
        return U(i) ? i : this.kt;
    }
    startIfEnabled() {
        this.isEnabled && !this.P && (_s.info("enabled, starting..."), this.it(this.rt));
    }
    onRemoteConfig(t) {
        var i = R(t.capturePerformance) && !!t.capturePerformance.web_vitals, e = R(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
        this._instance.persistence && (this._instance.persistence.register({
            [Yi]: i
        }), this._instance.persistence.register({
            [Zi]: e
        })), this.kt = i, this.startIfEnabled();
    }
    it(t) {
        var i, e;
        if (null != (i = v.__PosthogExtensions__) && i.postHogWebVitalsCallbacks) t();
        else {
            var r = this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
            null == (e = v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, r, (i)=>{
                i ? _s.error("failed to load script", i) : t();
            });
        }
    }
    Ct() {
        var i = t ? t.location.href : void 0;
        if (i) {
            var e = this._instance.config.mask_personal_data_properties, r = this._instance.config.custom_personal_data_properties, s = e ? Fi([], rs, r || []) : [];
            return or(i, s, ns);
        }
        _s.error("Could not determine current URL");
    }
}
var ys = Si("[Heatmaps]");
function ws(t) {
    return R(t) && "clientX" in t && "clientY" in t && L(t.clientX) && L(t.clientY);
}
class xs {
    constructor(t){
        var i;
        this.kt = !1, this.P = !1, this.Ft = null, this.instance = t, this.kt = !(null == (i = this.instance.persistence) || !i.props[Gi]), this.rageclicks = new er(t.config.rageclick);
    }
    get flushIntervalMilliseconds() {
        var t = 5e3;
        return R(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
    }
    get isEnabled() {
        return D(this.instance.config.capture_heatmaps) ? D(this.instance.config.enable_heatmaps) ? this.kt : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this.P) return;
            ys.info("starting..."), this.Ot(), this.Mt();
        } else {
            var t;
            clearInterval(null !== (t = this.Ft) && void 0 !== t ? t : void 0), this.At(), this.getAndClearBuffer();
        }
    }
    onRemoteConfig(t) {
        var i = !!t.heatmaps;
        this.instance.persistence && this.instance.persistence.register({
            [Gi]: i
        }), this.kt = i, this.startIfEnabled();
    }
    getAndClearBuffer() {
        var t = this.N;
        return this.N = void 0, t;
    }
    jt(t) {
        this.Dt(t.originalEvent, "deadclick");
    }
    Mt() {
        this.Ft && clearInterval(this.Ft), this.Ft = function(t) {
            return "visible" === (null == t ? void 0 : t.visibilityState);
        }(o) ? setInterval(this.Lt.bind(this), this.flushIntervalMilliseconds) : null;
    }
    Ot() {
        t && o && (this.Nt = this.Lt.bind(this), zi(t, "beforeunload", this.Nt), this.Ut = (i)=>this.Dt(i || (null == t ? void 0 : t.event)), zi(o, "click", this.Ut, {
            capture: !0
        }), this.zt = (i)=>this.Ht(i || (null == t ? void 0 : t.event)), zi(o, "mousemove", this.zt, {
            capture: !0
        }), this.Bt = new Nr(this.instance, Dr, this.jt.bind(this)), this.Bt.startIfEnabledOrStop(), this.qt = this.Mt.bind(this), zi(o, "visibilitychange", this.qt), this.P = !0);
    }
    At() {
        var i;
        t && o && (this.Nt && t.removeEventListener("beforeunload", this.Nt), this.Ut && o.removeEventListener("click", this.Ut, {
            capture: !0
        }), this.zt && o.removeEventListener("mousemove", this.zt, {
            capture: !0
        }), this.qt && o.removeEventListener("visibilitychange", this.qt), clearTimeout(this.Wt), null == (i = this.Bt) || i.stop(), this.P = !1);
    }
    Gt(i, e) {
        var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(i, e, r) {
            for(var s = i; s && xe(s) && !Ee(s, "body");){
                if (s === r) return !1;
                if (w(e, null == t ? void 0 : t.getComputedStyle(s).position)) return !0;
                s = Me(s);
            }
            return !1;
        }(Re(i), [
            "fixed",
            "sticky"
        ], n);
        return {
            x: i.clientX + (o ? 0 : s),
            y: i.clientY + (o ? 0 : r),
            target_fixed: o,
            type: e
        };
    }
    Dt(t, i) {
        var e;
        if (void 0 === i && (i = "click"), !we(t.target) && ws(t)) {
            var r = this.Gt(t, i);
            null != (e = this.rageclicks) && e.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.Vt(g({}, r, {
                type: "rageclick"
            })), this.Vt(r);
        }
    }
    Ht(t) {
        !we(t.target) && ws(t) && (clearTimeout(this.Wt), this.Wt = setTimeout(()=>{
            this.Vt(this.Gt(t, "mousemove"));
        }, 500));
    }
    Vt(i) {
        if (t) {
            var e = t.location.href, r = this.instance.config.mask_personal_data_properties, s = this.instance.config.custom_personal_data_properties, n = r ? Fi([], rs, s || []) : [], o = or(e, n, ns);
            this.N = this.N || {}, this.N[o] || (this.N[o] = []), this.N[o].push(i);
        }
    }
    Lt() {
        this.N && !F(this.N) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class Es {
    constructor(t){
        this.Jt = (t, i, e)=>{
            e && (e.noSessionId || e.activityTimeout || e.sessionPastMaximumLength) && ($i.info("[PageViewManager] Session rotated, clearing pageview state", {
                sessionId: t,
                changeReason: e
            }), this.Kt = void 0, this._instance.scrollManager.resetContext());
        }, this._instance = t, this.Yt();
    }
    Yt() {
        var t;
        this.Xt = null == (t = this._instance.sessionManager) ? void 0 : t.onSessionId(this.Jt);
    }
    destroy() {
        var t;
        null == (t = this.Xt) || t.call(this), this.Xt = void 0;
    }
    doPageView(i, e) {
        var r, s = this.Qt(i, e);
        return this.Kt = {
            pathname: null !== (r = null == t ? void 0 : t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: e,
            timestamp: i
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var i;
        return this.Qt(t, null == (i = this.Kt) ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.Kt) ? void 0 : t.pageViewId
        };
    }
    Qt(t, i) {
        var e = this.Kt;
        if (!e) return {
            $pageview_id: i
        };
        var r = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: h } = s;
            if (!(O(n) || O(o) || O(a) || O(l) || O(u) || O(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n <= 1 ? 1 : K(o / n, 0, 1, $i), v = n <= 1 ? 1 : K(a / n, 0, 1, $i), c = l <= 1 ? 1 : K(u / l, 0, 1, $i), f = l <= 1 ? 1 : K(h / l, 0, 1, $i);
                r = Ri(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return e.pathname && (r.$prev_pageview_pathname = e.pathname), e.timestamp && (r.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), r;
    }
}
var $s = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], Ss = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), ks = Uint8Array, Ps = Uint16Array, Ts = Uint32Array, Is = new ks([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), Cs = new ks([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), Rs = new ks([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), Fs = function(t, i) {
    for(var e = new Ps(31), r = 0; r < 31; ++r)e[r] = i += 1 << t[r - 1];
    var s = new Ts(e[30]);
    for(r = 1; r < 30; ++r)for(var n = e[r]; n < e[r + 1]; ++n)s[n] = n - e[r] << 5 | r;
    return [
        e,
        s
    ];
}, Os = Fs(Is, 2), Ms = Os[0], As = Os[1];
Ms[28] = 258, As[258] = 28;
for(var js = Fs(Cs, 0)[1], Ds = new Ps(32768), Ls = 0; Ls < 32768; ++Ls){
    var Ns = (43690 & Ls) >>> 1 | (21845 & Ls) << 1;
    Ns = (61680 & (Ns = (52428 & Ns) >>> 2 | (13107 & Ns) << 2)) >>> 4 | (3855 & Ns) << 4, Ds[Ls] = ((65280 & Ns) >>> 8 | (255 & Ns) << 8) >>> 1;
}
var Us = function(t, i, e) {
    for(var r = t.length, s = 0, n = new Ps(i); s < r; ++s)++n[t[s] - 1];
    var o, a = new Ps(i);
    for(s = 0; s < i; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (e) {
        o = new Ps(1 << i);
        var l = 15 - i;
        for(s = 0; s < r; ++s)if (t[s]) for(var u = s << 4 | t[s], h = i - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; d <= v; ++d)o[Ds[d] >>> l] = u;
    } else for(o = new Ps(r), s = 0; s < r; ++s)o[s] = Ds[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, zs = new ks(288);
for(Ls = 0; Ls < 144; ++Ls)zs[Ls] = 8;
for(Ls = 144; Ls < 256; ++Ls)zs[Ls] = 9;
for(Ls = 256; Ls < 280; ++Ls)zs[Ls] = 7;
for(Ls = 280; Ls < 288; ++Ls)zs[Ls] = 8;
var Hs = new ks(32);
for(Ls = 0; Ls < 32; ++Ls)Hs[Ls] = 5;
var Bs = Us(zs, 9, 0), qs = Us(Hs, 5, 0), Ws = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, Gs = function(t, i, e) {
    (null == e || e > t.length) && (e = t.length);
    var r = new (t instanceof Ps ? Ps : t instanceof Ts ? Ts : ks)(e - i);
    return r.set(t.subarray(i, e)), r;
}, Vs = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8;
}, Js = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8, t[r + 2] |= e >>> 16;
}, Ks = function(t, i) {
    for(var e = [], r = 0; r < t.length; ++r)t[r] && e.push({
        s: r,
        f: t[r]
    });
    var s = e.length, n = e.slice();
    if (!s) return [
        new ks(0),
        0
    ];
    if (1 == s) {
        var o = new ks(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var a = e[0], l = e[1], u = 0, h = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = e[e[u].f < e[d].f ? u++ : d++], l = e[u != h && e[u].f < e[d].f ? u++ : d++], e[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; r < s; ++r)n[r].s > v && (v = n[r].s);
    var c = new Ps(v + 1), f = Ys(e[h - 1], c, 0);
    if (f > i) {
        r = 0;
        var p = 0, g = f - i, _ = 1 << g;
        for(n.sort(function(t, i) {
            return c[i.s] - c[t.s] || t.f - i.f;
        }); r < s; ++r){
            var m = n[r].s;
            if (!(c[m] > i)) break;
            p += _ - (1 << f - c[m]), c[m] = i;
        }
        for(p >>>= g; p > 0;){
            var b = n[r].s;
            c[b] < i ? p -= 1 << i - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var y = n[r].s;
            c[y] == i && (--c[y], ++p);
        }
        f = i;
    }
    return [
        new ks(c),
        f
    ];
}, Ys = function(t, i, e) {
    return -1 == t.s ? Math.max(Ys(t.l, i, e + 1), Ys(t.r, i, e + 1)) : i[t.s] = e;
}, Xs = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new Ps(++i), r = 0, s = t[0], n = 1, o = function(t) {
        e[r++] = t;
    }, a = 1; a <= i; ++a)if (t[a] == s && a != i) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        e.subarray(0, r),
        i
    ];
}, Qs = function(t, i) {
    for(var e = 0, r = 0; r < i.length; ++r)e += t[r] * i[r];
    return e;
}, Zs = function(t, i, e) {
    var r = e.length, s = Ws(i + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; n < r; ++n)t[s + n + 4] = e[n];
    return 8 * (s + 4 + r);
}, tn = function(t, i, e, r, s, n, o, a, l, u, h) {
    Vs(i, h++, e), ++s[256];
    for(var d = Ks(s, 15), v = d[0], c = d[1], f = Ks(n, 15), p = f[0], g = f[1], _ = Xs(v), m = _[0], b = _[1], y = Xs(p), w = y[0], x = y[1], E = new Ps(19), S = 0; S < m.length; ++S)E[31 & m[S]]++;
    for(S = 0; S < w.length; ++S)E[31 & w[S]]++;
    for(var k = Ks(E, 7), P = k[0], T = k[1], I = 19; I > 4 && !P[Rs[I - 1]]; --I);
    var C, R, F, O, M = u + 5 << 3, A = Qs(s, zs) + Qs(n, Hs) + o, j = Qs(s, v) + Qs(n, p) + o + 14 + 3 * I + Qs(E, P) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
    if (M <= A && M <= j) return Zs(i, h, t.subarray(l, l + u));
    if (Vs(i, h, 1 + (j < A)), h += 2, j < A) {
        C = Us(v, c, 0), R = v, F = Us(p, g, 0), O = p;
        var D = Us(P, T, 0);
        Vs(i, h, b - 257), Vs(i, h + 5, x - 1), Vs(i, h + 10, I - 4), h += 14;
        for(S = 0; S < I; ++S)Vs(i, h + 3 * S, P[Rs[S]]);
        h += 3 * I;
        for(var L = [
            m,
            w
        ], N = 0; N < 2; ++N){
            var U = L[N];
            for(S = 0; S < U.length; ++S){
                var z = 31 & U[S];
                Vs(i, h, D[z]), h += P[z], z > 15 && (Vs(i, h, U[S] >>> 5 & 127), h += U[S] >>> 12);
            }
        }
    } else C = Bs, R = zs, F = qs, O = Hs;
    for(S = 0; S < a; ++S)if (r[S] > 255) {
        z = r[S] >>> 18 & 31;
        Js(i, h, C[z + 257]), h += R[z + 257], z > 7 && (Vs(i, h, r[S] >>> 23 & 31), h += Is[z]);
        var H = 31 & r[S];
        Js(i, h, F[H]), h += O[H], H > 3 && (Js(i, h, r[S] >>> 5 & 8191), h += Cs[H]);
    } else Js(i, h, C[r[S]]), h += R[r[S]];
    return Js(i, h, C[256]), h + R[256];
}, en = new Ts([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), rn = function() {
    for(var t = new Ts(256), i = 0; i < 256; ++i){
        for(var e = i, r = 9; --r;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), sn = function(t, i, e, r, s) {
    return function(t, i, e, r, s, n) {
        var o = t.length, a = new ks(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!i || o < 8) for(var h = 0; h <= o; h += 65535){
            var d = h + 65535;
            d < o ? u = Zs(l, u, t.subarray(h, d)) : (l[h] = n, u = Zs(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = en[i - 1], c = v >>> 13, f = 8191 & v, p = (1 << e) - 1, g = new Ps(32768), _ = new Ps(p + 1), m = Math.ceil(e / 3), b = 2 * m, y = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << b) & p;
            }, w = new Ts(25e3), x = new Ps(288), E = new Ps(32), S = 0, k = 0, P = (h = 0, 0), T = 0, I = 0; h < o; ++h){
                var C = y(h), R = 32767 & h, F = _[C];
                if (g[R] = F, _[C] = R, T <= h) {
                    var O = o - h;
                    if ((S > 7e3 || P > 24576) && O > 423) {
                        u = tn(t, l, 0, w, x, E, k, P, I, h - I, u), P = S = k = 0, I = h;
                        for(var M = 0; M < 286; ++M)x[M] = 0;
                        for(M = 0; M < 30; ++M)E[M] = 0;
                    }
                    var A = 2, j = 0, D = f, L = R - F & 32767;
                    if (O > 2 && C == y(h - L)) for(var N = Math.min(c, O) - 1, U = Math.min(32767, h), z = Math.min(258, O); L <= U && --D && R != F;){
                        if (t[h + A] == t[h + A - L]) {
                            for(var H = 0; H < z && t[h + H] == t[h + H - L]; ++H);
                            if (H > A) {
                                if (A = H, j = L, H > N) break;
                                var B = Math.min(L, H - 2), q = 0;
                                for(M = 0; M < B; ++M){
                                    var W = h - L + M + 32768 & 32767, G = W - g[W] + 32768 & 32767;
                                    G > q && (q = G, F = W);
                                }
                            }
                        }
                        L += (R = F) - (F = g[R]) + 32768 & 32767;
                    }
                    if (j) {
                        w[P++] = 268435456 | As[A] << 18 | js[j];
                        var V = 31 & As[A], J = 31 & js[j];
                        k += Is[V] + Cs[J], ++x[257 + V], ++E[J], T = h + A, ++S;
                    } else w[P++] = t[h], ++x[t[h]];
                }
            }
            u = tn(t, l, n, w, x, E, k, P, I, h - I, u);
        }
        return Gs(a, 0, r + Ws(u) + s);
    }(t, null == i.level ? 6 : i.level, null == i.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + i.mem, e, r, !0);
}, nn = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
};
function on(t, i) {
    void 0 === i && (i = {});
    var e = function() {
        var t = 4294967295;
        return {
            p: function(i) {
                for(var e = t, r = 0; r < i.length; ++r)e = rn[255 & e ^ i[r]] ^ e >>> 8;
                t = e;
            },
            d: function() {
                return 4294967295 ^ t;
            }
        };
    }(), r = t.length;
    e.p(t);
    var s, n = sn(t, i, 10 + ((s = i).filename && s.filename.length + 1 || 0), 8), o = n.length;
    return function(t, i) {
        var e = i.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = i.level < 2 ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && nn(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
            t[3] = 8;
            for(var r = 0; r <= e.length; ++r)t[r + 10] = e.charCodeAt(r);
        }
    }(n, i), nn(n, o - 8, e.d()), nn(n, o - 4, r), n;
}
var an = function(t) {
    var i, e, r, s, n = "";
    for(i = e = 0, r = (t = (t + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, s = 0; s < r; s++){
        var o = t.charCodeAt(s), a = null;
        o < 128 ? e++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), j(a) || (e > i && (n += t.substring(i, e)), n += a, i = e = s + 1);
    }
    return e > i && (n += t.substring(i, t.length)), n;
}, ln = !!u || !!l, un = "text/plain", hn = function(t, i, e) {
    var r;
    void 0 === e && (e = !0);
    var [s, n] = t.split("?"), o = g({}, i), a = null !== (r = null == n ? void 0 : n.split("&").map((t)=>{
        var i, [r, s] = t.split("="), n = e && null !== (i = o[r]) && void 0 !== i ? i : s;
        return delete o[r], r + "=" + n;
    })) && void 0 !== r ? r : [], l = sr(o);
    return l && a.push(l), s + "?" + a.join("&");
}, dn = (t, i)=>JSON.stringify(t, (t, i)=>"bigint" == typeof i ? i.toString() : i, i), vn = (t)=>{
    var { data: i, compression: e } = t;
    if (i) {
        if (e === Ss.GZipJS) {
            var r = on(function(t, i) {
                var e = t.length;
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
                for(var r = new ks(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                    r[s++] = t;
                }, o = 0; o < e; ++o){
                    if (s + 5 > r.length) {
                        var a = new ks(s + 8 + (e - o << 1));
                        a.set(r), r = a;
                    }
                    var l = t.charCodeAt(o);
                    l < 128 || i ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
                }
                return Gs(r, 0, s);
            }(dn(i)), {
                mtime: 0
            }), s = new Blob([
                r
            ], {
                type: un
            });
            return {
                contentType: un,
                body: s,
                estimatedSize: s.size
            };
        }
        if (e === Ss.Base64) {
            var n = function(t) {
                var i, e, r, s, n, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, u = "", h = [];
                if (!t) return t;
                t = an(t);
                do i = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, e = n >> 12 & 63, r = n >> 6 & 63, s = 63 & n, h[l++] = o.charAt(i) + o.charAt(e) + o.charAt(r) + o.charAt(s);
                while (a < t.length);
                switch(u = h.join(""), t.length % 3){
                    case 1:
                        u = u.slice(0, -2) + "==";
                        break;
                    case 2:
                        u = u.slice(0, -1) + "=";
                }
                return u;
            }(dn(i)), o = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : dn(t)))(n);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: o,
                estimatedSize: new Blob([
                    o
                ]).size
            };
        }
        var a = dn(i);
        return {
            contentType: "application/json",
            body: a,
            estimatedSize: new Blob([
                a
            ]).size
        };
    }
}, cn = [];
l && cn.push({
    transport: "fetch",
    method: (t)=>{
        var i, e, { contentType: r, body: s, estimatedSize: n } = null !== (i = vn(t)) && void 0 !== i ? i : {}, o = new Headers;
        Ci(t.headers, function(t, i) {
            o.append(i, t);
        }), r && o.append("Content-Type", r);
        var a = t.url, u = null;
        if (h) {
            var d = new h;
            u = {
                signal: d.signal,
                timeout: setTimeout(()=>d.abort(), t.timeout)
            };
        }
        l(a, g({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: o,
            keepalive: "POST" === t.method && (n || 0) < 52428.8,
            body: s,
            signal: null == (e = u) ? void 0 : e.signal
        }, t.fetchOptions)).then((i)=>i.text().then((e)=>{
                var r = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    r.json = JSON.parse(e);
                } catch (t) {
                    $i.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((i)=>{
            $i.error(i), null == t.callback || t.callback({
                statusCode: 0,
                error: i
            });
        }).finally(()=>u ? clearTimeout(u.timeout) : null);
    }
}), u && cn.push({
    transport: "XHR",
    method: (t)=>{
        var i, e = new u;
        e.open(t.method || "GET", t.url, !0);
        var { contentType: r, body: s } = null !== (i = vn(t)) && void 0 !== i ? i : {};
        Ci(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), t.disableXHRCredentials || (e.withCredentials = !0), e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(s);
    }
}), null != n && n.sendBeacon && cn.push({
    transport: "sendBeacon",
    method: (t)=>{
        var i = hn(t.url, {
            beacon: "1"
        });
        try {
            var e, { contentType: r, body: s } = null !== (e = vn(t)) && void 0 !== e ? e : {}, o = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            n.sendBeacon(i, o);
        } catch (t) {}
    }
});
var fn = function(t, i) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
};
function pn(t, i, e) {
    return dn({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
var gn = {
    exact: (t, i)=>i.some((i)=>t.some((t)=>i === t)),
    is_not: (t, i)=>i.every((i)=>t.every((t)=>i !== t)),
    regex: (t, i)=>i.some((i)=>t.some((t)=>fn(i, t))),
    not_regex: (t, i)=>i.every((i)=>t.every((t)=>!fn(i, t))),
    icontains: (t, i)=>i.map(_n).some((i)=>t.map(_n).some((t)=>i.includes(t))),
    not_icontains: (t, i)=>i.map(_n).every((i)=>t.map(_n).every((t)=>!i.includes(t))),
    gt: (t, i)=>i.some((i)=>{
            var e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e > parseFloat(t));
        }),
    lt: (t, i)=>i.some((i)=>{
            var e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e < parseFloat(t));
        })
}, _n = (t)=>t.toLowerCase();
function mn(t, i) {
    return !t || Object.entries(t).every((t)=>{
        var [e, r] = t, s = null == i ? void 0 : i[e];
        if (O(s) || j(s)) return !1;
        var n = [
            String(s)
        ], o = gn[r.operator];
        return !!o && o(r.values, n);
    });
}
var bn = Si("[Error tracking]");
class yn {
    constructor(t){
        var i, e;
        this.Zt = [], this.ti = new Qt([
            new vi,
            new xi,
            new fi,
            new ci,
            new yi,
            new bi,
            new gi,
            new wi
        ], di()), this._instance = t, this.Zt = null !== (i = null == (e = this._instance.persistence) ? void 0 : e.get_property(Ji)) && void 0 !== i ? i : [];
    }
    onRemoteConfig(t) {
        var i, e, r, s = null !== (i = null == (e = t.errorTracking) ? void 0 : e.suppressionRules) && void 0 !== i ? i : [], n = null == (r = t.errorTracking) ? void 0 : r.captureExtensionExceptions;
        this.Zt = s, this._instance.persistence && this._instance.persistence.register({
            [Ji]: this.Zt,
            [Ki]: n
        });
    }
    get ii() {
        var t, i = !!this._instance.get_property(Ki), e = this._instance.config.error_tracking.captureExtensionExceptions;
        return null !== (t = null != e ? e : i) && void 0 !== t && t;
    }
    buildProperties(t, i) {
        return this.ti.buildFromUnknown(t, {
            syntheticException: null == i ? void 0 : i.syntheticException,
            mechanism: {
                handled: null == i ? void 0 : i.handled
            }
        });
    }
    sendExceptionEvent(t) {
        var i = t.$exception_list;
        if (this.ei(i)) {
            if (this.ri(i)) return void bn.info("Skipping exception capture because a suppression rule matched");
            if (!this.ii && this.si(i)) return void bn.info("Skipping exception capture because it was thrown by an extension");
            if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.ni(i)) return void bn.info("Skipping exception capture because it was thrown by the PostHog SDK");
        }
        return this._instance.capture("$exception", t, {
            _noTruncate: !0,
            _batchKey: "exceptionEvent"
        });
    }
    ri(t) {
        if (0 === t.length) return !1;
        var i = t.reduce((t, i)=>{
            var { type: e, value: r } = i;
            return M(e) && e.length > 0 && t.$exception_types.push(e), M(r) && r.length > 0 && t.$exception_values.push(r), t;
        }, {
            $exception_types: [],
            $exception_values: []
        });
        return this.Zt.some((t)=>{
            var e = t.values.map((t)=>{
                var e, r = gn[t.operator], s = I(t.value) ? t.value : [
                    t.value
                ], n = null !== (e = i[t.key]) && void 0 !== e ? e : [];
                return s.length > 0 && r(s, n);
            });
            return "OR" === t.type ? e.some(Boolean) : e.every(Boolean);
        });
    }
    si(t) {
        return t.flatMap((t)=>{
            var i, e;
            return null !== (i = null == (e = t.stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [];
        }).some((t)=>t.filename && t.filename.startsWith("chrome-extension://"));
    }
    ni(t) {
        if (t.length > 0) {
            var i, e, r, s, n = null !== (i = null == (e = t[0].stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [], o = n[n.length - 1];
            return null !== (r = null == o || null == (s = o.filename) ? void 0 : s.includes("posthog.com/static")) && void 0 !== r && r;
        }
        return !1;
    }
    ei(t) {
        return !D(t) && I(t);
    }
}
var wn = Si("[FeatureFlags]"), xn = Si("[FeatureFlags]", {
    debugEnabled: !0
}), En = "errors_while_computing_flags", $n = "flag_missing", Sn = "quota_limited", kn = "timeout", Pn = "connection_error", Tn = "unknown_error", In = (t)=>"api_error_" + t, Cn = "$active_feature_flags", Rn = "$override_feature_flags", Fn = "$feature_flag_payloads", On = "$override_feature_flag_payloads", Mn = "$feature_flag_request_id", An = "$feature_flag_evaluated_at", jn = (t)=>{
    var i = {};
    for (var [e, r] of Oi(t || {}))r && (i[e] = r);
    return i;
}, Dn = (t)=>{
    var i = t.flags;
    return i ? (t.featureFlags = Object.fromEntries(Object.keys(i).map((t)=>{
        var e;
        return [
            t,
            null !== (e = i[t].variant) && void 0 !== e ? e : i[t].enabled
        ];
    })), t.featureFlagPayloads = Object.fromEntries(Object.keys(i).filter((t)=>i[t].enabled).filter((t)=>{
        var e;
        return null == (e = i[t].metadata) ? void 0 : e.payload;
    }).map((t)=>{
        var e;
        return [
            t,
            null == (e = i[t].metadata) ? void 0 : e.payload
        ];
    }))) : wn.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
}, Ln = function(t) {
    return t.FeatureFlags = "feature_flags", t.Recordings = "recordings", t;
}({});
class Nn {
    constructor(t){
        this.oi = !1, this.ai = !1, this.li = !1, this.ui = !1, this.hi = !1, this.di = !1, this.vi = !1, this.ci = !1, this._instance = t, this.featureFlagEventHandlers = [];
    }
    fi() {
        var t, i = null !== (t = this._instance.config.evaluation_contexts) && void 0 !== t ? t : this._instance.config.evaluation_environments;
        return !this._instance.config.evaluation_environments || this._instance.config.evaluation_contexts || this.ci || (wn.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.ci = !0), null != i && i.length ? i.filter((t)=>{
            var i = t && "string" == typeof t && t.trim().length > 0;
            return i || wn.error("Invalid evaluation context found:", t, "Expected non-empty string"), i;
        }) : [];
    }
    pi() {
        return this.fi().length > 0;
    }
    flags() {
        if (this._instance.config.__preview_remote_config) this.di = !0;
        else {
            var t = !this.gi && (this._instance.config.advanced_disable_feature_flags || this._instance.config.advanced_disable_feature_flags_on_first_load);
            this.mi({
                disableFlags: t
            });
        }
    }
    get hasLoadedFlags() {
        return this.ai;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagsWithDetails() {
        var t = this._instance.get_property(ne), i = this._instance.get_property(Rn), e = this._instance.get_property(On);
        if (!e && !i) return t || {};
        var r = Ri({}, t || {}), s = [
            ...new Set([
                ...Object.keys(e || {}),
                ...Object.keys(i || {})
            ])
        ];
        for (var n of s){
            var o, a, l = r[n], u = null == i ? void 0 : i[n], h = O(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = O(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == e ? void 0 : e[n], c = g({}, l, {
                enabled: h,
                variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
            });
            if (h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v) c.metadata = g({}, null == l ? void 0 : l.metadata, {
                payload: v,
                original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
            });
            r[n] = c;
        }
        return this.oi || (wn.warn(" Overriding feature flag details!", {
            flagDetails: t,
            overriddenPayloads: e,
            finalDetails: r
        }), this.oi = !0), r;
    }
    getFlagVariants() {
        var t = this._instance.get_property(re), i = this._instance.get_property(Rn);
        if (!i) return t || {};
        for(var e = Ri({}, t), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.oi || (wn.warn(" Overriding feature flags!", {
            enabledFlags: t,
            overriddenFlags: i,
            finalFlags: e
        }), this.oi = !0), e;
    }
    getFlagPayloads() {
        var t = this._instance.get_property(Fn), i = this._instance.get_property(On);
        if (!i) return t || {};
        for(var e = Ri({}, t || {}), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.oi || (wn.warn(" Overriding feature flag payloads!", {
            flagPayloads: t,
            overriddenPayloads: i,
            finalPayloads: e
        }), this.oi = !0), e;
    }
    reloadFeatureFlags() {
        this.ui || this._instance.config.advanced_disable_feature_flags || this.gi || (this._instance.bi.emit("featureFlagsReloading", !0), this.gi = setTimeout(()=>{
            this.mi();
        }, 5));
    }
    yi() {
        clearTimeout(this.gi), this.gi = void 0;
    }
    ensureFlagsLoaded() {
        this.ai || this.li || this.gi || this.reloadFeatureFlags();
    }
    setAnonymousDistinctId(t) {
        this.$anon_distinct_id = t;
    }
    setReloadingPaused(t) {
        this.ui = t;
    }
    mi(t) {
        var i;
        if (this.yi(), !this._instance.M()) {
            if (this.li) this.hi = !0;
            else {
                var e = this._instance.config.token, r = this._instance.get_property("$device_id"), s = {
                    token: e,
                    distinct_id: this._instance.get_distinct_id(),
                    groups: this._instance.getGroups(),
                    $anon_distinct_id: this.$anon_distinct_id,
                    person_properties: g({}, (null == (i = this._instance.persistence) ? void 0 : i.get_initial_props()) || {}, this._instance.get_property(oe) || {}),
                    group_properties: this._instance.get_property(ae)
                };
                j(r) || O(r) || (s.$device_id = r), (null != t && t.disableFlags || this._instance.config.advanced_disable_feature_flags) && (s.disable_flags = !0), this.pi() && (s.evaluation_contexts = this.fi());
                var n = this._instance.config.__preview_remote_config, o = n ? "/flags/?v=2" : "/flags/?v=2&config=true", a = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", l = this._instance.requestRouter.endpointFor("flags", o + a);
                n && (s.timezone = fs()), this.li = !0, this._instance._send_request({
                    method: "POST",
                    url: l,
                    data: s,
                    compression: this._instance.config.disable_compression ? void 0 : Ss.Base64,
                    timeout: this._instance.config.feature_flag_request_timeout_ms,
                    callback: (t)=>{
                        var i, e, r, n, o = !0;
                        (200 === t.statusCode && (this.hi || (this.$anon_distinct_id = void 0), o = !1), this.li = !1, this.di) || (this.di = !0, this._instance.wi(null !== (n = t.json) && void 0 !== n ? n : {}));
                        if (!s.disable_flags || this.hi) {
                            this.vi = !o;
                            var a = [];
                            t.error ? t.error instanceof Error ? a.push("AbortError" === t.error.name ? kn : Pn) : a.push(Tn) : 200 !== t.statusCode && a.push(In(t.statusCode)), null != (i = t.json) && i.errorsWhileComputingFlags && a.push(En);
                            var l = !(null == (e = t.json) || null == (e = e.quotaLimited) || !e.includes(Ln.FeatureFlags));
                            if (l && a.push(Sn), null == (r = this._instance.persistence) || r.register({
                                [he]: a
                            }), l) wn.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                            else {
                                var u;
                                if (!s.disable_flags) this.receivedFeatureFlags(null !== (u = t.json) && void 0 !== u ? u : {}, o);
                                this.hi && (this.hi = !1, this.mi());
                            }
                        }
                    }
                });
            }
        }
    }
    getFeatureFlag(t, i) {
        var e;
        if (void 0 === i && (i = {}), this.ai || this.getFlags() && this.getFlags().length > 0) {
            var r = this.getFeatureFlagResult(t, i);
            return null !== (e = null == r ? void 0 : r.variant) && void 0 !== e ? e : null == r ? void 0 : r.enabled;
        }
        wn.warn('getFeatureFlag for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getFeatureFlagDetails(t) {
        return this.getFlagsWithDetails()[t];
    }
    getFeatureFlagPayload(t) {
        var i = this.getFeatureFlagResult(t, {
            send_event: !1
        });
        return null == i ? void 0 : i.payload;
    }
    getFeatureFlagResult(t, i) {
        if (void 0 === i && (i = {}), this.ai || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFlagVariants(), r = t in e, s = e[t], n = this.getFlagPayloads()[t], o = String(s), a = this._instance.get_property(Mn) || void 0, l = this._instance.get_property(An) || void 0, u = this._instance.get_property(ue) || {};
            if ((i.send_event || !("send_event" in i)) && (!(t in u) || !u[t].includes(o))) {
                var h, d, v, c, f, p, g, _, m, b;
                I(u[t]) ? u[t].push(o) : u[t] = [
                    o
                ], null == (h = this._instance.persistence) || h.register({
                    [ue]: u
                });
                var y = this.getFeatureFlagDetails(t), w = [
                    ...null !== (d = this._instance.get_property(he)) && void 0 !== d ? d : []
                ];
                O(s) && w.push($n);
                var x = {
                    $feature_flag: t,
                    $feature_flag_response: s,
                    $feature_flag_payload: n || null,
                    $feature_flag_request_id: a,
                    $feature_flag_evaluated_at: l,
                    $feature_flag_bootstrapped_response: (null == (v = this._instance.config.bootstrap) || null == (v = v.featureFlags) ? void 0 : v[t]) || null,
                    $feature_flag_bootstrapped_payload: (null == (c = this._instance.config.bootstrap) || null == (c = c.featureFlagPayloads) ? void 0 : c[t]) || null,
                    $used_bootstrap_value: !this.vi
                };
                O(null == y || null == (f = y.metadata) ? void 0 : f.version) || (x.$feature_flag_version = y.metadata.version);
                var E, S = null !== (p = null == y || null == (g = y.reason) ? void 0 : g.description) && void 0 !== p ? p : null == y || null == (_ = y.reason) ? void 0 : _.code;
                if (S && (x.$feature_flag_reason = S), null != y && null != (m = y.metadata) && m.id && (x.$feature_flag_id = y.metadata.id), O(null == y ? void 0 : y.original_variant) && O(null == y ? void 0 : y.original_enabled) || (x.$feature_flag_original_response = O(y.original_variant) ? y.original_enabled : y.original_variant), null != y && null != (b = y.metadata) && b.original_payload) x.$feature_flag_original_payload = null == y || null == (E = y.metadata) ? void 0 : E.original_payload;
                w.length && (x.$feature_flag_error = w.join(",")), this._instance.capture("$feature_flag_called", x);
            }
            if (r) {
                var k = n;
                if (!O(n)) try {
                    k = JSON.parse(n);
                } catch (t) {}
                return {
                    key: t,
                    enabled: !!s,
                    variant: "string" == typeof s ? s : void 0,
                    payload: k
                };
            }
        } else wn.warn('getFeatureFlagResult for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getRemoteConfigPayload(t, i) {
        var e = this._instance.config.token, r = {
            distinct_id: this._instance.get_distinct_id(),
            token: e
        };
        this.pi() && (r.evaluation_contexts = this.fi()), this._instance._send_request({
            method: "POST",
            url: this._instance.requestRouter.endpointFor("flags", "/flags/?v=2&config=true"),
            data: r,
            compression: this._instance.config.disable_compression ? void 0 : Ss.Base64,
            timeout: this._instance.config.feature_flag_request_timeout_ms,
            callback: (e)=>{
                var r, s = null == (r = e.json) ? void 0 : r.featureFlagPayloads;
                i((null == s ? void 0 : s[t]) || void 0);
            }
        });
    }
    isFeatureEnabled(t, i) {
        if (void 0 === i && (i = {}), this.ai || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFeatureFlag(t, i);
            return O(e) ? void 0 : !!e;
        }
        wn.warn('isFeatureEnabled for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers.push(t);
    }
    removeFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
    }
    receivedFeatureFlags(t, i) {
        if (this._instance.persistence) {
            this.ai = !0;
            var e = this.getFlagVariants(), r = this.getFlagPayloads(), s = this.getFlagsWithDetails();
            !function(t, i, e, r, s) {
                void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                var n = Dn(t), o = n.flags, a = n.featureFlags, l = n.featureFlagPayloads;
                if (a) {
                    var u = t.requestId, h = t.evaluatedAt;
                    if (I(a)) {
                        wn.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                        var d = {};
                        if (a) for(var v = 0; v < a.length; v++)d[a[v]] = !0;
                        i && i.register({
                            [Cn]: a,
                            [re]: d
                        });
                    } else {
                        var c = a, f = l, p = o;
                        if (t.errorsWhileComputingFlags) {
                            if (o) {
                                var _ = new Set(Object.keys(o).filter((t)=>{
                                    var i;
                                    return !(null != (i = o[t]) && i.failed);
                                }));
                                c = g({}, e, Object.fromEntries(Object.entries(c).filter((t)=>{
                                    var [i] = t;
                                    return _.has(i);
                                }))), f = g({}, r, Object.fromEntries(Object.entries(f || {}).filter((t)=>{
                                    var [i] = t;
                                    return _.has(i);
                                }))), p = g({}, s, Object.fromEntries(Object.entries(p || {}).filter((t)=>{
                                    var [i] = t;
                                    return _.has(i);
                                })));
                            } else c = g({}, e, c), f = g({}, r, f), p = g({}, s, p);
                        }
                        i && i.register(g({
                            [Cn]: Object.keys(jn(c)),
                            [re]: c || {},
                            [Fn]: f || {},
                            [ne]: p || {}
                        }, u ? {
                            [Mn]: u
                        } : {}, h ? {
                            [An]: h
                        } : {}));
                    }
                }
            }(t, this._instance.persistence, e, r, s), this.xi(i);
        }
    }
    override(t, i) {
        void 0 === i && (i = !1), wn.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
            flags: t,
            suppressWarning: i
        });
    }
    overrideFeatureFlags(t) {
        if (!this._instance.__loaded || !this._instance.persistence) return wn.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
        if (!1 === t) return this._instance.persistence.unregister(Rn), this._instance.persistence.unregister(On), this.xi(), xn.info("All overrides cleared");
        if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
            var i, e = t;
            if (this.oi = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i), "flags" in e) {
                if (!1 === e.flags) this._instance.persistence.unregister(Rn), xn.info("Flag overrides cleared");
                else if (e.flags) {
                    if (I(e.flags)) {
                        for(var r = {}, s = 0; s < e.flags.length; s++)r[e.flags[s]] = !0;
                        this._instance.persistence.register({
                            [Rn]: r
                        });
                    } else this._instance.persistence.register({
                        [Rn]: e.flags
                    });
                    xn.info("Flag overrides set", {
                        flags: e.flags
                    });
                }
            }
            return "payloads" in e && (!1 === e.payloads ? (this._instance.persistence.unregister(On), xn.info("Payload overrides cleared")) : e.payloads && (this._instance.persistence.register({
                [On]: e.payloads
            }), xn.info("Payload overrides set", {
                payloads: e.payloads
            }))), void this.xi();
        }
        this.xi();
    }
    onFeatureFlags(t) {
        if (this.addFeatureFlagsHandler(t), this.ai) {
            var { flags: i, flagVariants: e } = this.Ei();
            t(i, e);
        }
        return ()=>this.removeFeatureFlagsHandler(t);
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        var r, s = (this._instance.get_property(se) || []).find((i)=>i.flagKey === t), n = {
            ["$feature_enrollment/" + t]: i
        }, o = {
            $feature_flag: t,
            $feature_enrollment: i,
            $set: n
        };
        s && (o.$early_access_feature_name = s.name), e && (o.$feature_enrollment_stage = e), this._instance.capture("$feature_enrollment_update", o), this.setPersonPropertiesForFlags(n, !1);
        var a = g({}, this.getFlagVariants(), {
            [t]: i
        });
        null == (r = this._instance.persistence) || r.register({
            [Cn]: Object.keys(jn(a)),
            [re]: a
        }), this.xi();
    }
    getEarlyAccessFeatures(t, i, e) {
        void 0 === i && (i = !1);
        var r = this._instance.get_property(se), s = e ? "&" + e.map((t)=>"stage=" + t).join("&") : "";
        if (r && !i) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + s),
            method: "GET",
            callback: (i)=>{
                var e, r;
                if (i.json) {
                    var s = i.json.earlyAccessFeatures;
                    return null == (e = this._instance.persistence) || e.unregister(se), null == (r = this._instance.persistence) || r.register({
                        [se]: s
                    }), t(s);
                }
            }
        });
    }
    Ei() {
        var t = this.getFlags(), i = this.getFlagVariants();
        return {
            flags: t.filter((t)=>i[t]),
            flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
        };
    }
    xi(t) {
        var { flags: i, flagVariants: e } = this.Ei();
        this.featureFlagEventHandlers.forEach((r)=>r(i, e, {
                errorsLoading: t
            }));
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property(oe) || {};
        this._instance.register({
            [oe]: g({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this._instance.unregister(oe);
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property(ae) || {};
        0 !== Object.keys(e).length && Object.keys(e).forEach((i)=>{
            e[i] = g({}, e[i], t[i]), delete t[i];
        }), this._instance.register({
            [ae]: g({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(t) {
        if (t) {
            var i = this._instance.get_property(ae) || {};
            this._instance.register({
                [ae]: g({}, i, {
                    [t]: {}
                })
            });
        } else this._instance.unregister(ae);
    }
    reset() {
        this.ai = !1, this.li = !1, this.ui = !1, this.hi = !1, this.di = !1, this.vi = !1, this.$anon_distinct_id = void 0, this.yi(), this.oi = !1;
    }
}
var Un = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class zn {
    constructor(t, i){
        this.R = t, this.props = {}, this.$i = !1, this.Si = ((t)=>{
            var i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(t), this.Y = this.ki(t), this.load(), t.debug && $i.info("Persistence loaded", t.persistence, g({}, this.props)), this.update_config(t, t, i), this.save();
    }
    isDisabled() {
        return !!this.Pi;
    }
    ki(i) {
        -1 === Un.indexOf(i.persistence.toLowerCase()) && ($i.critical("Unknown persistence type " + i.persistence + "; falling back to localStorage+cookie"), i.persistence = "localStorage+cookie");
        var e = function(i) {
            void 0 === i && (i = []);
            var e = [
                ...Ir,
                ...i
            ];
            return g({}, Tr, {
                W: function(t) {
                    try {
                        var i = {};
                        try {
                            i = kr.W(t) || {};
                        } catch (t) {}
                        var e = Ri(i, JSON.parse(Tr.q(t) || "{}"));
                        return Tr.G(t, e), e;
                    } catch (t) {}
                    return null;
                },
                G: function(t, i, r, s, n, o) {
                    try {
                        Tr.G(t, i, void 0, void 0, o);
                        var a = {};
                        e.forEach((t)=>{
                            i[t] && (a[t] = i[t]);
                        }), Object.keys(a).length && kr.G(t, a, r, s, n, o);
                    } catch (t) {
                        Tr.B(t);
                    }
                },
                V: function(i, e) {
                    try {
                        null == t || t.localStorage.removeItem(i), kr.V(i, e);
                    } catch (t) {
                        Tr.B(t);
                    }
                }
            });
        }(i.cookie_persisted_properties || []), r = i.persistence.toLowerCase();
        return "localstorage" === r && Tr.H() ? Tr : "localstorage+cookie" === r && e.H() ? e : "sessionstorage" === r && Or.H() ? Or : "memory" === r ? Rr : "cookie" === r ? kr : e.H() ? e : kr;
    }
    properties() {
        var t = {};
        return Ci(this.props, function(i, e) {
            if (e === re && R(i)) for(var r = Object.keys(i), n = 0; n < r.length; n++)t["$feature/" + r[n]] = i[r[n]];
            else a = e, l = !1, (j(o = ye) ? l : s && o.indexOf === s ? -1 != o.indexOf(a) : (Ci(o, function(t) {
                if (l || (l = t === a)) return Ti;
            }), l)) || (t[e] = i);
            var o, a, l;
        }), t;
    }
    load() {
        if (!this.Pi) {
            var t = this.Y.W(this.Si);
            t && (this.props = Ri({}, t));
        }
    }
    save() {
        this.Pi || this.Y.G(this.Si, this.props, this.Ti, this.Ii, this.Ci, this.R.debug);
    }
    remove() {
        this.Y.V(this.Si, !1), this.Y.V(this.Si, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if (R(t)) {
            O(i) && (i = "None"), this.Ti = O(e) ? this.Ri : e;
            var r = !1;
            if (Ci(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.props[e] = t, r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if (R(t)) {
            this.Ti = O(i) ? this.Ri : i;
            var e = !1;
            if (Ci(t, (i, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== i && (this.props[r] = i, e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (delete this.props[t], this.save());
    }
    update_campaign_params() {
        if (!this.$i) {
            var t = as(this.R.custom_campaign_params, this.R.mask_personal_data_properties, this.R.custom_personal_data_properties);
            F(ji(t)) || this.register(t), this.$i = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == o ? void 0 : o.referrer) ? us(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: ds(),
            $referring_domain: null != o && o.referrer && (null == (t = rr(o.referrer)) ? void 0 : t.host) || "$direct"
        }, void 0);
    }
    set_initial_person_info() {
        this.props[fe] || this.props[pe] || this.register_once({
            [ge]: vs(this.R.mask_personal_data_properties, this.R.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        Ci([
            pe,
            fe
        ], (i)=>{
            var e = this.props[i];
            e && Ci(e, function(i, e) {
                t["$initial_" + E(e)] = i;
            });
        });
        var i, e, r = this.props[ge];
        if (r) {
            var s = (i = cs(r), e = {}, Ci(i, function(t, i) {
                e["$initial_" + E(i)] = t;
            }), e);
            Ri(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return Ci(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i, e) {
        if (this.Ri = this.Ti = t.cookie_expiration, this.set_disabled(t.disable_persistence || !!e), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== i.persistence || !((t, i)=>{
            if (t.length !== i.length) return !1;
            var e = [
                ...t
            ].sort(), r = [
                ...i
            ].sort();
            return e.every((t, i)=>t === r[i]);
        })(t.cookie_persisted_properties || [], i.cookie_persisted_properties || [])) {
            var r = this.ki(t), s = this.props;
            this.clear(), this.Y = r, this.props = s, this.save();
        }
    }
    set_disabled(t) {
        this.Pi = t, this.Pi ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ii && (this.Ii = t, this.remove(), this.save());
    }
    set_secure(t) {
        t !== this.Ci && (this.Ci = t, this.remove(), this.save());
    }
    set_event_timer(t, i) {
        var e = this.props[qi] || {};
        e[t] = i, this.props[qi] = e, this.save();
    }
    remove_event_timer(t) {
        var i = (this.props[qi] || {})[t];
        return O(i) || (delete this.props[qi][t], this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.props[t] = i, this.save();
    }
}
var Hn = Si("[Product Tours]"), Bn = "ph_product_tours";
class qn {
    constructor(t){
        this.Fi = null, this.Oi = null, this._instance = t;
    }
    onRemoteConfig(t) {
        this._instance.persistence && this._instance.persistence.register({
            [Qi]: !(null == t || !t.productTours)
        }), this.loadIfEnabled();
    }
    loadIfEnabled() {
        var t, i;
        this.Fi || (t = this._instance).config.disable_product_tours || null == (i = t.persistence) || !i.get_property(Qi) || this.it(()=>this.Mi());
    }
    it(t) {
        var i, e;
        null != (i = v.__PosthogExtensions__) && i.generateProductTours ? t() : null == (e = v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "product-tours", (i)=>{
            i ? Hn.error("Could not load product tours script", i) : t();
        });
    }
    Mi() {
        var t;
        !this.Fi && null != (t = v.__PosthogExtensions__) && t.generateProductTours && (this.Fi = v.__PosthogExtensions__.generateProductTours(this._instance, !0));
    }
    getProductTours(t, i) {
        if (void 0 === i && (i = !1), !I(this.Oi) || i) {
            var e = this._instance.persistence;
            if (e) {
                var r = e.props[Bn];
                if (I(r) && !i) return this.Oi = r, void t(r, {
                    isLoaded: !0
                });
            }
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/product_tours/?token=" + this._instance.config.token),
                method: "GET",
                callback: (i)=>{
                    var r = i.statusCode;
                    if (200 !== r || !i.json) {
                        var s = "Product Tours API could not be loaded, status: " + r;
                        return Hn.error(s), void t([], {
                            isLoaded: !1,
                            error: s
                        });
                    }
                    var n = I(i.json.product_tours) ? i.json.product_tours : [];
                    this.Oi = n, e && e.register({
                        [Bn]: n
                    }), t(n, {
                        isLoaded: !0
                    });
                }
            });
        } else t(this.Oi, {
            isLoaded: !0
        });
    }
    getActiveProductTours(t) {
        D(this.Fi) ? t([], {
            isLoaded: !1,
            error: "Product tours not loaded"
        }) : this.Fi.getActiveProductTours(t);
    }
    showProductTour(t) {
        var i;
        null == (i = this.Fi) || i.showTourById(t);
    }
    previewTour(t) {
        this.Fi ? this.Fi.previewTour(t) : this.it(()=>{
            var i;
            this.Mi(), null == (i = this.Fi) || i.previewTour(t);
        });
    }
    dismissProductTour() {
        var t;
        null == (t = this.Fi) || t.dismissTour("user_clicked_skip");
    }
    nextStep() {
        var t;
        null == (t = this.Fi) || t.nextStep();
    }
    previousStep() {
        var t;
        null == (t = this.Fi) || t.previousStep();
    }
    clearCache() {
        var t;
        this.Oi = null, null == (t = this._instance.persistence) || t.unregister(Bn);
    }
    resetTour(t) {
        var i;
        null == (i = this.Fi) || i.resetTour(t);
    }
    resetAllTours() {
        var t;
        null == (t = this.Fi) || t.resetAllTours();
    }
    cancelPendingTour(t) {
        var i;
        null == (i = this.Fi) || i.cancelPendingTour(t);
    }
}
var Wn = function(t) {
    return t.Activation = "events", t.Cancellation = "cancelEvents", t;
}({}), Gn = function(t) {
    return t.Button = "button", t.Tab = "tab", t.Selector = "selector", t;
}({}), Vn = function(t) {
    return t.TopLeft = "top_left", t.TopRight = "top_right", t.TopCenter = "top_center", t.MiddleLeft = "middle_left", t.MiddleRight = "middle_right", t.MiddleCenter = "middle_center", t.Left = "left", t.Center = "center", t.Right = "right", t.NextToTrigger = "next_to_trigger", t;
}({}), Jn = function(t) {
    return t.Top = "top", t.Left = "left", t.Right = "right", t.Bottom = "bottom", t;
}({}), Kn = function(t) {
    return t.Popover = "popover", t.API = "api", t.Widget = "widget", t.ExternalSurvey = "external_survey", t;
}({}), Yn = function(t) {
    return t.Open = "open", t.MultipleChoice = "multiple_choice", t.SingleChoice = "single_choice", t.Rating = "rating", t.Link = "link", t;
}({}), Xn = function(t) {
    return t.NextQuestion = "next_question", t.End = "end", t.ResponseBased = "response_based", t.SpecificQuestion = "specific_question", t;
}({}), Qn = function(t) {
    return t.Once = "once", t.Recurring = "recurring", t.Always = "always", t;
}({}), Zn = function(t) {
    return t.SHOWN = "survey shown", t.DISMISSED = "survey dismissed", t.SENT = "survey sent", t.ABANDONED = "survey abandoned", t;
}({}), to = function(t) {
    return t.SURVEY_ID = "$survey_id", t.SURVEY_NAME = "$survey_name", t.SURVEY_RESPONSE = "$survey_response", t.SURVEY_ITERATION = "$survey_iteration", t.SURVEY_ITERATION_START_DATE = "$survey_iteration_start_date", t.SURVEY_PARTIALLY_COMPLETED = "$survey_partially_completed", t.SURVEY_SUBMISSION_ID = "$survey_submission_id", t.SURVEY_QUESTIONS = "$survey_questions", t.SURVEY_COMPLETED = "$survey_completed", t.PRODUCT_TOUR_ID = "$product_tour_id", t.SURVEY_LAST_SEEN_DATE = "$survey_last_seen_date", t;
}({}), io = function(t) {
    return t.Popover = "popover", t.Inline = "inline", t;
}({}), eo = Si("[Surveys]");
var ro = "seenSurvey_", so = (t, i)=>{
    var e = "$survey_" + i + "/" + t.id;
    return t.current_iteration && t.current_iteration > 0 && (e = "$survey_" + i + "/" + t.id + "/" + t.current_iteration), e;
}, no = (t)=>((t, i)=>{
        var e = "" + t + i.id;
        return i.current_iteration && i.current_iteration > 0 && (e = "" + t + i.id + "_" + i.current_iteration), e;
    })(ro, t), oo = [
    Kn.Popover,
    Kn.Widget,
    Kn.API
], ao = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: io.Popover
};
class lo {
    constructor(){
        this.Ai = {}, this.Ai = {};
    }
    on(t, i) {
        return this.Ai[t] || (this.Ai[t] = []), this.Ai[t].push(i), ()=>{
            this.Ai[t] = this.Ai[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (var e of this.Ai[t] || [])e(i);
        for (var r of this.Ai["*"] || [])r(t, i);
    }
}
function uo(t, i, e) {
    if (D(t)) return !1;
    switch(e){
        case "exact":
            return t === i;
        case "contains":
            var r = i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
            return new RegExp(r, "i").test(t);
        case "regex":
            try {
                return new RegExp(i).test(t);
            } catch (t) {
                return !1;
            }
        default:
            return !1;
    }
}
class ho {
    constructor(t){
        this.ji = new lo, this.Di = (t, i)=>this.Li(t, i) && this.Ni(t, i) && this.Ui(t, i) && this.zi(t, i), this.Li = (t, i)=>null == i || !i.event || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event), this._instance = t, this.Hi = new Set, this.Bi = new Set;
    }
    init() {
        var t;
        if (!O(null == (t = this._instance) ? void 0 : t._addCaptureHook)) {
            var i;
            null == (i = this._instance) || i._addCaptureHook((t, i)=>{
                this.on(t, i);
            });
        }
    }
    register(t) {
        var i, e;
        if (!O(null == (i = this._instance) ? void 0 : i._addCaptureHook) && (t.forEach((t)=>{
            var i, e;
            null == (i = this.Bi) || i.add(t), null == (e = t.steps) || e.forEach((t)=>{
                var i;
                null == (i = this.Hi) || i.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (e = this._instance) && e.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var i;
                null == (i = t.steps) || i.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, i) {
        var e;
        null != i && 0 != t.length && (this.Hi.has(t) || this.Hi.has(null == i ? void 0 : i.event)) && this.Bi && (null == (e = this.Bi) ? void 0 : e.size) > 0 && this.Bi.forEach((t)=>{
            this.qi(i, t) && this.ji.emit("actionCaptured", t.name);
        });
    }
    Wi(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    qi(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (var e of i.steps)if (this.Di(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.ji.on(t, i);
    }
    Ni(t, i) {
        if (null != i && i.url) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!uo(r, i.url, i.url_matching || "contains")) return !1;
        }
        return !0;
    }
    Ui(t, i) {
        return !!this.Gi(t, i) && !!this.Vi(t, i) && !!this.Ji(t, i);
    }
    Gi(t, i) {
        var e;
        if (null == i || !i.href) return !0;
        var r = this.Ki(t);
        if (r.length > 0) return r.some((t)=>uo(t.href, i.href, i.href_matching || "exact"));
        var s, n = (null == t || null == (e = t.properties) ? void 0 : e.$elements_chain) || "";
        return !!n && uo((s = n.match(/(?::|")href="(.*?)"/)) ? s[1] : "", i.href, i.href_matching || "exact");
    }
    Vi(t, i) {
        var e;
        if (null == i || !i.text) return !0;
        var r = this.Ki(t);
        if (r.length > 0) return r.some((t)=>uo(t.text, i.text, i.text_matching || "exact") || uo(t.$el_text, i.text, i.text_matching || "exact"));
        var s, n, o, a = (null == t || null == (e = t.properties) ? void 0 : e.$elements_chain) || "";
        return !!a && (s = function(t) {
            for(var i, e = [], r = /(?::|")text="(.*?)"/g; !D(i = r.exec(t));)e.includes(i[1]) || e.push(i[1]);
            return e;
        }(a), n = i.text, o = i.text_matching || "exact", s.some((t)=>uo(t, n, o)));
    }
    Ji(t, i) {
        var e, r;
        if (null == i || !i.selector) return !0;
        var s = null == t || null == (e = t.properties) ? void 0 : e.$element_selectors;
        if (null != s && s.includes(i.selector)) return !0;
        var n = (null == t || null == (r = t.properties) ? void 0 : r.$elements_chain) || "";
        if (i.selector_regex && n) try {
            return new RegExp(i.selector_regex).test(n);
        } catch (t) {
            return !1;
        }
        return !1;
    }
    Ki(t) {
        var i;
        return null == (null == t || null == (i = t.properties) ? void 0 : i.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
    zi(t, i) {
        return null == i || !i.properties || 0 === i.properties.length || mn(i.properties.reduce((t, i)=>{
            var e = I(i.value) ? i.value.map(String) : null != i.value ? [
                String(i.value)
            ] : [];
            return t[i.key] = {
                values: e,
                operator: i.operator || "exact"
            }, t;
        }, {}), null == t ? void 0 : t.properties);
    }
}
class vo {
    constructor(t){
        this._instance = t, this.Yi = new Map, this.Xi = new Map, this.Qi = new Map;
    }
    Zi(t, i) {
        return !!t && mn(t.propertyFilters, null == i ? void 0 : i.properties);
    }
    te(t, i) {
        var e = new Map;
        return t.forEach((t)=>{
            var r;
            null == (r = t.conditions) || null == (r = r[i]) || null == (r = r.values) || r.forEach((i)=>{
                if (null != i && i.name) {
                    var r = e.get(i.name) || [];
                    r.push(t.id), e.set(i.name, r);
                }
            });
        }), e;
    }
    ie(t, i, e) {
        var r = (e === Wn.Activation ? this.Yi : this.Xi).get(t), s = [];
        return this.ee((t)=>{
            s = t.filter((t)=>null == r ? void 0 : r.includes(t.id));
        }), s.filter((r)=>{
            var s, n = null == (s = r.conditions) || null == (s = s[e]) || null == (s = s.values) ? void 0 : s.find((i)=>i.name === t);
            return this.Zi(n, i);
        });
    }
    register(t) {
        var i;
        O(null == (i = this._instance) ? void 0 : i._addCaptureHook) || (this.re(t), this.se(t));
    }
    se(t) {
        var i = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.actions) && (null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== i.length) {
            if (null == this.ne) {
                this.ne = new ho(this._instance), this.ne.init();
                this.ne.Wi((t)=>{
                    this.onAction(t);
                });
            }
            i.forEach((t)=>{
                var i, e, r, s, n;
                t.conditions && null != (i = t.conditions) && i.actions && null != (e = t.conditions) && null != (e = e.actions) && e.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.ne) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((i)=>{
                    if (i && i.name) {
                        var e = this.Qi.get(i.name);
                        e && e.push(t.id), this.Qi.set(i.name, e || [
                            t.id
                        ]);
                    }
                }));
            });
        }
    }
    re(t) {
        var i, e = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.events) && (null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) ? void 0 : e.length) > 0;
        }), r = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.cancelEvents) && (null == (e = t.conditions) || null == (e = e.cancelEvents) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== e.length || 0 !== r.length) null == (i = this._instance) || i._addCaptureHook((t, i)=>{
            this.onEvent(t, i);
        }), this.Yi = this.te(t, Wn.Activation), this.Xi = this.te(t, Wn.Cancellation);
    }
    onEvent(t, i) {
        var e, r = this.oe(), s = this.ae(), n = this.le(), o = (null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[s]) || [];
        if (n === t && i && o.length > 0) {
            var a, l;
            r.info("event matched, removing item from activated items", {
                event: t,
                eventPayload: i,
                existingActivatedItems: o
            });
            var u = (null == i || null == (a = i.properties) ? void 0 : a.$survey_id) || (null == i || null == (l = i.properties) ? void 0 : l.$product_tour_id);
            if (u) {
                var h = o.indexOf(u);
                h >= 0 && (o.splice(h, 1), this.ue(o));
            }
        } else {
            if (this.Xi.has(t)) {
                var d = this.ie(t, i, Wn.Cancellation);
                d.length > 0 && (r.info("cancel event matched, cancelling items", {
                    event: t,
                    itemsToCancel: d.map((t)=>t.id)
                }), d.forEach((t)=>{
                    var i = o.indexOf(t.id);
                    i >= 0 && o.splice(i, 1), this.he(t.id);
                }), this.ue(o));
            }
            if (this.Yi.has(t)) {
                r.info("event name matched", {
                    event: t,
                    eventPayload: i,
                    items: this.Yi.get(t)
                });
                var v = this.ie(t, i, Wn.Activation);
                this.ue(o.concat(v.map((t)=>t.id) || []));
            }
        }
    }
    onAction(t) {
        var i, e = this.ae(), r = (null == (i = this._instance) || null == (i = i.persistence) ? void 0 : i.props[e]) || [];
        this.Qi.has(t) && this.ue(r.concat(this.Qi.get(t) || []));
    }
    ue(t) {
        var i, e = this.oe(), r = this.ae(), s = [
            ...new Set(t)
        ].filter((t)=>!this.de(t));
        e.info("updating activated items", {
            activatedItems: s
        }), null == (i = this._instance) || null == (i = i.persistence) || i.register({
            [r]: s
        });
    }
    getActivatedIds() {
        var t, i = this.ae(), e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[i];
        return e || [];
    }
    getEventToItemsMap() {
        return this.Yi;
    }
    ve() {
        return this.ne;
    }
}
class co extends vo {
    constructor(t){
        super(t);
    }
    ae() {
        return "$surveys_activated";
    }
    le() {
        return Zn.SHOWN;
    }
    ee(t) {
        var i;
        null == (i = this._instance) || i.getSurveys(t);
    }
    he(t) {
        var i;
        null == (i = this._instance) || i.cancelPendingSurvey(t);
    }
    oe() {
        return eo;
    }
    de() {
        return !1;
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}
class fo {
    constructor(t){
        this.ce = void 0, this._surveyManager = null, this.fe = !1, this.pe = [], this.ge = null, this._instance = t, this._surveyEventReceiver = null;
    }
    onRemoteConfig(t) {
        if (!this._instance.config.disable_surveys) {
            var i = t.surveys;
            if (D(i)) return eo.warn("Flags not loaded yet. Not loading surveys.");
            var e = I(i);
            this.ce = e ? i.length > 0 : i, eo.info("flags response received, isSurveysEnabled: " + this.ce), this.loadIfEnabled();
        }
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        for(var t = [], i = 0; i < localStorage.length; i++){
            var e = localStorage.key(i);
            (null != e && e.startsWith(ro) || null != e && e.startsWith("inProgressSurvey_")) && t.push(e);
        }
        t.forEach((t)=>localStorage.removeItem(t));
    }
    loadIfEnabled() {
        if (!this._surveyManager) {
            if (this.fe) eo.info("Already initializing surveys, skipping...");
            else if (this._instance.config.disable_surveys) eo.info("Disabled. Not loading surveys.");
            else if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) eo.info("Not loading surveys in cookieless mode without consent.");
            else {
                var t = null == v ? void 0 : v.__PosthogExtensions__;
                if (t) {
                    if (!O(this.ce) || this._instance.config.advanced_enable_surveys) {
                        var i = this.ce || this._instance.config.advanced_enable_surveys;
                        this.fe = !0;
                        try {
                            var e = t.generateSurveys;
                            if (e) return void this._e(e, i);
                            var r = t.loadExternalDependency;
                            if (!r) return void this.me("PostHog loadExternalDependency extension not found.");
                            r(this._instance, "surveys", (e)=>{
                                e || !t.generateSurveys ? this.me("Could not load surveys script", e) : this._e(t.generateSurveys, i);
                            });
                        } catch (t) {
                            throw this.me("Error initializing surveys", t), t;
                        } finally{
                            this.fe = !1;
                        }
                    }
                } else eo.error("PostHog Extensions not found.");
            }
        }
    }
    _e(t, i) {
        this._surveyManager = t(this._instance, i), this._surveyEventReceiver = new co(this._instance), eo.info("Surveys loaded successfully"), this.be({
            isLoaded: !0
        });
    }
    me(t, i) {
        eo.error(t, i), this.be({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.pe.push(t), this._surveyManager && this.be({
            isLoaded: !0
        }), ()=>{
            this.pe = this.pe.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i) {
        if (void 0 === i && (i = !1), this._instance.config.disable_surveys) return eo.info("Disabled. Not loading surveys."), t([]);
        var e, r = this._instance.get_property(le);
        if (r && !i) return t(r, {
            isLoaded: !0
        });
        "undefined" != typeof Promise && this.ge ? this.ge.then((i)=>{
            var { surveys: e, context: r } = i;
            return t(e, r);
        }) : ("undefined" != typeof Promise && (this.ge = new Promise((t)=>{
            e = t;
        })), this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token),
            method: "GET",
            timeout: this._instance.config.surveys_request_timeout_ms,
            callback: (i)=>{
                var r;
                this.ge = null;
                var s = i.statusCode;
                if (200 !== s || !i.json) {
                    var n = "Surveys API could not be loaded, status: " + s;
                    eo.error(n);
                    var o = {
                        isLoaded: !1,
                        error: n
                    };
                    return t([], o), void (null == e || e({
                        surveys: [],
                        context: o
                    }));
                }
                var a, l = i.json.surveys || [], u = l.filter((t)=>(function(t) {
                        return !(!t.start_date || t.end_date);
                    })(t) && (function(t) {
                        var i;
                        return !(null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || !i.length);
                    }(t) || function(t) {
                        var i;
                        return !(null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) || !i.length);
                    }(t)));
                u.length > 0 && (null == (a = this._surveyEventReceiver) || a.register(u));
                null == (r = this._instance.persistence) || r.register({
                    [le]: l
                });
                var h = {
                    isLoaded: !0
                };
                t(l, h), null == e || e({
                    surveys: l,
                    context: h
                });
            }
        }));
    }
    be(t) {
        for (var i of this.pe)try {
            if (!t.isLoaded) return i([], t);
            this.getSurveys(i);
        } catch (t) {
            eo.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i) {
        if (void 0 === i && (i = !1), !D(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, i);
        eo.warn("init was not called");
    }
    ye(t) {
        var i = null;
        return this.getSurveys((e)=>{
            var r;
            i = null !== (r = e.find((i)=>i.id === t)) && void 0 !== r ? r : null;
        }), i;
    }
    we(t) {
        if (D(this._surveyManager)) return {
            eligible: !1,
            reason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = "string" == typeof t ? this.ye(t) : t;
        return i ? this._surveyManager.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if (D(this._surveyManager)) return eo.warn("init was not called"), {
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = this.we(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return D(this._surveyManager) ? (eo.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var r, s = null !== (r = i.find((i)=>i.id === t)) && void 0 !== r ? r : null;
                if (s) {
                    var n = this.we(s);
                    e({
                        visible: n.eligible,
                        disabledReason: n.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i, e) {
        var r;
        if (D(this._surveyManager)) eo.warn("init was not called");
        else {
            var s = "string" == typeof t ? this.ye(t) : t;
            if (null != s && s.id) {
                if (oo.includes(s.type)) {
                    var n = null == o ? void 0 : o.querySelector(i);
                    if (n) return null != (r = s.appearance) && r.surveyPopupDelaySeconds ? (eo.info("Rendering survey " + s.id + " with delay of " + s.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(()=>{
                        var t, i;
                        eo.info("Rendering survey " + s.id + " with delay of " + (null == (t = s.appearance) ? void 0 : t.surveyPopupDelaySeconds) + " seconds"), null == (i = this._surveyManager) || i.renderSurvey(s, n, e), eo.info("Survey " + s.id + " rendered");
                    }, 1e3 * s.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(s, n, e);
                    eo.warn("Survey element not found");
                } else eo.warn("Surveys of type " + s.type + " cannot be rendered in the app");
            } else eo.warn("Survey not found");
        }
    }
    displaySurvey(t, i) {
        var e;
        if (D(this._surveyManager)) eo.warn("init was not called");
        else {
            var r = this.ye(t);
            if (r) {
                var s = r;
                if (null != (e = r.appearance) && e.surveyPopupDelaySeconds && i.ignoreDelay && (s = g({}, r, {
                    appearance: g({}, r.appearance, {
                        surveyPopupDelaySeconds: 0
                    })
                })), i.displayType !== io.Popover && i.initialResponses && eo.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), !1 === i.ignoreConditions) {
                    var n = this.canRenderSurvey(r);
                    if (!n.visible) return void eo.warn("Survey is not eligible to be displayed: ", n.disabledReason);
                }
                i.displayType !== io.Inline ? this._surveyManager.handlePopoverSurvey(s, i) : this.renderSurvey(s, i.selector, i.properties);
            } else eo.warn("Survey not found");
        }
    }
    cancelPendingSurvey(t) {
        D(this._surveyManager) ? eo.warn("init was not called") : this._surveyManager.cancelSurvey(t);
    }
    handlePageUnload() {
        var t;
        null == (t = this._surveyManager) || t.handlePageUnload();
    }
}
var po = Si("[Conversations]");
class go {
    constructor(t){
        this.xe = void 0, this._conversationsManager = null, this.Ee = !1, this.$e = null, this._instance = t;
    }
    onRemoteConfig(t) {
        if (!this._instance.config.disable_conversations) {
            var i = t.conversations;
            D(i) || (U(i) ? this.xe = i : (this.xe = i.enabled, this.$e = i), this.loadIfEnabled());
        }
    }
    reset() {
        var t;
        null == (t = this._conversationsManager) || t.reset(), this._conversationsManager = null, this.xe = void 0, this.$e = null;
    }
    loadIfEnabled() {
        if (!this._conversationsManager && !this.Ee && !(this._instance.config.disable_conversations || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut())) {
            var t = null == v ? void 0 : v.__PosthogExtensions__;
            if (t && !O(this.xe) && this.xe) {
                if (this.$e && this.$e.token) {
                    this.Ee = !0;
                    try {
                        var i = t.initConversations;
                        if (i) return this.Se(i), void (this.Ee = !1);
                        var e = t.loadExternalDependency;
                        if (!e) return void this.ke("PostHog loadExternalDependency extension not found.");
                        e(this._instance, "conversations", (i)=>{
                            i || !t.initConversations ? this.ke("Could not load conversations script", i) : this.Se(t.initConversations), this.Ee = !1;
                        });
                    } catch (t) {
                        this.ke("Error initializing conversations", t), this.Ee = !1;
                    }
                } else po.error("Conversations enabled but missing token in remote config.");
            }
        }
    }
    Se(t) {
        if (this.$e) try {
            this._conversationsManager = t(this.$e, this._instance), po.info("Conversations loaded successfully");
        } catch (t) {
            this.ke("Error completing conversations initialization", t);
        }
        else po.error("Cannot complete initialization: remote config is null");
    }
    ke(t, i) {
        po.error(t, i), this._conversationsManager = null, this.Ee = !1;
    }
    show() {
        this._conversationsManager ? this._conversationsManager.show() : po.warn("Conversations not loaded yet.");
    }
    hide() {
        this._conversationsManager && this._conversationsManager.hide();
    }
    isAvailable() {
        return !0 === this.xe && !j(this._conversationsManager);
    }
    isVisible() {
        var t, i;
        return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.isVisible()) && void 0 !== t && t;
    }
    sendMessage(t, i, e) {
        var r = this;
        return p(function*() {
            return r._conversationsManager ? r._conversationsManager.sendMessage(t, i, e) : (po.warn("Conversations not available yet."), null);
        })();
    }
    getMessages(t, i) {
        var e = this;
        return p(function*() {
            return e._conversationsManager ? e._conversationsManager.getMessages(t, i) : (po.warn("Conversations not available yet."), null);
        })();
    }
    markAsRead(t) {
        var i = this;
        return p(function*() {
            return i._conversationsManager ? i._conversationsManager.markAsRead(t) : (po.warn("Conversations not available yet."), null);
        })();
    }
    getTickets(t) {
        var i = this;
        return p(function*() {
            return i._conversationsManager ? i._conversationsManager.getTickets(t) : (po.warn("Conversations not available yet."), null);
        })();
    }
    getCurrentTicketId() {
        var t, i;
        return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.getCurrentTicketId()) && void 0 !== t ? t : null;
    }
    getWidgetSessionId() {
        var t, i;
        return null !== (t = null == (i = this._conversationsManager) ? void 0 : i.getWidgetSessionId()) && void 0 !== t ? t : null;
    }
}
class _o {
    constructor(t){
        var i;
        this.Pe = !1, this.Te = !1, this._instance = t, this._instance && null != (i = this._instance.config.logs) && i.captureConsoleLogs && (this.Pe = !0);
    }
    onRemoteConfig(t) {
        var i, e = null == (i = t.logs) ? void 0 : i.captureConsoleLogs;
        !D(e) && e && (this.Pe = !0, this.loadIfEnabled());
    }
    reset() {}
    loadIfEnabled() {
        if (this.Pe && !this.Te) {
            var t = Si("[logs]"), i = null == v ? void 0 : v.__PosthogExtensions__;
            if (i) {
                var e = i.loadExternalDependency;
                e ? e(this._instance, "logs", (e)=>{
                    var r;
                    e || null == (r = i.logs) || !r.initializeLogs ? t.error("Could not load logs script", e) : (i.logs.initializeLogs(this._instance), this.Te = !0);
                }) : t.error("PostHog loadExternalDependency extension not found.");
            } else t.error("PostHog Extensions not found.");
        }
    }
}
var mo = Si("[RateLimiter]");
class bo {
    constructor(t){
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    mo.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void mo.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: i
                });
            }
        }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    get captureEventsPerSecond() {
        var t;
        return (null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_per_second) || 10;
    }
    get captureEventsBurstLimit() {
        var t;
        return Math.max((null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
    }
    clientRateLimitContext(t) {
        var i, e, r;
        void 0 === t && (t = !1);
        var { captureEventsBurstLimit: s, captureEventsPerSecond: n } = this, o = (new Date).getTime(), a = null !== (i = null == (e = this.instance.persistence) ? void 0 : e.get_property(ce)) && void 0 !== i ? i : {
            tokens: s,
            last: o
        };
        a.tokens += (o - a.last) / 1e3 * n, a.last = o, a.tokens > s && (a.tokens = s);
        var l = a.tokens < 1;
        return l || t || (a.tokens = Math.max(0, a.tokens - 1)), !l || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + n + " events per second and " + s + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = l, null == (r = this.instance.persistence) || r.set_property(ce, a), {
            isRateLimited: l,
            remainingTokens: a.tokens
        };
    }
    isServerRateLimited(t) {
        var i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
}
var yo = Si("[RemoteConfig]");
class wo {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    Ie(t) {
        var i, e;
        null != (i = v.__PosthogExtensions__) && i.loadExternalDependency ? null == (e = v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : (yo.error("PostHog Extensions not found. Cannot load remote config."), t());
    }
    Ce(t) {
        this._instance._send_request({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback: (i)=>{
                t(i.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return yo.info("Using preloaded remote config", this.remoteConfig), void this.wi(this.remoteConfig);
            if (this._instance.M()) return void yo.warn("Remote config is disabled. Falling back to local config.");
            this.Ie((t)=>{
                if (!t) return yo.info("No config found after loading remote JS config. Falling back to JSON."), void this.Ce((t)=>{
                    this.wi(t);
                });
                this.wi(t);
            });
        } catch (t) {
            yo.error("Error loading remote config", t);
        }
    }
    wi(t) {
        t ? this._instance.config.__preview_remote_config ? (this._instance.wi(t), !1 !== t.hasFeatureFlags && this._instance.featureFlags.ensureFlagsLoaded()) : yo.info("__preview_remote_config is disabled. Logging config instead", t) : yo.error("Failed to fetch remote config from PostHog.");
    }
}
var xo = 3e3;
class Eo {
    constructor(t, i){
        this.Re = !0, this.Fe = [], this.Oe = K((null == i ? void 0 : i.flush_interval_ms) || xo, 250, 5e3, $i.createLogger("flush interval"), xo), this.Me = t;
    }
    enqueue(t) {
        this.Fe.push(t), this.Ae || this.je();
    }
    unload() {
        this.De();
        var t = this.Fe.length > 0 ? this.Le() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.Me(g({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.Re = !1, this.je();
    }
    je() {
        var t = this;
        this.Re || (this.Ae = setTimeout(()=>{
            if (this.De(), this.Fe.length > 0) {
                var i = this.Le(), e = function() {
                    var e = i[r], s = (new Date).getTime();
                    e.data && I(e.data) && Ci(e.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.Me(e);
                };
                for(var r in i)e();
            }
        }, this.Oe));
    }
    De() {
        clearTimeout(this.Ae), this.Ae = void 0;
    }
    Le() {
        var t = {};
        return Ci(this.Fe, (i)=>{
            var e, r = i, s = (r ? r.batchKey : null) || r.url;
            O(t[s]) && (t[s] = g({}, r, {
                data: []
            })), null == (e = t[s].data) || e.push(r.data);
        }), this.Fe = [], t;
    }
}
var $o = [
    "retriesPerformedSoFar"
];
class So {
    constructor(i){
        this.Ne = !1, this.Ue = 3e3, this.Fe = [], this._instance = i, this.Fe = [], this.ze = !0, !O(t) && "onLine" in t.navigator && (this.ze = t.navigator.onLine, this.He = ()=>{
            this.ze = !0, this.Lt();
        }, this.Be = ()=>{
            this.ze = !1;
        }, zi(t, "online", this.He), zi(t, "offline", this.Be));
    }
    get length() {
        return this.Fe.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: i } = t, e = _(t, $o);
        N(i) && (e.url = hn(e.url, {
            retry_count: i
        })), this._instance._send_request(g({}, e, {
            callback: (t)=>{
                200 !== t.statusCode && (t.statusCode < 400 || t.statusCode >= 500) && (null != i ? i : 0) < 10 ? this.qe(g({
                    retriesPerformedSoFar: i
                }, e)) : null == e.callback || e.callback(t);
            }
        }));
    }
    qe(t) {
        var i = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = i + 1;
        var e = function(t) {
            var i = 3e3 * Math.pow(2, t), e = i / 2, r = Math.min(18e5, i), s = (Math.random() - .5) * (r - e);
            return Math.ceil(r + s);
        }(i), r = Date.now() + e;
        this.Fe.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + e;
        navigator.onLine || (s += " (Browser is offline)"), $i.warn(s), this.Ne || (this.Ne = !0, this.We());
    }
    We() {
        if (this.Ge && clearTimeout(this.Ge), 0 === this.Fe.length) return this.Ne = !1, void (this.Ge = void 0);
        this.Ge = setTimeout(()=>{
            this.ze && this.Fe.length > 0 && this.Lt(), this.We();
        }, this.Ue);
    }
    Lt() {
        var t = Date.now(), i = [], e = this.Fe.filter((e)=>e.retryAt < t || (i.push(e), !1));
        if (this.Fe = i, e.length > 0) for (var { requestOptions: r } of e)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: i } of (this.Ge && (clearTimeout(this.Ge), this.Ge = void 0), this.Ne = !1, O(t) || (this.He && (t.removeEventListener("online", this.He), this.He = void 0), this.Be && (t.removeEventListener("offline", this.Be), this.Be = void 0)), this.Fe))try {
            this._instance._send_request(g({}, i, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $i.error(t);
        }
        this.Fe = [];
    }
}
class ko {
    constructor(t){
        this.Ve = ()=>{
            var t, i, e, r;
            this.Je || (this.Je = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.Je.lastScrollY = Math.ceil(n), this.Je.maxScrollY = Math.max(n, null !== (t = this.Je.maxScrollY) && void 0 !== t ? t : 0), this.Je.maxScrollHeight = Math.max(o, null !== (i = this.Je.maxScrollHeight) && void 0 !== i ? i : 0), this.Je.lastContentY = a, this.Je.maxContentY = Math.max(a, null !== (e = this.Je.maxContentY) && void 0 !== e ? e : 0), this.Je.maxContentHeight = Math.max(l, null !== (r = this.Je.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    getContext() {
        return this.Je;
    }
    resetContext() {
        var t = this.Je;
        return setTimeout(this.Ve, 0), t;
    }
    startMeasuringScrollPosition() {
        zi(t, "scroll", this.Ve, {
            capture: !0
        }), zi(t, "scrollend", this.Ve, {
            capture: !0
        }), zi(t, "resize", this.Ve);
    }
    scrollElement() {
        if (!this._instance.config.scroll_root_selector) return null == t ? void 0 : t.document.documentElement;
        var i = I(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [
            this._instance.config.scroll_root_selector
        ];
        for (var e of i){
            var r = null == t ? void 0 : t.document.querySelector(e);
            if (r) return r;
        }
    }
    scrollY() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollTop || 0;
        }
        return t && (t.scrollY || t.pageYOffset || t.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollLeft || 0;
        }
        return t && (t.scrollX || t.pageXOffset || t.document.documentElement.scrollLeft) || 0;
    }
}
var Po = (t)=>vs(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class To {
    constructor(t, i, e, r){
        this.Ke = (t)=>{
            var i = this.Ye();
            if (!i || i.sessionId !== t) {
                var e = {
                    sessionId: t,
                    props: this.Xe(this._instance)
                };
                this.Qe.register({
                    [ve]: e
                });
            }
        }, this._instance = t, this.Ze = i, this.Qe = e, this.Xe = r || Po, this.Ze.onSessionId(this.Ke);
    }
    Ye() {
        return this.Qe.props[ve];
    }
    getSetOnceProps() {
        var t, i = null == (t = this.Ye()) ? void 0 : t.props;
        return i ? "r" in i ? cs(i) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return Ci(ji(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t["$session_entry_" + E(e)] = i;
        }), t;
    }
}
var Io = Si("[SessionId]");
class Co {
    on(t, i) {
        return this.tr.on(t, i);
    }
    constructor(t, i, e){
        var r;
        if (this.ir = [], this.er = void 0, this.tr = new lo, this.rr = (t, i)=>!(!N(t) || !N(i)) && Math.abs(t - i) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if ("always" === t.config.cookieless_mode) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.R = t.config, this.Qe = t.persistence, this.sr = void 0, this.nr = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.ar = i || wr, this.lr = e || wr;
        var s = this.R.persistence_name || this.R.token, n = this.R.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * K(n, 60, 36e3, Io.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.ur(), this.hr = "ph_" + s + "_window_id", this.dr = "ph_" + s + "_primary_window_exists", this.vr()) {
            var o = Or.W(this.hr), a = Or.W(this.dr);
            o && !a ? this.sr = o : Or.V(this.hr), Or.G(this.dr, !0);
        }
        if (null != (r = this.R.bootstrap) && r.sessionID) try {
            var l = ((t)=>{
                var i = t.replace(/-/g, "");
                if (32 !== i.length) throw new Error("Not a valid UUID");
                if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                return parseInt(i.substring(0, 12), 16);
            })(this.R.bootstrap.sessionID);
            this.cr(this.R.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (t) {
            Io.error("Invalid sessionID in bootstrap", t);
        }
        this.pr();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return O(this.ir) && (this.ir = []), this.ir.push(t), this.nr && t(this.nr, this.sr), ()=>{
            this.ir = this.ir.filter((i)=>i !== t);
        };
    }
    vr() {
        return "memory" !== this.R.persistence && !this.Qe.Pi && Or.H();
    }
    gr(t) {
        t !== this.sr && (this.sr = t, this.vr() && Or.G(this.hr, t));
    }
    _r() {
        return this.sr ? this.sr : this.vr() ? Or.W(this.hr) : null;
    }
    cr(t, i, e) {
        t === this.nr && i === this._sessionActivityTimestamp && e === this._sessionStartTimestamp || (this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.nr = t, this.Qe.register({
            [ie]: [
                i,
                t,
                e
            ]
        }));
    }
    mr() {
        var t = this.Qe.props[ie];
        return I(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.cr(null, null, null);
    }
    destroy() {
        clearTimeout(this.br), this.br = void 0, this.er && t && (t.removeEventListener("beforeunload", this.er, {
            capture: !1
        }), this.er = void 0), this.ir = [];
    }
    pr() {
        this.er = ()=>{
            this.vr() && Or.V(this.dr);
        }, zi(t, "beforeunload", this.er, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, i) {
        if (void 0 === t && (t = !1), void 0 === i && (i = null), "always" === this.R.cookieless_mode) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        var e = i || (new Date).getTime(), [r, s, n] = this.mr(), o = this._r(), a = N(n) && Math.abs(e - n) > 864e5, l = !1, u = !s, h = !u && !t && this.rr(e, r);
        u || h || a ? (s = this.ar(), o = this.lr(), Io.info("new session ID generated", {
            sessionId: s,
            windowId: o,
            changeReason: {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            }
        }), n = e, l = !0) : o || (o = this.lr(), l = !0);
        var d = !!N(r) && t && !a ? r : e, v = !N(n) ? (new Date).getTime() : n;
        return this.gr(o), this.cr(s, d, v), t || this.ur(), l && this.ir.forEach((t)=>t(s, o, l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: s,
            windowId: o,
            sessionStartTimestamp: v,
            changeReason: l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: r
        };
    }
    ur() {
        clearTimeout(this.br), this.br = setTimeout(()=>{
            var [t] = this.mr();
            if (this.rr((new Date).getTime(), t)) {
                var i = this.nr;
                this.resetSessionId(), this.tr.emit("forcedIdleReset", {
                    idleSessionId: i
                });
            }
        }, 1.1 * this.sessionTimeoutMs);
    }
}
var Ro = [
    "$set_once",
    "$set"
], Fo = Si("[SiteApps]");
class Oo {
    constructor(t){
        this._instance = t, this.yr = [], this.apps = {};
    }
    get isEnabled() {
        return !!this._instance.config.opt_in_site_apps;
    }
    wr(t, i) {
        if (i) {
            var e = this.globalsForEvent(i);
            this.yr.push(e), this.yr.length > 1e3 && (this.yr = this.yr.slice(10));
        }
    }
    get siteAppLoaders() {
        var t;
        return null == (t = v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
    }
    init() {
        if (this.isEnabled) {
            var t = this._instance._addCaptureHook(this.wr.bind(this));
            this.Er = ()=>{
                t(), this.yr = [], this.Er = void 0;
            };
        }
    }
    globalsForEvent(t) {
        var i, e, r, s, n, o, a;
        if (!t) throw new Error("Event payload is required");
        var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
        for (var [d, v] of Object.entries(h))l[d] = {
            id: u[d],
            type: d,
            properties: v
        };
        var { $set_once: c, $set: f } = t;
        return {
            event: g({}, _(t, Ro), {
                properties: g({}, t.properties, f ? {
                    $set: g({}, null !== (i = null == (e = t.properties) ? void 0 : e.$set) && void 0 !== i ? i : {}, f)
                } : {}, c ? {
                    $set_once: g({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                } : {}),
                elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
            }),
            person: {
                properties: this._instance.get_property("$stored_person_properties")
            },
            groups: l
        };
    }
    setupSiteApp(t) {
        var i = this.apps[t.id], e = ()=>{
            var e;
            (!i.errored && this.yr.length && (Fo.info("Processing " + this.yr.length + " events for site app with id " + t.id), this.yr.forEach((t)=>null == i.processEvent ? void 0 : i.processEvent(t)), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored)) && (null == (e = this.Er) || e.call(this));
        }, r = !1, s = (s)=>{
            i.errored = !s, i.loaded = !0, Fo.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && e();
        };
        try {
            var { processEvent: n } = t.init({
                posthog: this._instance,
                callback: (t)=>{
                    s(t);
                }
            });
            n && (i.processEvent = n), r = !0;
        } catch (i) {
            Fo.error("Error while initializing PostHog app with config id " + t.id, i), s(!1);
        }
        if (r && i.loaded) try {
            e();
        } catch (e) {
            Fo.error("Error while processing buffered events PostHog app with config id " + t.id, e), i.errored = !0;
        }
    }
    $r() {
        var t = this.siteAppLoaders || [];
        for (var i of t)this.apps[i.id] = {
            id: i.id,
            loaded: !1,
            errored: !1,
            processedBuffer: !1
        };
        for (var e of t)this.setupSiteApp(e);
    }
    Sr(t) {
        if (0 !== Object.keys(this.apps).length) {
            var i = this.globalsForEvent(t);
            for (var e of Object.values(this.apps))try {
                null == e.processEvent || e.processEvent(i);
            } catch (i) {
                Fo.error("Error while processing event " + t.event + " for site app " + e.id, i);
            }
        }
    }
    onRemoteConfig(t) {
        var i, e, r, s = this;
        if (null != (i = this.siteAppLoaders) && i.length) return this.isEnabled ? (this.$r(), void this._instance.on("eventCaptured", (t)=>this.Sr(t))) : void Fo.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        if (null == (e = this.Er) || e.call(this), null != (r = t.siteApps) && r.length) {
            if (this.isEnabled) {
                var n = function(t) {
                    var i;
                    v["__$$ph_site_app_" + t] = s._instance, null == (i = v.__PosthogExtensions__) || null == i.loadSiteApp || i.loadSiteApp(s._instance, a, (i)=>{
                        if (i) return Fo.error("Error while initializing PostHog app with config id " + t, i);
                    });
                };
                for (var { id: o, url: a } of t.siteApps)n(o);
            } else Fo.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        }
    }
}
var Mo = function(t, i) {
    if (!t) return !1;
    var e = t.userAgent;
    if (e && y(e, i)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>y(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
}, Ao = function(t) {
    return t.US = "us", t.EU = "eu", t.CUSTOM = "custom", t;
}({}), jo = "i.posthog.com";
class Do {
    constructor(t){
        this.kr = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get flagsApiHost() {
        var t = this.instance.config.flags_api_host;
        return t ? t.trim().replace(/\/$/, "") : this.apiHost;
    }
    get uiHost() {
        var t, i = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace("." + jo, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.kr[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.kr[this.apiHost] = Ao.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.kr[this.apiHost] = Ao.EU : this.kr[this.apiHost] = Ao.CUSTOM), this.kr[this.apiHost];
    }
    endpointFor(t, i) {
        if (void 0 === i && (i = ""), i && (i = "/" === i[0] ? i : "/" + i), "ui" === t) return this.uiHost + i;
        if ("flags" === t) return this.flagsApiHost + i;
        if (this.region === Ao.CUSTOM) return this.apiHost + i;
        var e = jo + i;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + e;
            case "api":
                return "https://" + this.region + "." + e;
        }
    }
}
var Lo = {
    icontains: (i, e)=>!!t && e.href.toLowerCase().indexOf(i.toLowerCase()) > -1,
    not_icontains: (i, e)=>!!t && -1 === e.href.toLowerCase().indexOf(i.toLowerCase()),
    regex: (i, e)=>!!t && fn(e.href, i),
    not_regex: (i, e)=>!!t && !fn(e.href, i),
    exact: (t, i)=>i.href === t,
    is_not: (t, i)=>i.href !== t
};
class No {
    constructor(t){
        var i = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), i.getWebExperiments((t)=>{
                No.Pr("retrieved web experiments from the server"), i.Tr = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var e;
                        if (i.Tr) No.Pr("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (e = i.Tr) || e.set(t.feature_flag_key, t);
                        var r = i._instance.getFeatureFlag(t.feature_flag_key);
                        M(r) && t.variants[r] && i.Ir(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        No.Cr(n) && i.Ir(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    onFeatureFlags(t) {
        if (this._is_bot()) No.Pr("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this._instance.config.disable_web_experiments) {
            if (D(this.Tr)) return this.Tr = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            No.Pr("applying feature flags", t), t.forEach((t)=>{
                var i;
                if (this.Tr && null != (i = this.Tr) && i.has(t)) {
                    var e, r = this._instance.getFeatureFlag(t), s = null == (e = this.Tr) ? void 0 : e.get(t);
                    r && null != s && s.variants[r] && this.Ir(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = No.getWindowLocation();
        if (null != t && t.search) {
            var i = nr(null == t ? void 0 : t.search, "__experiment_id"), e = nr(null == t ? void 0 : t.search, "__experiment_variant");
            i && e && (No.Pr("previewing web experiments " + i + " && " + e), this.getWebExperiments((t)=>{
                this.Rr(parseInt(i), e, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, i, e) {
        if (this._instance.config.disable_web_experiments && !e) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !i) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token),
            method: "GET",
            callback: (i)=>{
                if (200 !== i.statusCode || !i.json) return t([]);
                var e = i.json.experiments || [];
                return t(e);
            }
        });
    }
    Rr(t, i, e) {
        var r = e.filter((i)=>i.id === t);
        r && r.length > 0 && (No.Pr("Previewing web experiment [" + r[0].name + "] with variant [" + i + "]"), this.Ir(r[0].name, i, r[0].variants[i].transforms));
    }
    static Cr(t) {
        return !D(t.conditions) && No.Fr(t) && No.Or(t);
    }
    static Fr(t) {
        var i;
        if (D(t.conditions) || D(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var e, r, s, n = No.getWindowLocation();
        return !!n && (null == (e = t.conditions) || !e.url || Lo[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == t ? void 0 : t.location;
    }
    static Or(t) {
        var i;
        if (D(t.conditions) || D(null == (i = t.conditions) ? void 0 : i.utm)) return !0;
        var e = as();
        if (e.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == e.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == e.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == e.utm_medium, f = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == e.utm_term;
            return d && c && f && v;
        }
        return !1;
    }
    static Pr(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        $i.info("[WebExperiments] " + t, e);
    }
    Ir(t, i, e) {
        this._is_bot() ? No.Pr("Refusing to render web experiment since the viewer is a likely bot") : "control" !== i ? e.forEach((e)=>{
            if (e.selector) {
                var r;
                No.Pr("applying transform of variant " + i + " for experiment " + t + " ", e);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(e.selector);
                null == s || s.forEach((t)=>{
                    var i = t;
                    e.html && (i.innerHTML = e.html), e.css && i.setAttribute("style", e.css);
                });
            }
        }) : No.Pr("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return n && this._instance ? Mo(n, this._instance.config.custom_blocked_useragents) : void 0;
    }
}
var Uo = Si("[PostHog ExternalIntegrations]"), zo = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
class Ho {
    constructor(t){
        this._instance = t;
    }
    it(t, i) {
        var e;
        null == (e = v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, t, (t)=>{
            if (t) return Uo.error("failed to load script", t);
            i();
        });
    }
    startIfEnabledOrStop() {
        var t = this, i = function(i) {
            var e, s, n;
            (!r || null != (e = v.__PosthogExtensions__) && null != (e = e.integrations) && e[i] || t.it(zo[i], ()=>{
                var e;
                null == (e = v.__PosthogExtensions__) || null == (e = e.integrations) || null == (e = e[i]) || e.start(t._instance);
            }), !r && null != (s = v.__PosthogExtensions__) && null != (s = s.integrations) && s[i]) && (null == (n = v.__PosthogExtensions__) || null == (n = n.integrations) || null == (n = n[i]) || n.stop());
        };
        for (var [e, r] of Object.entries(null !== (s = this._instance.config.integrations) && void 0 !== s ? s : {})){
            var s;
            i(e);
        }
    }
}
Si("[SessionRecording]");
var Bo = "[SessionRecording]", qo = Si(Bo);
class Wo {
    get started() {
        var t;
        return !(null == (t = this.Mr) || !t.isStarted);
    }
    get status() {
        return this.Mr ? this.Mr.status : this.Ar && !this.jr ? "disabled" : "lazy_loading";
    }
    constructor(t){
        if (this._forceAllowLocalhostNetworkCapture = !1, this.Ar = !1, this.Dr = !1, this.Lr = void 0, this._instance = t, !this._instance.sessionManager) throw qo.error("started without valid sessionManager"), new Error(Bo + " started without valid sessionManager. This is a bug.");
        if ("always" === this._instance.config.cookieless_mode) throw new Error(Bo + ' cannot be used with cookieless_mode="always"');
    }
    get jr() {
        var i, e = !(null == (i = this._instance.get_property(te)) || !i.enabled), r = !this._instance.config.disable_session_recording, s = this._instance.config.disable_session_recording || this._instance.consent.isOptedOut();
        return t && e && r && !s;
    }
    startIfEnabledOrStop(t) {
        var i;
        if (!this.jr || null == (i = this.Mr) || !i.isStarted) {
            var e = !O(Object.assign) && !O(Array.from);
            this.jr && e ? (this.Nr(t), qo.info("starting")) : this.stopRecording();
        }
    }
    Nr(t) {
        var i, e, r;
        this.jr && (null != v && null != (i = v.__PosthogExtensions__) && null != (i = i.rrweb) && i.record && null != (e = v.__PosthogExtensions__) && e.initSessionRecording ? this.Ur(t) : null == (r = v.__PosthogExtensions__) || null == r.loadExternalDependency || r.loadExternalDependency(this._instance, this.zr, (i)=>{
            if (i) return qo.error("could not load recorder", i);
            this.Ur(t);
        }));
    }
    stopRecording() {
        var t, i;
        null == (t = this.Lr) || t.call(this), this.Lr = void 0, null == (i = this.Mr) || i.stop();
    }
    Hr() {
        var t;
        null == (t = this._instance.persistence) || t.unregister(ee);
    }
    Br(t) {
        if (this._instance.persistence) {
            var i, e, r = this._instance.persistence, s = ()=>{
                var i = !1 === t.sessionRecording ? void 0 : t.sessionRecording, e = null == i ? void 0 : i.sampleRate, s = D(e) ? null : parseFloat(e);
                D(s) && this.Hr();
                var n = null == i ? void 0 : i.minimumDurationMilliseconds;
                r.register({
                    [te]: g({
                        cache_timestamp: Date.now(),
                        enabled: !!i
                    }, i, {
                        networkPayloadCapture: g({
                            capturePerformance: t.capturePerformance
                        }, null == i ? void 0 : i.networkPayloadCapture),
                        canvasRecording: {
                            enabled: null == i ? void 0 : i.recordCanvas,
                            fps: null == i ? void 0 : i.canvasFps,
                            quality: null == i ? void 0 : i.canvasQuality
                        },
                        sampleRate: s,
                        minimumDurationMilliseconds: O(n) ? null : n,
                        endpoint: null == i ? void 0 : i.endpoint,
                        triggerMatchType: null == i ? void 0 : i.triggerMatchType,
                        masking: null == i ? void 0 : i.masking,
                        urlTriggers: null == i ? void 0 : i.urlTriggers
                    })
                });
            };
            s(), null == (i = this.Lr) || i.call(this), this.Lr = null == (e = this._instance.sessionManager) ? void 0 : e.onSessionId(s);
        }
    }
    onRemoteConfig(t) {
        "sessionRecording" in t ? !1 !== t.sessionRecording ? (this.Dr = !1, this.Br(t), this.Ar = !0, this.startIfEnabledOrStop()) : this.Ar = !0 : qo.info("skipping remote config with no sessionRecording", t);
    }
    log(t, i) {
        var e;
        void 0 === i && (i = "log"), null != (e = this.Mr) && e.log ? this.Mr.log(t, i) : qo.warn("log called before recorder was ready");
    }
    get zr() {
        var t, i, e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.get_property(te);
        return (null == e || null == (i = e.scriptConfig) ? void 0 : i.script) || "lazy-recorder";
    }
    qr() {
        var t, i = this._instance.get_property(te);
        if (!i) return !1;
        var e = null !== (t = ("object" == typeof i ? i : JSON.parse(i)).cache_timestamp) && void 0 !== t ? t : Date.now();
        return Date.now() - e <= 3e5;
    }
    Ur(t) {
        var i, e;
        if (null == (i = v.__PosthogExtensions__) || !i.initSessionRecording) throw Error("Called on script loaded before session recording is available");
        this.Mr || (this.Mr = null == (e = v.__PosthogExtensions__) ? void 0 : e.initSessionRecording(this._instance), this.Mr._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture);
        this.qr() ? this.Mr.start(t) : this.Dr || (this.Dr = !0, qo.info("persisted remote config is stale, requesting fresh config before starting"), new wo(this._instance).load());
    }
    onRRwebEmit(t) {
        var i;
        null == (i = this.Mr) || null == i.onRRwebEmit || i.onRRwebEmit(t);
    }
    overrideLinkedFlag() {
        var t, i;
        this.Mr || null == (i = this._instance.persistence) || i.register({
            $replay_override_linked_flag: !0
        });
        null == (t = this.Mr) || t.overrideLinkedFlag();
    }
    overrideSampling() {
        var t, i;
        this.Mr || null == (i = this._instance.persistence) || i.register({
            $replay_override_sampling: !0
        });
        null == (t = this.Mr) || t.overrideSampling();
    }
    overrideTrigger(t) {
        var i, e;
        this.Mr || null == (e = this._instance.persistence) || e.register({
            ["url" === t ? "$replay_override_url_trigger" : "$replay_override_event_trigger"]: !0
        });
        null == (i = this.Mr) || i.overrideTrigger(t);
    }
    get sdkDebugProperties() {
        var t;
        return (null == (t = this.Mr) ? void 0 : t.sdkDebugProperties) || {
            $recording_status: this.status
        };
    }
    tryAddCustomEvent(t, i) {
        var e;
        return !(null == (e = this.Mr) || !e.tryAddCustomEvent(t, i));
    }
}
var Go = {}, Vo = ()=>{}, Jo = "posthog", Ko = !ln && -1 === (null == d ? void 0 : d.indexOf("MSIE")) && -1 === (null == d ? void 0 : d.indexOf("Mozilla")), Yo = (i)=>{
    var e;
    return g({
        api_host: "https://us.i.posthog.com",
        flags_api_host: null,
        ui_host: null,
        token: "",
        autocapture: !0,
        cross_subdomain_cookie: Ni(null == o ? void 0 : o.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_persisted_properties: [],
        loaded: Vo,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageleave: "if_capture_pageview",
        defaults: null != i ? i : "unset",
        __preview_deferred_init_extensions: !1,
        debug: a && M(null == a ? void 0 : a.search) && -1 !== a.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_conversations: !1,
        disable_product_tours: !1,
        disable_external_dependency_loading: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == t || null == (e = t.location) ? void 0 : e.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error: (t)=>{
            var i = "Bad HTTP status: " + t.statusCode + " " + t.text;
            $i.error(i);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: xo
        },
        error_tracking: {},
        _onCapture: Vo,
        __preview_eager_load_replay: !1
    }, ((t)=>({
            rageclick: !(t && t >= "2025-11-30") || {
                content_ignorelist: !0
            },
            capture_pageview: !(t && t >= "2025-05-24") || "history_change",
            session_recording: t && t >= "2025-11-30" ? {
                strictMinimumDuration: !0
            } : {},
            external_scripts_inject_target: t && t >= "2026-01-30" ? "head" : "body",
            internal_or_test_user_hostname: t && t >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0
        }))(i));
}, Xo = (t)=>{
    var i = {};
    O(t.process_person) || (i.person_profiles = t.process_person), O(t.xhr_headers) || (i.request_headers = t.xhr_headers), O(t.cookie_name) || (i.persistence_name = t.cookie_name), O(t.disable_cookie) || (i.disable_persistence = t.disable_cookie), O(t.store_google) || (i.save_campaign_params = t.store_google), O(t.verbose) || (i.debug = t.verbose);
    var e = Ri({}, i, t);
    return I(t.property_blacklist) && (O(t.property_denylist) ? e.property_denylist = t.property_blacklist : I(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $i.error("Invalid value for property_denylist config: " + t.property_denylist)), e;
};
class Qo {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get Wr() {
        return this.__forceAllowLocalhost;
    }
    set Wr(t) {
        $i.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class Zo {
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        this.webPerformance = new Qo, this.Gr = !1, this.version = c.LIB_VERSION, this.bi = new lo, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = Yo(), this.SentryIntegration = Jr, this.sentryIntegration = (t)=>(function(t, i) {
                var e = Vr(t, i);
                return {
                    name: Gr,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.Vr = !1, this.Jr = null, this.Kr = null, this.Yr = null, this.featureFlags = new Nn(this), this.toolbar = new Zr(this), this.scrollManager = new ko(this), this.pageViewManager = new Es(this), this.surveys = new fo(this), this.conversations = new go(this), this.logs = new _o(this), this.experiments = new No(this), this.exceptions = new yn(this), this.rateLimiter = new bo(this), this.requestRouter = new Do(this), this.consent = new Ar(this), this.externalIntegrations = new Ho(this), this.people = {
            set: (t, i, e)=>{
                var r = M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(r), null == e || e({});
            },
            set_once: (t, i, e)=>{
                var r = M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, r), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$i.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, i, e) {
        if (e && e !== Jo) {
            var r, s = null !== (r = Go[e]) && void 0 !== r ? r : new Zo;
            return s._init(t, i, e), Go[e] = s, Go[Jo][e] = s, s;
        }
        return this._init(t, i, e);
    }
    _init(i, e, r) {
        var s;
        if (void 0 === e && (e = {}), O(i) || A(i)) return $i.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, e.debug = this.Xr(e.debug), this.Qr = e, this.Zr = [], e.person_profiles && (this.Kr = e.person_profiles), this.set_config(Ri({}, Yo(e.defaults), Xo(e), {
            name: r,
            token: i
        })), this.config.on_xhr_error && $i.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = e.disable_compression ? void 0 : Ss.GZipJS;
        var n = this.ts();
        this.persistence = new zn(this.config, n), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new zn(g({}, this.config, {
            persistence: "sessionStorage"
        }), n);
        var o = g({}, this.persistence.props), a = g({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.es = new Eo((t)=>this.rs(t), this.config.request_queue_config), this.ss = new So(this), this.__request_queue = [];
        var l = "always" === this.config.cookieless_mode || "on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut();
        if (l || (this.sessionManager = new Co(this), this.sessionPropsManager = new To(this, this.sessionManager, this.persistence)), this.config.__preview_deferred_init_extensions ? ($i.info("Deferring extension initialization to improve startup performance"), setTimeout(()=>{
            this.ns(l);
        }, 0)) : ($i.info("Initializing extensions synchronously"), this.ns(l)), c.DEBUG = c.DEBUG || this.config.debug, c.DEBUG && $i.info("Starting in debug mode", {
            this: this,
            config: e,
            thisC: g({}, this.config),
            p: o,
            s: a
        }), void 0 !== (null == (s = e.bootstrap) ? void 0 : s.distinctID)) {
            var u, h, d = this.config.get_device_id(wr()), v = null != (u = e.bootstrap) && u.isIdentifiedID ? d : e.bootstrap.distinctID;
            this.persistence.set_property(de, null != (h = e.bootstrap) && h.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: e.bootstrap.distinctID,
                $device_id: v
            });
        }
        if (this.os()) {
            var f, p, _ = Object.keys((null == (f = e.bootstrap) ? void 0 : f.featureFlags) || {}).filter((t)=>{
                var i;
                return !(null == (i = e.bootstrap) || null == (i = i.featureFlags) || !i[t]);
            }).reduce((t, i)=>{
                var r;
                return t[i] = (null == (r = e.bootstrap) || null == (r = r.featureFlags) ? void 0 : r[i]) || !1, t;
            }, {}), m = Object.keys((null == (p = e.bootstrap) ? void 0 : p.featureFlagPayloads) || {}).filter((t)=>_[t]).reduce((t, i)=>{
                var r, s;
                null != (r = e.bootstrap) && null != (r = r.featureFlagPayloads) && r[i] && (t[i] = null == (s = e.bootstrap) || null == (s = s.featureFlagPayloads) ? void 0 : s[i]);
                return t;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: _,
                featureFlagPayloads: m
            });
        }
        if (l) this.register_once({
            distinct_id: be,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var b = this.config.get_device_id(wr());
            this.register_once({
                distinct_id: b,
                $device_id: b
            }, ""), this.persistence.set_property(de, "anonymous");
        }
        return zi(t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), this.toolbar.maybeLoadToolbar(), e.segment ? Wr(this, ()=>this.ls()) : this.ls(), C(this.config._onCapture) && this.config._onCapture !== Vo && ($i.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $i.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
    }
    ns(t) {
        var i = performance.now();
        this.historyAutocapture = new Br(this), this.historyAutocapture.startIfEnabled();
        var e = [];
        e.push(()=>{
            new is(this).startIfEnabledOrStop();
        }), e.push(()=>{
            var t;
            this.siteApps = new Oo(this), null == (t = this.siteApps) || t.init();
        }), t || e.push(()=>{
            this.sessionRecording = new Wo(this), this.sessionRecording.startIfEnabledOrStop();
        }), this.config.disable_scroll_properties || e.push(()=>{
            this.scrollManager.startMeasuringScrollPosition();
        }), e.push(()=>{
            this.autocapture = new fr(this), this.autocapture.startIfEnabled();
        }), e.push(()=>{
            this.surveys.loadIfEnabled();
        }), e.push(()=>{
            this.logs.loadIfEnabled();
        }), e.push(()=>{
            this.conversations.loadIfEnabled();
        }), e.push(()=>{
            this.productTours = new qn(this), this.productTours.loadIfEnabled();
        }), e.push(()=>{
            this.heatmaps = new xs(this), this.heatmaps.startIfEnabled();
        }), e.push(()=>{
            this.webVitalsAutocapture = new bs(this);
        }), e.push(()=>{
            this.exceptionObserver = new zr(this), this.exceptionObserver.startIfEnabledOrStop();
        }), e.push(()=>{
            this.deadClicksAutocapture = new Nr(this, Lr), this.deadClicksAutocapture.startIfEnabledOrStop();
        }), e.push(()=>{
            if (this.us) {
                var t = this.us;
                this.us = void 0, this.wi(t);
            }
        }), this.hs(e, i);
    }
    hs(t, i) {
        for(; t.length > 0;){
            if (this.config.__preview_deferred_init_extensions) {
                if (performance.now() - i >= 30 && t.length > 0) return void setTimeout(()=>{
                    this.hs(t, i);
                }, 0);
            }
            var e = t.shift();
            if (e) try {
                e();
            } catch (t) {
                $i.error("Error initializing extension:", t);
            }
        }
        var r = Math.round(performance.now() - i);
        this.register_for_session({
            $sdk_debug_extensions_init_method: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous",
            $sdk_debug_extensions_init_time_ms: r
        }), this.config.__preview_deferred_init_extensions && $i.info("PostHog extensions initialized (" + r + "ms)");
    }
    wi(t) {
        var i, e, r, s, n, a, l, u, h;
        if (!o || !o.body) return $i.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.wi(t);
        }, 500);
        this.config.__preview_deferred_init_extensions && (this.us = t), this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = w(t.supportedCompression, Ss.GZipJS) ? Ss.GZipJS : w(t.supportedCompression, Ss.Base64) ? Ss.Base64 : void 0), null != (i = t.analytics) && i.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this.Kr ? this.Kr : "identified_only"
        }), null == (e = this.siteApps) || e.onRemoteConfig(t), null == (r = this.sessionRecording) || r.onRemoteConfig(t), null == (s = this.autocapture) || s.onRemoteConfig(t), null == (n = this.heatmaps) || n.onRemoteConfig(t), this.surveys.onRemoteConfig(t), this.logs.onRemoteConfig(t), this.conversations.onRemoteConfig(t), null == (a = this.productTours) || a.onRemoteConfig(t), null == (l = this.webVitalsAutocapture) || l.onRemoteConfig(t), null == (u = this.exceptionObserver) || u.onRemoteConfig(t), this.exceptions.onRemoteConfig(t), null == (h = this.deadClicksAutocapture) || h.onRemoteConfig(t);
    }
    ls() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $i.critical("`loaded` function failed", t);
        }
        if (this.ds(), this.config.internal_or_test_user_hostname && null != a && a.hostname) {
            var t = a.hostname, i = this.config.internal_or_test_user_hostname;
            ("string" == typeof i ? t === i : i.test(t)) && this.setInternalOrTestUser();
        }
        this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || "always" === this.config.cookieless_mode) && this.vs();
        }, 1), new wo(this).load(), this.featureFlags.flags();
    }
    ds() {
        var t;
        this.is_capturing() && this.config.request_batching && (null == (t = this.es) || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && Ii(this.__request_queue, (t)=>this.rs(t)), this.__request_queue = [], this.ds();
    }
    _handle_unload() {
        var t, i;
        this.surveys.handlePageUnload(), this.config.request_batching ? (this.cs() && this.capture("$pageleave"), null == (t = this.es) || t.unload(), null == (i = this.ss) || i.unload()) : this.cs() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    _send_request(t) {
        this.__loaded && (Ko ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = hn(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = g({}, this.config.request_headers, t.headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, t.disableXHRCredentials = this.config.__preview_disable_xhr_credentials, this.config.__preview_disable_beacon && (t.disableTransport = [
            "sendBeacon"
        ]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var i, e, r, s = g({}, t);
            s.timeout = s.timeout || 6e4, s.url = hn(s.url, {
                _: (new Date).getTime().toString(),
                ver: c.LIB_VERSION,
                compression: s.compression
            });
            var n = null !== (i = s.transport) && void 0 !== i ? i : "fetch", o = cn.filter((t)=>!s.disableTransport || !t.transport || !s.disableTransport.includes(t.transport)), a = null !== (e = null == (r = Ui(o, (t)=>t.transport === n)) ? void 0 : r.method) && void 0 !== e ? e : o[0].method;
            if (!a) throw new Error("No available transport method");
            a(s);
        })(g({}, t, {
            callback: (i)=>{
                var e, r;
                (this.rateLimiter.checkForLimiting(i), i.statusCode >= 400) && (null == (e = (r = this.config).on_request_error) || e.call(r, i));
                null == t.callback || t.callback(i);
            }
        }))));
    }
    rs(t) {
        this.ss ? this.ss.retriableRequest(t) : this._send_request(t);
    }
    _execute_array(t) {
        var i, e = [], r = [], s = [];
        Ii(t, (t)=>{
            t && (i = t[0], I(i) ? s.push(t) : C(t) ? t.call(this) : I(t) && "alias" === i ? e.push(t) : I(t) && -1 !== i.indexOf("capture") && C(this[i]) ? s.push(t) : r.push(t));
        });
        var n = function(t, i) {
            Ii(t, function(t) {
                if (I(t[0])) {
                    var e = i;
                    Ci(t, function(t) {
                        e = e[t[0]].apply(e, t.slice(1));
                    });
                } else this[t[0]].apply(this, t.slice(1));
            }, i);
        };
        n(e, this), n(r, this), n(s, this);
    }
    os() {
        var t, i;
        return (null == (t = this.config.bootstrap) ? void 0 : t.featureFlags) && Object.keys(null == (i = this.config.bootstrap) ? void 0 : i.featureFlags).length > 0 || !1;
    }
    push(t) {
        this._execute_array([
            t
        ]);
    }
    capture(t, i, e) {
        var r;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.es) {
            if (this.is_capturing()) {
                if (!O(t) && M(t)) {
                    var s = !this.config.opt_out_useragent_filter && this._is_bot();
                    if (!(s && !this.config.__preview_capture_bot_pageviews)) {
                        var n = null != e && e.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == n || !n.isRateLimited) {
                            null != i && i.$current_url && !M(null == i ? void 0 : i.$current_url) && ($i.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var o = new Date, a = (null == e ? void 0 : e.timestamp) || o, l = wr(), u = {
                                uuid: l,
                                event: t,
                                properties: this.calculateEventProperties(t, i || {}, a, l)
                            };
                            "$pageview" === t && this.config.__preview_capture_bot_pageviews && s && (u.event = "$bot_pageview", u.properties.$browser_type = "bot"), n && (u.properties.$lib_rate_limit_remaining_tokens = n.remainingTokens), (null == e ? void 0 : e.$set) && (u.$set = null == e ? void 0 : e.$set);
                            var h, d = "$groupidentify" !== t, v = this.fs(null == e ? void 0 : e.$set_once, d);
                            if (v && (u.$set_once = v), (u = Di(u, null != e && e._noTruncate ? null : this.config.properties_string_max_length)).timestamp = a, O(null == e ? void 0 : e.timestamp) || (u.properties.$event_time_override_provided = !0, u.properties.$event_time_override_system_time = o), t === Zn.DISMISSED || t === Zn.SENT) {
                                var c = null == i ? void 0 : i[to.SURVEY_ID], f = null == i ? void 0 : i[to.SURVEY_ITERATION];
                                h = {
                                    id: c,
                                    current_iteration: f
                                }, localStorage.getItem(no(h)) || localStorage.setItem(no(h), "true"), u.$set = g({}, u.$set, {
                                    [so({
                                        id: c,
                                        current_iteration: f
                                    }, t === Zn.SENT ? "responded" : "dismissed")]: !0
                                });
                            } else t === Zn.SHOWN && (u.$set = g({}, u.$set, {
                                [to.SURVEY_LAST_SEEN_DATE]: (new Date).toISOString()
                            }));
                            var p = g({}, u.properties.$set, u.$set);
                            if (F(p) || this.setPersonPropertiesForFlags(p), !D(this.config.before_send)) {
                                var _ = this.ps(u);
                                if (!_) return;
                                u = _;
                            }
                            this.bi.emit("eventCaptured", u);
                            var m = {
                                method: "POST",
                                url: null !== (r = null == e ? void 0 : e._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: u,
                                compression: "best-available",
                                batchKey: null == e ? void 0 : e._batchKey
                            };
                            return !this.config.request_batching || e && (null == e || !e._batchKey) || null != e && e.send_instantly ? this.rs(m) : this.es.enqueue(m), u;
                        }
                        $i.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $i.error("No event name provided to posthog.capture");
            }
        } else $i.uninitializedWarning("posthog.capture");
    }
    _addCaptureHook(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    calculateEventProperties(t, i, e, r, s) {
        if (e = e || new Date, !this.persistence || !this.sessionPersistence) return i;
        var n = s ? void 0 : this.persistence.remove_event_timer(t), a = g({}, i);
        if (a.token = this.config.token, a.$config_defaults = this.config.defaults, ("always" == this.config.cookieless_mode || "on_reject" == this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) && (a.$cookieless_mode = !0), "$snapshot" === t) {
            var l = g({}, this.persistence.properties(), this.sessionPersistence.properties());
            return a.distinct_id = l.distinct_id, (!M(a.distinct_id) && !L(a.distinct_id) || A(a.distinct_id)) && $i.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
        }
        var u, h = gs(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
        if (this.sessionManager) {
            var { sessionId: v, windowId: c } = this.sessionManager.checkAndGetSessionAndWindowId(s, e.getTime());
            a.$session_id = v, a.$window_id = c;
        }
        this.sessionPropsManager && Ri(a, this.sessionPropsManager.getSessionProps());
        try {
            var f;
            this.sessionRecording && Ri(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = null == (f = this.ss) ? void 0 : f.length;
        } catch (t) {
            a.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === Ao.CUSTOM && (a.$lib_custom_api_host = this.config.api_host), u = "$pageview" !== t || s ? "$pageleave" !== t || s ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(e) : this.pageViewManager.doPageView(e, r), a = Ri(a, u), "$pageview" === t && o && (a.title = o.title), !O(n)) {
            var p = e.getTime() - n;
            a.$duration = parseFloat((p / 1e3).toFixed(3));
        }
        d && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser"), (a = Ri({}, h, this.persistence.properties(), this.sessionPersistence.properties(), a)).$is_identified = this._isIdentified(), I(this.config.property_denylist) ? Ci(this.config.property_denylist, function(t) {
            delete a[t];
        }) : $i.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var _ = this.config.sanitize_properties;
        _ && ($i.error("sanitize_properties is deprecated. Use before_send instead"), a = _(a, t));
        var m = this.gs();
        return a.$process_person_profile = m, m && !s && this._s("_calculate_event_properties"), a;
    }
    fs(t, i) {
        var e;
        if (void 0 === i && (i = !0), !this.persistence || !this.gs()) return t;
        if (this.Gr) return t;
        var r = this.persistence.get_initial_props(), s = null == (e = this.sessionPropsManager) ? void 0 : e.getSetOnceProps(), n = Ri({}, r, s || {}, t || {}), o = this.config.sanitize_properties;
        return o && ($i.error("sanitize_properties is deprecated. Use before_send instead"), n = o(n, "$set_once")), i && (this.Gr = !0), F(n) ? void 0 : n;
    }
    register(t, i) {
        var e;
        null == (e = this.persistence) || e.register(t, i);
    }
    register_once(t, i, e) {
        var r;
        null == (r = this.persistence) || r.register_once(t, i, e);
    }
    register_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.register(t);
    }
    unregister(t) {
        var i;
        null == (i = this.persistence) || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.unregister(t);
    }
    bs(t, i) {
        this.register({
            [t]: i
        });
    }
    getFeatureFlag(t, i) {
        return this.featureFlags.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        return this.featureFlags.getFeatureFlagPayload(t);
    }
    getFeatureFlagResult(t, i) {
        return this.featureFlags.getFeatureFlagResult(t, i);
    }
    isFeatureEnabled(t, i) {
        return this.featureFlags.isFeatureEnabled(t, i);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateFlags(t, i, e) {
        var r = null != e && e.merge ? this.featureFlags.getFlagVariants() : {}, s = null != e && e.merge ? this.featureFlags.getFlagPayloads() : {}, n = g({}, r, t), o = g({}, s, i), a = {};
        for (var [l, u] of Object.entries(n)){
            var h = "string" == typeof u;
            a[l] = {
                key: l,
                enabled: !!h || Boolean(u),
                variant: h ? u : void 0,
                reason: void 0,
                metadata: O(null == o ? void 0 : o[l]) ? void 0 : {
                    id: 0,
                    version: void 0,
                    description: void 0,
                    payload: o[l]
                }
            };
        }
        this.featureFlags.receivedFeatureFlags({
            flags: a
        });
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(t, i, e);
    }
    getEarlyAccessFeatures(t, i, e) {
        return void 0 === i && (i = !1), this.featureFlags.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this.bi.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags.onFeatureFlags(t);
    }
    onSurveysLoaded(t) {
        return this.surveys.onSurveysLoaded(t);
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null == (e = this.sessionManager) ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getSurveys(t, i);
    }
    getActiveMatchingSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getActiveMatchingSurveys(t, i);
    }
    renderSurvey(t, i) {
        this.surveys.renderSurvey(t, i);
    }
    displaySurvey(t, i) {
        void 0 === i && (i = ao), this.surveys.displaySurvey(t, i);
    }
    cancelPendingSurvey(t) {
        this.surveys.cancelPendingSurvey(t);
    }
    canRenderSurvey(t) {
        return this.surveys.canRenderSurvey(t);
    }
    canRenderSurveyAsync(t, i) {
        return void 0 === i && (i = !1), this.surveys.canRenderSurveyAsync(t, i);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $i.uninitializedWarning("posthog.identify");
        if (L(t) && (t = t.toString(), $i.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(t.toLowerCase())) $i.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
            else if (t !== be) {
                if (this._s("posthog.identify")) {
                    var r = this.get_distinct_id();
                    if (this.register({
                        $user_id: t
                    }), !this.get_property("$device_id")) {
                        var s = r;
                        this.register_once({
                            $had_persisted_distinct_id: !0,
                            $device_id: s
                        }, "");
                    }
                    t !== r && t !== this.get_property(Bi) && (this.unregister(Bi), this.register({
                        distinct_id: t
                    }));
                    var n = "anonymous" === (this.persistence.get_property(de) || "anonymous");
                    t !== r && n ? (this.persistence.set_property(de, "identified"), this.setPersonPropertiesForFlags(g({}, e || {}, i || {}), !1), this.capture("$identify", {
                        distinct_id: t,
                        $anon_distinct_id: r
                    }, {
                        $set: i || {},
                        $set_once: e || {}
                    }), this.Yr = pn(t, i, e), this.featureFlags.setAnonymousDistinctId(r)) : (i || e) && this.setPersonProperties(i, e), t !== r && (this.reloadFeatureFlags(), this.unregister(ue));
                }
            } else $i.critical('The string "' + be + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.');
        } else $i.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(t, i) {
        if ((t || i) && this._s("posthog.setPersonProperties")) {
            var e = pn(this.get_distinct_id(), t, i);
            this.Yr !== e ? (this.setPersonPropertiesForFlags(g({}, i || {}, t || {})), this.capture("$set", {
                $set: t || {},
                $set_once: i || {}
            }), this.Yr = e) : $i.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, i, e) {
        if (t && i) {
            var r = this.getGroups();
            r[t] !== i && this.resetGroupPropertiesForFlags(t), this.register({
                $groups: g({}, r, {
                    [t]: i
                })
            }), e && (this.capture("$groupidentify", {
                $group_type: t,
                $group_key: i,
                $group_set: e
            }), this.setGroupPropertiesForFlags({
                [t]: e
            })), r[t] === i || e || this.reloadFeatureFlags();
        } else $i.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.featureFlags.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this._s("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, i);
    }
    resetGroupPropertiesForFlags(t) {
        this.featureFlags.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var i, e, r, s;
        if ($i.info("reset"), !this.__loaded) return $i.uninitializedWarning("posthog.reset");
        var n = this.get_property("$device_id");
        if (this.consent.reset(), null == (i = this.persistence) || i.clear(), null == (e = this.sessionPersistence) || e.clear(), this.surveys.reset(), this.featureFlags.reset(), null == (r = this.persistence) || r.set_property(de, "anonymous"), null == (s = this.sessionManager) || s.resetSessionId(), this.Yr = null, "always" === this.config.cookieless_mode) this.register_once({
            distinct_id: be,
            $device_id: null
        }, "");
        else {
            var o = this.config.get_device_id(wr());
            this.register_once({
                distinct_id: o,
                $device_id: t ? o : n
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1);
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null == (i = this.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + i);
        if (null != t && t.withTimestamp && e) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!e) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, i) {
        return t === this.get_property(Hi) ? ($i.critical("Attempting to create alias for existing People user - aborting."), -2) : this._s("posthog.alias") ? (O(i) && (i = this.get_distinct_id()), t !== i ? (this.bs(Bi, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($i.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var i = g({}, this.config);
        if (R(t)) {
            var e, r, s, n, o, a, l, u;
            Ri(this.config, Xo(t));
            var h = this.ts();
            null == (e = this.persistence) || e.update_config(this.config, i, h), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new zn(g({}, this.config, {
                persistence: "sessionStorage"
            }), h);
            var d = this.Xr(this.config.debug);
            U(d) && (this.config.debug = d), U(this.config.debug) && (this.config.debug ? (c.DEBUG = !0, Tr.H() && Tr.G("ph_debug", "true"), $i.info("set_config", {
                config: t,
                oldConfig: i,
                newConfig: g({}, this.config)
            })) : (c.DEBUG = !1, Tr.H() && Tr.V("ph_debug"))), null == (r = this.exceptionObserver) || r.onConfigChange(), null == (s = this.sessionRecording) || s.startIfEnabledOrStop(), null == (n = this.autocapture) || n.startIfEnabled(), null == (o = this.heatmaps) || o.startIfEnabled(), null == (a = this.exceptionObserver) || a.startIfEnabledOrStop(), null == (l = this.deadClicksAutocapture) || l.startIfEnabledOrStop(), this.surveys.loadIfEnabled(), this.ys(), null == (u = this.externalIntegrations) || u.startIfEnabledOrStop();
        }
    }
    startSessionRecording(t) {
        var i = !0 === t, e = {
            sampling: i || !(null == t || !t.sampling),
            linked_flag: i || !(null == t || !t.linked_flag),
            url_trigger: i || !(null == t || !t.url_trigger),
            event_trigger: i || !(null == t || !t.event_trigger)
        };
        if (Object.values(e).some(Boolean)) {
            var r, s, n, o, a;
            if (null == (r = this.sessionManager) || r.checkAndGetSessionAndWindowId(), e.sampling) null == (s = this.sessionRecording) || s.overrideSampling();
            if (e.linked_flag) null == (n = this.sessionRecording) || n.overrideLinkedFlag();
            if (e.url_trigger) null == (o = this.sessionRecording) || o.overrideTrigger("url");
            if (e.event_trigger) null == (a = this.sessionRecording) || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, i) {
        var e = new Error("PostHog syntheticException"), r = this.exceptions.buildProperties(t, {
            handled: !0,
            syntheticException: e
        });
        return this.exceptions.sendExceptionEvent(g({}, r, i));
    }
    startExceptionAutocapture(t) {
        this.set_config({
            capture_exceptions: null == t || t
        });
    }
    stopExceptionAutocapture() {
        this.set_config({
            capture_exceptions: !1
        });
    }
    loadToolbar(t) {
        return this.toolbar.loadToolbar(t);
    }
    get_property(t) {
        var i;
        return null == (i = this.persistence) ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null == (i = this.sessionPersistence) ? void 0 : i.props[t];
    }
    toString() {
        var t, i = null !== (t = this.config.name) && void 0 !== t ? t : Jo;
        return i !== Jo && (i = Jo + "." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null == (t = this.persistence) ? void 0 : t.get_property(de)) || "identified" === (null == (i = this.sessionPersistence) ? void 0 : i.get_property(de));
    }
    gs() {
        var t, i;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && F(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[Bi]) && (null == (i = this.persistence) || null == (i = i.props) || !i[_e]));
    }
    cs() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.gs() || this._s("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    setInternalOrTestUser() {
        this._s("posthog.setInternalOrTestUser") && this.setPersonProperties({
            $internal_or_test_user: !0
        });
    }
    _s(t) {
        return "never" === this.config.person_profiles ? ($i.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.bs(_e, !0), !0);
    }
    ts() {
        if ("always" === this.config.cookieless_mode) return !0;
        var t = this.consent.isOptedOut(), i = this.config.opt_out_persistence_by_default || "on_reject" === this.config.cookieless_mode;
        return this.config.disable_persistence || t && !!i;
    }
    ys() {
        var t, i, e, r, s = this.ts();
        (null == (t = this.persistence) ? void 0 : t.Pi) !== s && (null == (e = this.persistence) || e.set_disabled(s));
        (null == (i = this.sessionPersistence) ? void 0 : i.Pi) !== s && (null == (r = this.sessionPersistence) || r.set_disabled(s));
        return s;
    }
    opt_in_capturing(t) {
        var i;
        if ("always" !== this.config.cookieless_mode) {
            var e, r, s;
            if ("on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) this.reset(!0), null == (e = this.sessionManager) || e.destroy(), null == (r = this.pageViewManager) || r.destroy(), this.sessionManager = new Co(this), this.pageViewManager = new Es(this), this.persistence && (this.sessionPropsManager = new To(this, this.sessionManager, this.persistence)), this.sessionRecording = new Wo(this), this.sessionRecording.startIfEnabledOrStop();
            if (this.consent.optInOut(!0), this.ys(), this.ds(), null == (i = this.sessionRecording) || i.startIfEnabledOrStop(), "on_reject" == this.config.cookieless_mode && this.surveys.loadIfEnabled(), O(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) this.capture(null !== (s = null == t ? void 0 : t.captureEventName) && void 0 !== s ? s : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            });
            this.config.capture_pageview && this.vs();
        } else $i.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    opt_out_capturing() {
        var t, i, e;
        "always" !== this.config.cookieless_mode ? ("on_reject" === this.config.cookieless_mode && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this.ys(), "on_reject" === this.config.cookieless_mode && (this.register({
            distinct_id: be,
            $device_id: null
        }), null == (t = this.sessionManager) || t.destroy(), null == (i = this.pageViewManager) || i.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, null == (e = this.sessionRecording) || e.stopRecording(), this.sessionRecording = void 0, this.vs())) : $i.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        var t = this.consent.consent;
        return t === Mr.GRANTED ? "granted" : t === Mr.DENIED ? "denied" : "pending";
    }
    is_capturing() {
        return "always" === this.config.cookieless_mode || ("on_reject" === this.config.cookieless_mode ? this.consent.isExplicitlyOptedOut() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.ys();
    }
    _is_bot() {
        return n ? Mo(n, this.config.custom_blocked_useragents) : void 0;
    }
    vs() {
        o && ("visible" === o.visibilityState ? this.Vr || (this.Vr = !0, this.capture("$pageview", {
            title: o.title
        }, {
            send_instantly: !0
        }), this.Jr && (o.removeEventListener("visibilitychange", this.Jr), this.Jr = null)) : this.Jr || (this.Jr = this.vs.bind(this), zi(o, "visibilitychange", this.Jr)));
    }
    debug(i) {
        !1 === i ? (null == t || t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == t || t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    M() {
        var t, i, e, r, s, n, o, a = this.Qr || {};
        return "advanced_disable_flags" in a ? !!a.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($i.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (e = "advanced_disable_decide", r = !1, s = $i, n = (i = "advanced_disable_flags") in (t = a) && !D(t[i]), o = e in t && !D(t[e]), n ? t[i] : o ? (s && s.warn("Config field '" + e + "' is deprecated. Please use '" + i + "' instead. The old field will be removed in a future major version."), t[e]) : r);
    }
    ps(t) {
        if (D(this.config.before_send)) return t;
        var i = I(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], e = t;
        for (var r of i){
            if (e = r(e), D(e)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return H(t.event) ? $i.warn(s + ". This can cause unexpected behavior.") : $i.info(s), null;
            }
            e.properties && !F(e.properties) || $i.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return e;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.Kt) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
    Xr(t) {
        var i = U(t) && !t, e = Tr.H() && "true" === Tr.q("ph_debug");
        return !i && (!!e || t);
    }
}
!function(t, i) {
    for(var e = 0; e < i.length; e++)t.prototype[i[e]] = Ai(t.prototype[i[e]]);
}(Zo, [
    "identify"
]);
var ta, ia = {
    backgroundColor: "#ffffff",
    textColor: "#1d1f27",
    buttonColor: "#1d1f27",
    borderRadius: 8,
    buttonBorderRadius: 6,
    borderColor: "#e5e7eb",
    fontFamily: "system-ui",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    showOverlay: !0,
    whiteLabel: !1,
    dismissOnClickOutside: !0,
    zIndex: 2147483646
}, ea = (ta = Go[Jo] = new Zo, function() {
    function i() {
        i.done || (i.done = !0, Ko = !1, Ci(Go, function(t) {
            t._dom_loaded();
        }));
    }
    null != o && o.addEventListener ? "complete" === o.readyState ? i() : zi(o, "DOMContentLoaded", i, {
        capture: !1
    }) : t && $i.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), ta);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["7XKBa"], "7XKBa", "parcelRequirec425", {})

//# sourceMappingURL=plans.146f7a2d.js.map
